var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntroductionImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 367.89 343.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-25,.cls-294,.cls-3,.cls-347,.cls-352,.cls-371,.cls-379{opacity:0.5;}.cls-218,.cls-293,.cls-296,.cls-3,.cls-302,.cls-308,.cls-348{mix-blend-mode:multiply;}.cls-219,.cls-220,.cls-221,.cls-222,.cls-223,.cls-224,.cls-225,.cls-226,.cls-227,.cls-228,.cls-35,.cls-372,.cls-373,.cls-374,.cls-375,.cls-376,.cls-377,.cls-378,.cls-379,.cls-380,.cls-381,.cls-382,.cls-383,.cls-384,.cls-385,.cls-386,.cls-4{fill:#afb6e5;}.cls-355,.cls-4{opacity:0;}.cls-5{fill:#a7adda;opacity:0.02;}.cls-355,.cls-6{fill:#9ea5cf;}.cls-53,.cls-6{opacity:0.05;}.cls-7{fill:#969cc4;opacity:0.07;}.cls-8{fill:#8e93b9;}.cls-54,.cls-8{opacity:0.1;}.cls-9{fill:#858bae;opacity:0.12;}.cls-10{fill:#7d82a4;}.cls-10,.cls-55{opacity:0.14;}.cls-11{fill:#757999;opacity:0.17;}.cls-12{fill:#6c718e;}.cls-12,.cls-56{opacity:0.19;}.cls-13{fill:#646883;opacity:0.21;}.cls-14{fill:#5c5f78;}.cls-14,.cls-57{opacity:0.24;}.cls-15{fill:#53576d;opacity:0.26;}.cls-16{fill:#4b4e62;}.cls-16,.cls-58{opacity:0.29;}.cls-17{fill:#434557;opacity:0.31;}.cls-18{fill:#3a3d4c;}.cls-18,.cls-59{opacity:0.33;}.cls-19{fill:#323441;opacity:0.36;}.cls-20{fill:#2a2b37;}.cls-20,.cls-60{opacity:0.38;}.cls-21{fill:#21232c;opacity:0.4;}.cls-22{fill:#191a21;}.cls-22,.cls-61{opacity:0.43;}.cls-23{fill:#111116;opacity:0.45;}.cls-24{fill:#08090b;}.cls-24,.cls-62{opacity:0.48;}.cls-26{fill:url(#linear-gradient);}.cls-27{fill:url(#linear-gradient-2);}.cls-28,.cls-31,.cls-34,.cls-353,.cls-354,.cls-43,.cls-47,.cls-51{mix-blend-mode:color-dodge;}.cls-28{fill:url(#Radial_Gradient_1);}.cls-29{fill:url(#linear-gradient-3);}.cls-30{fill:url(#linear-gradient-4);}.cls-31{fill:url(#Radial_Gradient_1-2);}.cls-32{fill:url(#linear-gradient-5);}.cls-33{fill:url(#linear-gradient-6);}.cls-34{fill:url(#Radial_Gradient_1-3);}.cls-36{fill:url(#linear-gradient-7);}.cls-290,.cls-37,.cls-40,.cls-44,.cls-48{opacity:0.95;}.cls-37{fill:url(#linear-gradient-8);}.cls-347,.cls-351,.cls-352,.cls-38,.cls-39{mix-blend-mode:screen;}.cls-38{fill:url(#radial-gradient);}.cls-39{fill:url(#radial-gradient-2);}.cls-40{fill:url(#linear-gradient-9);}.cls-41{fill:url(#linear-gradient-10);}.cls-42{fill:url(#linear-gradient-11);}.cls-43{fill:url(#Radial_Gradient_1-4);}.cls-44{fill:url(#linear-gradient-12);}.cls-45{fill:url(#linear-gradient-13);}.cls-46{fill:url(#linear-gradient-14);}.cls-47{fill:url(#Radial_Gradient_1-5);}.cls-48{fill:url(#linear-gradient-15);}.cls-49{fill:url(#linear-gradient-16);}.cls-50{fill:url(#linear-gradient-17);}.cls-51{fill:url(#Radial_Gradient_1-6);}.cls-52{opacity:0.2;}.cls-53{fill:#abb2e2;}.cls-54{fill:#a7addf;}.cls-55{fill:#a3a9dc;}.cls-56{fill:#9fa4d8;}.cls-57{fill:#9ba0d5;}.cls-58{fill:#979bd2;}.cls-59{fill:#9397cf;}.cls-60{fill:#8f92cc;}.cls-61{fill:#8b8ec9;}.cls-62{fill:#8789c6;}.cls-63{fill:#8385c2;opacity:0.52;}.cls-64{fill:#7f80bf;opacity:0.57;}.cls-65{fill:#7b7cbc;opacity:0.62;}.cls-66{fill:#7777b9;opacity:0.67;}.cls-67{fill:#7373b6;opacity:0.71;}.cls-68{fill:#6f6eb3;opacity:0.76;}.cls-69{fill:#6b6ab0;opacity:0.81;}.cls-70{fill:#6765ac;opacity:0.86;}.cls-71{fill:#6361a9;opacity:0.9;}.cls-72{fill:#5f5ca6;opacity:0.95;}.cls-73{fill:#5b58a3;}.cls-74{fill:url(#linear-gradient-18);}.cls-75{fill:url(#linear-gradient-19);}.cls-76{fill:url(#linear-gradient-20);}.cls-77{fill:url(#linear-gradient-21);}.cls-78{fill:url(#linear-gradient-22);}.cls-79{fill:url(#linear-gradient-23);}.cls-80{fill:url(#linear-gradient-24);}.cls-81{fill:url(#linear-gradient-25);}.cls-82{fill:url(#linear-gradient-26);}.cls-83{fill:url(#linear-gradient-27);}.cls-84{fill:url(#linear-gradient-28);}.cls-85{fill:url(#linear-gradient-29);}.cls-86{fill:url(#linear-gradient-30);}.cls-87{fill:url(#linear-gradient-31);}.cls-88{fill:url(#linear-gradient-32);}.cls-89{fill:url(#linear-gradient-33);}.cls-90{fill:url(#linear-gradient-34);}.cls-91{fill:url(#linear-gradient-35);}.cls-92{fill:url(#linear-gradient-36);}.cls-93{fill:url(#linear-gradient-37);}.cls-94{fill:url(#linear-gradient-38);}.cls-95{fill:url(#linear-gradient-39);}.cls-96{fill:url(#linear-gradient-40);}.cls-97{fill:url(#linear-gradient-41);}.cls-98{fill:#fff;}.cls-99{fill:url(#linear-gradient-42);}.cls-100{fill:url(#linear-gradient-43);}.cls-101{fill:url(#linear-gradient-44);}.cls-102{fill:url(#linear-gradient-45);}.cls-103{fill:url(#linear-gradient-46);}.cls-104{fill:url(#linear-gradient-47);}.cls-105{fill:url(#linear-gradient-48);}.cls-106{fill:url(#linear-gradient-49);}.cls-107{fill:url(#linear-gradient-50);}.cls-108{fill:url(#linear-gradient-51);}.cls-109{fill:url(#linear-gradient-52);}.cls-110{fill:url(#linear-gradient-53);}.cls-111{fill:url(#linear-gradient-54);}.cls-112{fill:url(#linear-gradient-55);}.cls-113{fill:url(#linear-gradient-56);}.cls-114{fill:url(#linear-gradient-57);}.cls-115{fill:url(#linear-gradient-58);}.cls-116{fill:url(#linear-gradient-59);}.cls-117{fill:url(#linear-gradient-60);}.cls-118{fill:url(#linear-gradient-61);}.cls-119{fill:url(#linear-gradient-62);}.cls-120{fill:url(#linear-gradient-63);}.cls-121{fill:url(#linear-gradient-64);}.cls-122{fill:url(#linear-gradient-65);}.cls-123{fill:url(#linear-gradient-66);}.cls-124{fill:url(#linear-gradient-67);}.cls-125{fill:url(#linear-gradient-68);}.cls-126{fill:url(#linear-gradient-69);}.cls-127{fill:url(#linear-gradient-70);}.cls-128{fill:url(#linear-gradient-71);}.cls-129{fill:url(#linear-gradient-72);}.cls-130{fill:url(#linear-gradient-73);}.cls-131{fill:url(#linear-gradient-74);}.cls-132{fill:url(#linear-gradient-75);}.cls-133{fill:url(#linear-gradient-76);}.cls-134{fill:url(#linear-gradient-77);}.cls-135{fill:url(#linear-gradient-78);}.cls-136{fill:url(#linear-gradient-79);}.cls-137{fill:url(#linear-gradient-80);}.cls-138{fill:url(#linear-gradient-81);}.cls-139{fill:url(#linear-gradient-82);}.cls-140{fill:url(#linear-gradient-83);}.cls-141{fill:url(#linear-gradient-84);}.cls-142{fill:url(#linear-gradient-85);}.cls-143{fill:url(#linear-gradient-86);}.cls-144{fill:url(#linear-gradient-87);}.cls-145{fill:url(#linear-gradient-88);}.cls-146{fill:url(#linear-gradient-89);}.cls-147{fill:url(#linear-gradient-90);}.cls-148{fill:url(#linear-gradient-91);}.cls-149{fill:url(#linear-gradient-92);}.cls-150{fill:url(#linear-gradient-93);}.cls-151{fill:url(#linear-gradient-94);}.cls-152{fill:url(#linear-gradient-95);}.cls-153{fill:url(#linear-gradient-96);}.cls-154{fill:url(#linear-gradient-97);}.cls-155{fill:url(#linear-gradient-98);}.cls-156{fill:url(#linear-gradient-99);}.cls-157{fill:url(#linear-gradient-100);}.cls-158{fill:url(#linear-gradient-101);}.cls-159{fill:url(#linear-gradient-102);}.cls-160{fill:url(#linear-gradient-103);}.cls-161{fill:url(#linear-gradient-104);}.cls-162{fill:url(#linear-gradient-105);}.cls-163{fill:url(#linear-gradient-106);}.cls-164{fill:url(#linear-gradient-107);}.cls-165{fill:url(#linear-gradient-108);}.cls-166{fill:url(#linear-gradient-109);}.cls-167{fill:url(#linear-gradient-110);}.cls-168{fill:url(#linear-gradient-111);}.cls-169{fill:url(#linear-gradient-112);}.cls-170{fill:url(#linear-gradient-113);}.cls-171{fill:url(#linear-gradient-114);}.cls-172{fill:url(#linear-gradient-115);}.cls-173{fill:url(#linear-gradient-116);}.cls-174{fill:url(#linear-gradient-117);}.cls-175{fill:url(#linear-gradient-118);}.cls-176{fill:url(#linear-gradient-119);}.cls-177{fill:url(#linear-gradient-120);}.cls-178{fill:url(#linear-gradient-121);}.cls-179{fill:url(#linear-gradient-122);}.cls-180{fill:url(#linear-gradient-123);}.cls-181{fill:url(#linear-gradient-124);}.cls-182{fill:url(#linear-gradient-125);}.cls-183{fill:url(#linear-gradient-126);}.cls-184{fill:url(#linear-gradient-127);}.cls-185{fill:url(#linear-gradient-128);}.cls-186{fill:url(#linear-gradient-129);}.cls-187{fill:url(#linear-gradient-130);}.cls-188{fill:url(#linear-gradient-131);}.cls-189{fill:url(#linear-gradient-132);}.cls-190{fill:url(#linear-gradient-133);}.cls-191{fill:url(#linear-gradient-134);}.cls-192{fill:url(#linear-gradient-135);}.cls-193{fill:url(#linear-gradient-136);}.cls-194{fill:url(#linear-gradient-137);}.cls-195{fill:url(#linear-gradient-138);}.cls-196{fill:url(#linear-gradient-139);}.cls-197{fill:url(#linear-gradient-140);}.cls-198{fill:url(#linear-gradient-141);}.cls-199{fill:url(#linear-gradient-142);}.cls-200{fill:url(#linear-gradient-143);}.cls-201{fill:url(#linear-gradient-144);}.cls-202{fill:url(#linear-gradient-145);}.cls-203{fill:url(#linear-gradient-146);}.cls-204{fill:url(#linear-gradient-147);}.cls-205{fill:url(#linear-gradient-148);}.cls-206{fill:url(#linear-gradient-149);}.cls-207{fill:url(#linear-gradient-150);}.cls-208{fill:url(#linear-gradient-151);}.cls-209{fill:url(#linear-gradient-152);}.cls-210{fill:url(#linear-gradient-153);}.cls-211{fill:url(#linear-gradient-154);}.cls-212{fill:url(#linear-gradient-155);}.cls-213{fill:url(#linear-gradient-156);}.cls-214{fill:url(#linear-gradient-157);}.cls-215{fill:url(#linear-gradient-158);}.cls-216{fill:url(#linear-gradient-159);}.cls-217{fill:url(#linear-gradient-160);}.cls-219{opacity:0.09;}.cls-220{opacity:0.18;}.cls-221{opacity:0.27;}.cls-222{opacity:0.36;}.cls-223{opacity:0.45;}.cls-224{opacity:0.55;}.cls-225{opacity:0.64;}.cls-226{opacity:0.73;}.cls-227{opacity:0.82;}.cls-228{opacity:0.91;}.cls-229{fill:url(#linear-gradient-161);}.cls-230{fill:url(#linear-gradient-162);}.cls-231{fill:url(#linear-gradient-163);}.cls-232{fill:url(#linear-gradient-164);}.cls-233{fill:url(#linear-gradient-165);}.cls-234{fill:url(#linear-gradient-166);}.cls-235{fill:url(#linear-gradient-167);}.cls-236{fill:url(#linear-gradient-168);}.cls-237{fill:url(#linear-gradient-169);}.cls-238{fill:url(#linear-gradient-170);}.cls-239{fill:url(#linear-gradient-171);}.cls-240{fill:url(#linear-gradient-172);}.cls-241{fill:url(#linear-gradient-173);}.cls-242{fill:url(#linear-gradient-174);}.cls-243{fill:url(#linear-gradient-175);}.cls-244{fill:url(#linear-gradient-176);}.cls-245{fill:url(#linear-gradient-177);}.cls-246{fill:url(#linear-gradient-178);}.cls-247{fill:url(#linear-gradient-179);}.cls-248{fill:url(#linear-gradient-180);}.cls-249{fill:url(#linear-gradient-181);}.cls-250{fill:url(#linear-gradient-182);}.cls-251{fill:url(#linear-gradient-183);}.cls-252{fill:url(#linear-gradient-184);}.cls-253{fill:url(#linear-gradient-185);}.cls-254{fill:url(#linear-gradient-186);}.cls-255{fill:url(#linear-gradient-187);}.cls-256{fill:#5277f7;}.cls-257{fill:url(#linear-gradient-188);}.cls-258{fill:url(#linear-gradient-189);}.cls-259{fill:url(#linear-gradient-190);}.cls-260{fill:url(#linear-gradient-191);}.cls-261{fill:url(#linear-gradient-192);}.cls-262{fill:url(#linear-gradient-193);}.cls-263{fill:url(#linear-gradient-194);}.cls-264{fill:url(#linear-gradient-195);}.cls-265{fill:url(#linear-gradient-196);}.cls-266{fill:url(#linear-gradient-197);}.cls-267{fill:url(#linear-gradient-198);}.cls-268{fill:url(#linear-gradient-199);}.cls-269{fill:url(#linear-gradient-200);}.cls-270{fill:url(#linear-gradient-201);}.cls-271{fill:url(#linear-gradient-202);}.cls-272{fill:url(#linear-gradient-203);}.cls-273{fill:url(#linear-gradient-204);}.cls-274{fill:url(#linear-gradient-205);}.cls-275{fill:url(#linear-gradient-206);}.cls-276{fill:url(#linear-gradient-207);}.cls-277{fill:url(#linear-gradient-208);}.cls-278{fill:url(#linear-gradient-209);}.cls-279{fill:url(#linear-gradient-210);}.cls-280{fill:url(#linear-gradient-211);}.cls-281{fill:url(#linear-gradient-212);}.cls-282{fill:url(#linear-gradient-213);}.cls-283{fill:url(#linear-gradient-214);}.cls-284{fill:url(#linear-gradient-215);}.cls-285{fill:url(#linear-gradient-216);}.cls-286{fill:url(#linear-gradient-217);}.cls-287{fill:#8d97d6;}.cls-288{fill:url(#linear-gradient-218);}.cls-289{fill:url(#linear-gradient-219);}.cls-290{fill:url(#linear-gradient-220);}.cls-291{fill:url(#linear-gradient-221);}.cls-292{fill:#afd3e5;}.cls-293{fill:url(#radial-gradient-3);}.cls-295{fill:url(#linear-gradient-222);}.cls-296{fill:#ced3f4;}.cls-297{fill:#4e0070;}.cls-298{fill:url(#linear-gradient-223);}.cls-299{fill:url(#linear-gradient-224);}.cls-300{fill:url(#linear-gradient-225);}.cls-301{fill:#ffd4c0;}.cls-302{fill:#f1d5be;}.cls-303{fill:url(#New_Gradient_Swatch_copy_36);}.cls-304{fill:#2d3259;}.cls-305{fill:#858fd6;}.cls-306{fill:#e5e9ff;}.cls-307{fill:url(#linear-gradient-226);}.cls-308{fill:#d1d3d4;}.cls-309{fill:url(#linear-gradient-227);}.cls-310{fill:#35004d;}.cls-311{fill:url(#linear-gradient-228);}.cls-312{fill:url(#linear-gradient-229);}.cls-313{fill:url(#linear-gradient-230);}.cls-314{fill:url(#linear-gradient-231);}.cls-315{fill:url(#linear-gradient-232);}.cls-316{fill:url(#linear-gradient-233);}.cls-317{fill:url(#New_Gradient_Swatch_copy_36-2);}.cls-318{clip-path:url(#clip-path);}.cls-319{fill:url(#linear-gradient-234);}.cls-320{fill:url(#linear-gradient-235);}.cls-321{fill:url(#linear-gradient-236);}.cls-322{fill:url(#linear-gradient-237);}.cls-323{fill:url(#linear-gradient-238);}.cls-324{fill:url(#linear-gradient-239);}.cls-325{fill:url(#linear-gradient-240);}.cls-326{fill:url(#linear-gradient-241);}.cls-327{fill:url(#linear-gradient-242);}.cls-328{fill:url(#linear-gradient-243);}.cls-329{fill:url(#linear-gradient-244);}.cls-330{fill:url(#linear-gradient-245);}.cls-331{fill:url(#linear-gradient-246);}.cls-332{fill:url(#linear-gradient-247);}.cls-333{fill:url(#linear-gradient-248);}.cls-334{fill:url(#linear-gradient-249);}.cls-335{fill:url(#linear-gradient-250);}.cls-336{fill:url(#linear-gradient-251);}.cls-337{fill:url(#linear-gradient-252);}.cls-338{fill:url(#linear-gradient-253);}.cls-339{fill:url(#linear-gradient-254);}.cls-340{fill:url(#linear-gradient-255);}.cls-341{fill:url(#linear-gradient-256);}.cls-342{fill:url(#linear-gradient-257);}.cls-343{fill:#9144c9;}.cls-344{fill:url(#linear-gradient-258);}.cls-345{fill:url(#linear-gradient-259);}.cls-346{fill:url(#linear-gradient-260);}.cls-347{fill:url(#radial-gradient-4);}.cls-348{fill:url(#radial-gradient-5);}.cls-349{fill:url(#linear-gradient-261);}.cls-350{fill:url(#linear-gradient-262);}.cls-351{fill:url(#Radial_Gradient_1-7);}.cls-352{fill:url(#White_Black_Radial);}.cls-353{fill:url(#radial-gradient-6);}.cls-354{fill:url(#radial-gradient-7);}.cls-356{fill:#9fa6d0;opacity:0.03;}.cls-357{fill:#9fa6d1;}.cls-357,.cls-372{opacity:0.06;}.cls-358{fill:#a0a7d1;opacity:0.09;}.cls-359{fill:#a1a8d2;}.cls-359,.cls-373{opacity:0.13;}.cls-360{fill:#a1a8d3;opacity:0.16;}.cls-361{fill:#a2a9d3;}.cls-361,.cls-374{opacity:0.19;}.cls-362{fill:#a2a9d4;opacity:0.22;}.cls-363{fill:#a3aad5;}.cls-363,.cls-375{opacity:0.25;}.cls-364{fill:#a4abd6;opacity:0.28;}.cls-365{fill:#a4abd7;}.cls-365,.cls-376{opacity:0.31;}.cls-366{fill:#a5acd7;opacity:0.34;}.cls-367{fill:#a6acd8;}.cls-367,.cls-377{opacity:0.38;}.cls-368{fill:#a6add9;opacity:0.41;}.cls-369,.cls-370{fill:#a7aeda;}.cls-369,.cls-378{opacity:0.44;}.cls-370{opacity:0.47;}.cls-371{fill:#a8afdb;}.cls-380{opacity:0.56;}.cls-381{opacity:0.63;}.cls-382{opacity:0.69;}.cls-383{opacity:0.75;}.cls-384{opacity:0.81;}.cls-385{opacity:0.88;}.cls-386{opacity:0.94;}.cls-387{fill:url(#linear-gradient-263);}.cls-388{fill:url(#linear-gradient-264);}.cls-389{fill:url(#linear-gradient-265);}.cls-390{fill:url(#linear-gradient-266);}.cls-391{fill:url(#linear-gradient-267);}.cls-392{fill:url(#linear-gradient-268);}.cls-393{fill:url(#linear-gradient-269);}.cls-394{fill:url(#linear-gradient-270);}.cls-395{fill:url(#linear-gradient-271);}.cls-396{fill:url(#linear-gradient-272);}.cls-397{fill:url(#linear-gradient-273);}.cls-398{fill:url(#linear-gradient-274);}.cls-399{fill:url(#linear-gradient-275);}.cls-400{fill:url(#linear-gradient-276);}.cls-401{fill:url(#linear-gradient-277);}.cls-402{fill:url(#linear-gradient-278);}.cls-403{fill:url(#linear-gradient-279);}.cls-404{fill:url(#linear-gradient-280);}.cls-405{fill:url(#linear-gradient-281);}.cls-406{fill:url(#linear-gradient-282);}.cls-407{fill:#8036b5;}.cls-408{fill:url(#linear-gradient-283);}.cls-409{fill:url(#linear-gradient-284);}.cls-410{fill:url(#linear-gradient-285);}.cls-411{fill:url(#New_Gradient_Swatch_copy_36-3);}.cls-412{fill:url(#linear-gradient-286);}.cls-413{fill:url(#linear-gradient-287);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 21.24,
    y1: 230.68,
    x2: 209.51,
    y2: 230.68,
    gradientTransform: "matrix(1, -0.01, 0, 1, 0, 48.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bfc5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c5cbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d1d6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d1d6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 139.22,
    y1: 163.96,
    x2: 102.69,
    y2: 258.25,
    gradientTransform: "matrix(1, -0.01, 0, 1, 0, 48.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b6bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c8cdf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f5f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    cx: 115.37,
    cy: 233.96,
    r: 74.48,
    gradientTransform: "matrix(1, -0.01, 0, 1, 0, 48.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 95.14,
    y1: 189.15,
    x2: 283.42,
    y2: 189.15,
    gradientTransform: "matrix(1, -0.01, 0, 1, 0, 48.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7bee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#bac1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c5cbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#d7dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d1d6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 213.13,
    y1: 122.43,
    x2: 176.6,
    y2: 216.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-2",
    cx: 189.28,
    cy: 192.42,
    r: 74.48,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 169.05,
    y1: 148.06,
    x2: 357.32,
    y2: 148.06,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 287.04,
    y1: 81.34,
    x2: 250.51,
    y2: 175.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-3",
    cx: 263.18,
    cy: 151.34,
    r: 74.48,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 170.16,
    y1: 138.52,
    x2: 235.64,
    y2: 265.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 123.55,
    y1: 237.69,
    x2: 322.95,
    y2: 237.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2be9a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#07cdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00c7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#09c7ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#21c9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#48cbee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#6cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5277f7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 157.83,
    cy: 264.51,
    r: 27.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#836df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#6655bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4b3e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#342b60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#211c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#130f23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#08070f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 240.85,
    cy: 217.95,
    r: 17.33,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 59.02,
    y1: 180.93,
    x2: 247.3,
    y2: 180.93,
    gradientTransform: "matrix(1, -0.01, 0, 1, 0, 48.41)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 95.14,
    y1: 179.26,
    x2: 283.42,
    y2: 179.26,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 213.13,
    y1: 112.54,
    x2: 176.6,
    y2: 206.84,
    gradientTransform: "matrix(1, -0.01, 0, 1, 0, 48.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f5f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-4",
    cx: 189.28,
    cy: 182.54,
    r: 74.48,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 132.93,
    y1: 139.85,
    x2: 321.2,
    y2: 139.85,
    gradientTransform: "matrix(1, -0.01, 0, 1, 0, 48.41)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 169.05,
    y1: 138.18,
    x2: 357.32,
    y2: 138.18,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 287.04,
    y1: 71.46,
    x2: 250.51,
    y2: 165.75,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-5",
    cx: 263.18,
    cy: 141.46,
    r: 74.48,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -14.88,
    y1: 222.46,
    x2: 173.39,
    y2: 222.46,
    gradientTransform: "matrix(1, -0.01, 0, 1, 0, 48.41)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 21.24,
    y1: 220.8,
    x2: 209.51,
    y2: 220.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 139.22,
    y1: 154.08,
    x2: 102.69,
    y2: 248.37,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-6",
    cx: 115.37,
    cy: 224.08,
    r: 74.48,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 74.74,
    y1: 72.23,
    x2: 408.26,
    y2: 145.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -3005.66,
    y1: 11.34,
    x2: -2862.07,
    y2: 227.26,
    gradientTransform: "translate(3195.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#273b98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2f2ba2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361cac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440b89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 229.29,
    y1: -18.61,
    x2: 346.4,
    y2: 216.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3bae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b7bde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bac0e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3bae7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 229.24,
    y1: -18.57,
    x2: 346.35,
    y2: 216.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4bbe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b9beea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bcc2ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b2b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b2b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b3b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4bbe8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 229.19,
    y1: -18.53,
    x2: 346.29,
    y2: 216.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bdc3eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b4bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b4bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b7bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bce8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 229.14,
    y1: -18.48,
    x2: 346.23,
    y2: 216.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7bde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bcc1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bfc5ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b7bde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b7bde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#bac0e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7bde9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 229.09,
    y1: -18.44,
    x2: 346.17,
    y2: 216.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8bfe9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bdc3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c1c6ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b9c0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b9c0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#bec4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8bfe9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 229.04,
    y1: -18.4,
    x2: 346.11,
    y2: 216.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9c0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bfc4ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c2c8ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#bcc2eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#bcc2eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c2c7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9c0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 228.98,
    y1: -18.35,
    x2: 346.05,
    y2: 216.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c0c6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c4c9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#bec4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#bec5ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c6cbec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b2b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bac1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bac1ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 228.93,
    y1: -18.31,
    x2: 346,
    y2: 216.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc2eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c2c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c6cbef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c1c7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c1c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#caceee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#b6bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcc2eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 228.88,
    y1: -18.27,
    x2: 345.94,
    y2: 216.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdc3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c4c9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c7cdf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c3c9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c4c9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#cdd2ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b9c0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdc3ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 228.83,
    y1: -18.22,
    x2: 345.88,
    y2: 216.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5caef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c9cef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c6cbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c6ccf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d0d4f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d1d5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#bdc3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec4ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 228.78,
    y1: -18.18,
    x2: 345.82,
    y2: 216.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfc5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c7ccf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#cbd0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c8cef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c9cef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3d7f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d5d9f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c1c7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfc5ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 228.73,
    y1: -18.14,
    x2: 345.76,
    y2: 216.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1c7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c8cdf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ccd1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#cbd0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#cbd1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d5d9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d9dcf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c5caec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c7ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 228.68,
    y1: -18.1,
    x2: 345.7,
    y2: 216.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c8ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#cacff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ced3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#cdd3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#ced3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d8dcf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#dde0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c9ceee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c8ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 228.63,
    y1: -18.05,
    x2: 345.65,
    y2: 216.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#cbd0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d0d4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d0d5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d0d6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dadef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e1e3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#cdd1ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c9ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 228.58,
    y1: -18.01,
    x2: 345.59,
    y2: 216.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4caef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#cdd2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d1d6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d2d7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d3d8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dde1f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e4e7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#d0d5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4caef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 228.52,
    y1: -17.97,
    x2: 345.53,
    y2: 216.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6cbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#cfd3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d3d8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d5daf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d6daf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0e3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e8eaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#d4d8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6cbf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 228.47,
    y1: -17.92,
    x2: 345.47,
    y2: 216.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7ccf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d0d5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d5d9f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d7dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d8ddf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e2e6f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#eceef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#d8dcf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7ccf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 228.42,
    y1: -17.88,
    x2: 345.41,
    y2: 216.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8cdf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d2d6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d6dbf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#dadef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#dbdffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e5e8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f0f1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#dcdff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cdf1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 228.37,
    y1: -17.84,
    x2: 345.36,
    y2: 216.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9cff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d3d8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d8dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#dce1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#dde2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e7eafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f4f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0e3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9cff1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 228.32,
    y1: -17.79,
    x2: 345.3,
    y2: 216.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbd0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d5d9f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#dadef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#dfe3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e0e4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#eaedfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f7f8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e3e6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#b1b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbd0f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 228.27,
    y1: -17.75,
    x2: 345.24,
    y2: 216.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccd1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d6dbf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#dbdffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e1e6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e2e7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#eceffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fbfcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e7eaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b5bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd1f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 228.22,
    y1: -17.71,
    x2: 345.18,
    y2: 216.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdd2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#eff2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ebedf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b9bfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdd2f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 234.78,
    y1: 116.99,
    x2: 190.84,
    y2: 13.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bb6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#976df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#836df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7a6ff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#6274f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5277f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 240.97,
    y1: 112.03,
    x2: 197.03,
    y2: 8.12,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 247.85,
    y1: 119.52,
    x2: 203.91,
    y2: 15.61,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 254.04,
    y1: 114.56,
    x2: 210.1,
    y2: 10.65,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 261.63,
    y1: 128.57,
    x2: 217.68,
    y2: 24.65,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 268.91,
    y1: 124.45,
    x2: 224.97,
    y2: 20.53,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 230.06,
    y1: 118.99,
    x2: 186.12,
    y2: 15.08,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 237.05,
    y1: 113.69,
    x2: 193.1,
    y2: 9.78,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 243.53,
    y1: 121.35,
    x2: 199.59,
    y2: 17.43,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 249.72,
    y1: 116.39,
    x2: 205.78,
    y2: 12.47,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 243.53,
    y1: 183.53,
    x2: 199.59,
    y2: 79.61,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 249.72,
    y1: 178.57,
    x2: 205.78,
    y2: 74.66,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 257.7,
    y1: 130.23,
    x2: 213.76,
    y2: 26.31,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 264.19,
    y1: 126.44,
    x2: 220.25,
    y2: 22.53,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 226.14,
    y1: 120.65,
    x2: 182.2,
    y2: 16.73,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 232.33,
    y1: 115.69,
    x2: 188.39,
    y2: 11.78,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 239.21,
    y1: 123.17,
    x2: 195.26,
    y2: 19.26,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 245.79,
    y1: 118.05,
    x2: 201.85,
    y2: 14.13,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 252.98,
    y1: 132.22,
    x2: 209.04,
    y2: 28.31,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 260.27,
    y1: 128.1,
    x2: 216.33,
    y2: 24.19,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 206.17,
    y1: 85.47,
    x2: 162.23,
    y2: -18.44,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 215.78,
    y1: 88.59,
    x2: 171.84,
    y2: -15.32,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 234.89,
    y1: 125,
    x2: 190.94,
    y2: 21.09,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 241.08,
    y1: 120.04,
    x2: 197.13,
    y2: 16.13,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 248.66,
    y1: 134.05,
    x2: 204.72,
    y2: 30.14,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 255.95,
    y1: 129.93,
    x2: 212.01,
    y2: 26.01,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 217.1,
    y1: 124.47,
    x2: 173.16,
    y2: 20.56,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 224.08,
    y1: 119.18,
    x2: 180.14,
    y2: 15.26,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 217.1,
    y1: 152.24,
    x2: 173.16,
    y2: 48.33,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 224.08,
    y1: 146.95,
    x2: 180.14,
    y2: 43.04,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 230.57,
    y1: 126.83,
    x2: 186.62,
    y2: 22.91,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 236.76,
    y1: 121.87,
    x2: 192.81,
    y2: 17.95,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 244.74,
    y1: 135.71,
    x2: 200.8,
    y2: 31.8,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 251.23,
    y1: 131.92,
    x2: 207.29,
    y2: 28.01,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 244.74,
    y1: 71.73,
    x2: 200.8,
    y2: -32.18,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 251.23,
    y1: 67.94,
    x2: 207.29,
    y2: -35.97,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 213.18,
    y1: 126.13,
    x2: 169.23,
    y2: 22.22,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 219.37,
    y1: 121.17,
    x2: 175.43,
    y2: 17.26,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 226.24,
    y1: 128.65,
    x2: 182.3,
    y2: 24.74,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 232.83,
    y1: 123.53,
    x2: 188.89,
    y2: 19.61,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 240.02,
    y1: 137.7,
    x2: 196.08,
    y2: 33.79,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 247.31,
    y1: 133.58,
    x2: 203.36,
    y2: 29.67,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 338.69,
    y1: 169.38,
    x2: 294.74,
    y2: 65.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4f759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#90f36c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#35ea9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2be9a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#07cdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00c7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#09beca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#21a7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#4881f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5277f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#836df3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 344.71,
    y1: 172.6,
    x2: 300.77,
    y2: 68.69,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 334.76,
    y1: 171.04,
    x2: 290.82,
    y2: 67.13,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 340,
    y1: 174.6,
    x2: 296.06,
    y2: 70.69,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 334.76,
    y1: 244.57,
    x2: 290.82,
    y2: 140.65,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 340,
    y1: 248.13,
    x2: 296.06,
    y2: 144.21,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 330.04,
    y1: 173.04,
    x2: 286.1,
    y2: 69.12,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 336.07,
    y1: 176.26,
    x2: 292.13,
    y2: 72.35,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 325.72,
    y1: 174.86,
    x2: 281.78,
    y2: 70.95,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 331.75,
    y1: 178.09,
    x2: 287.81,
    y2: 74.17,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 321.8,
    y1: 176.52,
    x2: 277.86,
    y2: 72.61,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 327.03,
    y1: 180.08,
    x2: 283.09,
    y2: 76.17,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 321.8,
    y1: 114.5,
    x2: 277.86,
    y2: 10.59,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 327.03,
    y1: 118.06,
    x2: 283.09,
    y2: 14.15,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 317.08,
    y1: 178.52,
    x2: 273.14,
    y2: 74.6,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 323.11,
    y1: 181.74,
    x2: 279.17,
    y2: 77.83,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 291.95,
    y1: 165.47,
    x2: 251.05,
    y2: 70.68,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 299.14,
    y1: 160.31,
    x2: 258.24,
    y2: 65.52,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 305.99,
    y1: 152.74,
    x2: 265.09,
    y2: 57.94,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 312.15,
    y1: 143.02,
    x2: 271.25,
    y2: 48.22,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 320.05,
    y1: 162.83,
    x2: 279.14,
    y2: 68.04,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 327.31,
    y1: 157.03,
    x2: 286.41,
    y2: 62.24,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 287.97,
    y1: 167.19,
    x2: 247.06,
    y2: 72.4,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 294.37,
    y1: 162.37,
    x2: 253.47,
    y2: 67.58,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 287.97,
    y1: 140.34,
    x2: 247.06,
    y2: 45.54,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 294.37,
    y1: 135.52,
    x2: 253.47,
    y2: 40.72,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 301.61,
    y1: 154.63,
    x2: 260.71,
    y2: 59.83,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 308.16,
    y1: 144.74,
    x2: 267.26,
    y2: 49.94,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 299.29,
    y1: 211.72,
    x2: 258.39,
    y2: 116.93,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 301.49,
    y1: 191.73,
    x2: 260.59,
    y2: 96.94,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 315.27,
    y1: 163.91,
    x2: 274.37,
    y2: 69.12,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 323.32,
    y1: 158.75,
    x2: 282.42,
    y2: 63.96,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 283.58,
    y1: 169.08,
    x2: 242.68,
    y2: 74.29,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 289.99,
    y1: 164.26,
    x2: 249.09,
    y2: 69.47,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 297.23,
    y1: 156.52,
    x2: 256.32,
    y2: 61.72,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 303.39,
    y1: 146.8,
    x2: 262.49,
    y2: 52,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 310.89,
    y1: 165.8,
    x2: 269.99,
    y2: 71.01,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 318.94,
    y1: 160.64,
    x2: 278.04,
    y2: 65.85,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 278.81,
    y1: 171.14,
    x2: 237.91,
    y2: 76.35,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 286,
    y1: 165.98,
    x2: 245.1,
    y2: 71.19,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 286,
    y1: 215.2,
    x2: 245.1,
    y2: 120.41,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 292.84,
    y1: 158.41,
    x2: 251.94,
    y2: 63.61,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 299.01,
    y1: 148.69,
    x2: 258.11,
    y2: 53.89,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 306.9,
    y1: 168.5,
    x2: 266,
    y2: 73.71,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 314.17,
    y1: 162.7,
    x2: 273.26,
    y2: 67.91,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 306.9,
    y1: 218.88,
    x2: 266,
    y2: 124.09,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 314.17,
    y1: 213.08,
    x2: 273.26,
    y2: 118.28,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 274.82,
    y1: 172.86,
    x2: 233.92,
    y2: 78.07,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 281.23,
    y1: 168.04,
    x2: 240.33,
    y2: 73.25,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 288.46,
    y1: 160.3,
    x2: 247.56,
    y2: 65.5,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 295.02,
    y1: 150.41,
    x2: 254.11,
    y2: 55.62,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 302.13,
    y1: 169.58,
    x2: 261.23,
    y2: 74.79,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 310.18,
    y1: 164.42,
    x2: 269.27,
    y2: 69.63,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 270.05,
    y1: 174.92,
    x2: 229.14,
    y2: 80.13,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 276.85,
    y1: 169.93,
    x2: 235.94,
    y2: 75.14,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 284.08,
    y1: 162.19,
    x2: 243.18,
    y2: 67.39,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 290.24,
    y1: 152.47,
    x2: 249.34,
    y2: 57.68,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 296.17,
    y1: 205.02,
    x2: 255.27,
    y2: 110.23,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 291.4,
    y1: 219.52,
    x2: 250.49,
    y2: 124.73,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 297.75,
    y1: 171.47,
    x2: 256.85,
    y2: 76.68,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 305.79,
    y1: 166.31,
    x2: 264.89,
    y2: 71.52,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 243.53,
    y1: 195.94,
    x2: 199.59,
    y2: 92.02,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 249.72,
    y1: 190.98,
    x2: 205.78,
    y2: 87.06,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 217.1,
    y1: 164.65,
    x2: 173.16,
    y2: 60.74,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 224.08,
    y1: 159.36,
    x2: 180.14,
    y2: 55.44,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 240.02,
    y1: 150.11,
    x2: 196.08,
    y2: 46.2,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 247.31,
    y1: 145.99,
    x2: 203.36,
    y2: 42.08,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 317.08,
    y1: 190.92,
    x2: 273.14,
    y2: 87.01,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 323.11,
    y1: 194.15,
    x2: 279.17,
    y2: 90.23,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 301.61,
    y1: 229.49,
    x2: 260.71,
    y2: 134.7,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 308.16,
    y1: 219.6,
    x2: 267.26,
    y2: 124.81,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 270.05,
    y1: 187.33,
    x2: 229.15,
    y2: 92.54,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 276.85,
    y1: 182.34,
    x2: 235.94,
    y2: 87.55,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 297.75,
    y1: 183.88,
    x2: 256.85,
    y2: 89.09,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 305.79,
    y1: 178.72,
    x2: 264.89,
    y2: 83.93,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 302.13,
    y1: 107.18,
    x2: 261.23,
    y2: 12.39,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 310.18,
    y1: 102.02,
    x2: 269.27,
    y2: 7.23,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: -1.26,
    y1: 113.56,
    x2: 332.26,
    y2: 186.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -3081.66,
    y1: 52.67,
    x2: -2938.07,
    y2: 268.59,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 153.29,
    y1: 22.72,
    x2: 270.4,
    y2: 257.35,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 153.24,
    y1: 22.76,
    x2: 270.35,
    y2: 257.38,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 153.19,
    y1: 22.81,
    x2: 270.29,
    y2: 257.41,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 153.14,
    y1: 22.85,
    x2: 270.23,
    y2: 257.44,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 153.09,
    y1: 22.89,
    x2: 270.17,
    y2: 257.47,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 153.04,
    y1: 22.94,
    x2: 270.11,
    y2: 257.5,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 152.98,
    y1: 22.98,
    x2: 270.05,
    y2: 257.53,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 152.93,
    y1: 23.02,
    x2: 270,
    y2: 257.56,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 152.88,
    y1: 23.07,
    x2: 269.94,
    y2: 257.58,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 152.83,
    y1: 23.11,
    x2: 269.88,
    y2: 257.61,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 152.78,
    y1: 23.15,
    x2: 269.82,
    y2: 257.64,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 152.73,
    y1: 23.2,
    x2: 269.76,
    y2: 257.67,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 152.68,
    y1: 23.24,
    x2: 269.7,
    y2: 257.7,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 152.63,
    y1: 23.28,
    x2: 269.65,
    y2: 257.73,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 152.58,
    y1: 23.32,
    x2: 269.59,
    y2: 257.76,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 152.52,
    y1: 23.37,
    x2: 269.53,
    y2: 257.79,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 152.47,
    y1: 23.41,
    x2: 269.47,
    y2: 257.81,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 152.42,
    y1: 23.45,
    x2: 269.41,
    y2: 257.84,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 152.37,
    y1: 23.5,
    x2: 269.36,
    y2: 257.87,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 152.32,
    y1: 23.54,
    x2: 269.3,
    y2: 257.9,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 152.27,
    y1: 23.58,
    x2: 269.24,
    y2: 257.93,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 152.22,
    y1: 23.62,
    x2: 269.18,
    y2: 257.96,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 130.02,
    y1: 108.86,
    x2: 179.11,
    y2: 108.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b4f759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#90ed6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#35d5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00c7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2d9be0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 130.02,
    y1: 113.49,
    x2: 160.52,
    y2: 113.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#836df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8c6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#a66df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b56df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#bb6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36dd4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 162.89,
    y1: 131.5,
    x2: 190.3,
    y2: 131.5,
    xlinkHref: "#linear-gradient-185"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 137.02,
    y1: 137.15,
    x2: 160.52,
    y2: 137.15,
    xlinkHref: "#linear-gradient-185"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 137.02,
    y1: 127.37,
    x2: 143.78,
    y2: 127.37,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 185.03,
    y1: 167.55,
    x2: 218.85,
    y2: 167.55,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 130.02,
    y1: 156.99,
    x2: 160.52,
    y2: 156.99,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 153.43,
    y1: 172.09,
    x2: 207.62,
    y2: 172.09,
    xlinkHref: "#linear-gradient-185"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 123.15,
    y1: 166.9,
    x2: 143.78,
    y2: 166.9,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: -74.59,
    y1: 156.9,
    x2: 258.92,
    y2: 230.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: -3154.99,
    y1: 96,
    x2: -3011.4,
    y2: 311.92,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 79.96,
    y1: 66.05,
    x2: 197.07,
    y2: 300.69,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 79.91,
    y1: 66.1,
    x2: 197.01,
    y2: 300.72,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 79.86,
    y1: 66.14,
    x2: 196.95,
    y2: 300.74,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 79.81,
    y1: 66.18,
    x2: 196.9,
    y2: 300.77,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 79.75,
    y1: 66.23,
    x2: 196.84,
    y2: 300.8,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 79.7,
    y1: 66.27,
    x2: 196.78,
    y2: 300.83,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 79.65,
    y1: 66.31,
    x2: 196.72,
    y2: 300.86,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 79.6,
    y1: 66.36,
    x2: 196.66,
    y2: 300.89,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 79.55,
    y1: 66.4,
    x2: 196.6,
    y2: 300.92,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 79.5,
    y1: 66.44,
    x2: 196.55,
    y2: 300.95,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 79.45,
    y1: 66.49,
    x2: 196.49,
    y2: 300.98,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 79.4,
    y1: 66.53,
    x2: 196.43,
    y2: 301,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 79.34,
    y1: 66.57,
    x2: 196.37,
    y2: 301.03,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 79.29,
    y1: 66.61,
    x2: 196.31,
    y2: 301.06,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 79.24,
    y1: 66.66,
    x2: 196.25,
    y2: 301.09,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 79.19,
    y1: 66.7,
    x2: 196.2,
    y2: 301.12,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 79.14,
    y1: 66.74,
    x2: 196.14,
    y2: 301.15,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 79.09,
    y1: 66.79,
    x2: 196.08,
    y2: 301.18,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 79.04,
    y1: 66.83,
    x2: 196.02,
    y2: 301.21,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 78.99,
    y1: 66.87,
    x2: 195.96,
    y2: 301.23,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 78.93,
    y1: 66.92,
    x2: 195.91,
    y2: 301.26,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 78.88,
    y1: 66.96,
    x2: 195.85,
    y2: 301.29,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 196.89,
    y1: 261.61,
    x2: 49.43,
    y2: 106.87,
    xlinkHref: "#linear-gradient-185"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 197.66,
    y1: 206.45,
    x2: 43.41,
    y2: 125.95,
    xlinkHref: "#linear-gradient-185"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 239.5,
    y1: 270.16,
    x2: 60.33,
    y2: 134.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#dbee70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b4f759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#90f36c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#35ea9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2be9a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#07cdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00c7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#09beca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#21a7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4881f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 125.87,
    y1: 197.11,
    x2: 89.24,
    y2: 164.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#bb6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ca6dea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f36dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36dd4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 1179.05,
    cy: -2391.05,
    r: 14.81,
    gradientTransform: "translate(-1339.29 1729.29) scale(1.28 0.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 175.4,
    y1: 263.37,
    x2: 162.58,
    y2: 296.1,
    gradientTransform: "translate(4.74 -5.15) rotate(3.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#62bcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5993fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 146.63,
    y1: 331,
    x2: 160.55,
    y2: 294.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 159.26,
    y1: 336.05,
    x2: 173.74,
    y2: 297.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 175.9,
    y1: 272.48,
    x2: 163.09,
    y2: 305.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-222"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36",
    x1: 169.53,
    y1: 270.42,
    x2: 166.81,
    y2: 259.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 184.97,
    y1: 276.03,
    x2: 172.16,
    y2: 308.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-222"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: -4767.17,
    y1: 3849.07,
    x2: -4767.17,
    y2: 3812.15,
    gradientTransform: "translate(6324.27 -618.9) rotate(30.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#42caeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00c7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#09cebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#21e1ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2be9a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 1328.95,
    y1: 513.39,
    x2: 1338.34,
    y2: 513.39,
    gradientTransform: "translate(-1151.59 406.03) rotate(-28.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b3aba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#564bd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6152e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4528c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4221a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#401b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3f1982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5e239e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491c8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 259.22,
    y1: 203.27,
    x2: 256.84,
    y2: 213.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b3aba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3f34bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4528c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#472bcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5a47dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6152e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 1330.79,
    y1: 493.09,
    x2: 1336.35,
    y2: 493.09,
    gradientTransform: "translate(-1151.59 406.03) rotate(-28.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bfea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#dfe3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdc3ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 10298.93,
    y1: 2015.94,
    x2: 10331.72,
    y2: 1994.08,
    gradientTransform: "matrix(-0.96, -0.27, -0.27, 0.96, 10769.3, 1147.82)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 9798.42,
    y1: 302.41,
    x2: 9798.14,
    y2: 261.83,
    gradientTransform: "matrix(-1, 0, 0, 1, 10084.61, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 9805.96,
    y1: 267.97,
    x2: 9808.59,
    y2: 231.57,
    gradientTransform: "matrix(-1, 0, 0, 1, 10084.61, 0)",
    xlinkHref: "#linear-gradient-227"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-2",
    x1: 9501.39,
    y1: -125.07,
    x2: 9510.32,
    y2: -132.44,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 9761.45, -440.59)",
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 237.06,
    cy: 177.05,
    rx: 18.18,
    ry: 31.48,
    transform: "translate(-56.95 143.84) rotate(-30.31)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 217.28,
    y1: 103.16,
    x2: 266.16,
    y2: 254.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0b7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b2b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b3b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0b7e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 217.24,
    y1: 103.18,
    x2: 266.11,
    y2: 254.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b4bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b7bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2b9e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 217.19,
    y1: 103.2,
    x2: 266.06,
    y2: 254.06,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 217.14,
    y1: 103.22,
    x2: 266.01,
    y2: 254.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5bbe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b9c0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bec4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bbe8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 217.09,
    y1: 103.24,
    x2: 265.96,
    y2: 254.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6bde8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bcc2eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c2c7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6bde8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 217.04,
    y1: 103.26,
    x2: 265.91,
    y2: 254.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8bee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bec5ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c6cbec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b2b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8bee9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 217,
    y1: 103.28,
    x2: 265.86,
    y2: 254.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bfea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c1c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#caceee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#b6bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9bfea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 216.95,
    y1: 103.3,
    x2: 265.81,
    y2: 254.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c4c9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#cdd2ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b9c0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bac1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bac1ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 216.9,
    y1: 103.32,
    x2: 265.76,
    y2: 254.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc2eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c6ccf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d0d4f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d1d5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bdc3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcc2eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 216.85,
    y1: 103.34,
    x2: 265.72,
    y2: 254.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdc3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c9cef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d3d7f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d5d9f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c1c7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdc3ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 216.81,
    y1: 103.36,
    x2: 265.67,
    y2: 254.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfc5ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#cbd1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d5d9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d9dcf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c5caec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfc5ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 216.76,
    y1: 103.38,
    x2: 265.62,
    y2: 254.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0c6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ced3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d8dcf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#dde0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c9ceee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c6ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 216.71,
    y1: 103.4,
    x2: 265.57,
    y2: 254.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d0d6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#dadef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e1e3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#cdd1ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c7ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 216.66,
    y1: 103.42,
    x2: 265.52,
    y2: 254.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d3d8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#dde1f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e4e7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#d0d5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c9ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 216.61,
    y1: 103.44,
    x2: 265.47,
    y2: 254.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4caef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d6daf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e0e3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e8eaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#d4d8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4caef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 216.57,
    y1: 103.46,
    x2: 265.42,
    y2: 254.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6cbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d8ddf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e2e6f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#eceef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#d8dcf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6cbf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 216.52,
    y1: 103.48,
    x2: 265.37,
    y2: 254.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7cdf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#dbdffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e5e8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f0f1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#dcdff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7cdf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 216.47,
    y1: 103.5,
    x2: 265.32,
    y2: 254.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9cef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#dde2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e7eafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f4f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e0e3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9cef1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 216.42,
    y1: 103.52,
    x2: 265.27,
    y2: 254.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e0e4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#eaedfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f7f8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e3e6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b1b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 216.38,
    y1: 103.54,
    x2: 265.22,
    y2: 254.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccd1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e2e7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#eceffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fbfcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e7eaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b5bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd1f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 216.33,
    y1: 103.56,
    x2: 265.17,
    y2: 254.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdd2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#eff2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ebedf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b9bfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdd2f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 138.8,
    y1: 220.34,
    x2: 311.16,
    y2: 149.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 185.84,
    y1: 93,
    x2: 276.23,
    y2: 248.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 275.79,
    y1: 175.93,
    x2: 250.99,
    y2: 162.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 230.5,
    y1: 168.97,
    x2: 243.83,
    y2: 191.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#cf6de8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#bb6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#976df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#836df3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 236.02,
    y1: 165.76,
    x2: 249.36,
    y2: 188.76,
    xlinkHref: "#linear-gradient-258"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 217.74,
    y1: 151.85,
    x2: 242.3,
    y2: 208.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9da6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#dfe3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdc3ec"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 232.64,
    cy: 169.33,
    r: 31.99,
    gradientTransform: "translate(121.76 -95.44) rotate(30.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277f7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 232.51,
    cy: 169.57,
    r: 31.99,
    gradientTransform: "translate(121.76 -95.44) rotate(30.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 230.72,
    y1: 144.02,
    x2: 260.53,
    y2: 201.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9da6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#dfe3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdc3ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 215.38,
    y1: 184.5,
    x2: 246.53,
    y2: 174.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b6bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c8cdf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#f5f4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f6fb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-7",
    cx: 246.76,
    cy: 158.66,
    r: 25.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "White_Black_Radial",
    cx: 231.57,
    cy: 164.22,
    r: 17.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 259.78,
    cy: 192.81,
    r: 5.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#273b98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#23368a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#192560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#10183e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#090d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#04060f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#010104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 244.96,
    cy: 155.32,
    r: 5.88,
    gradientTransform: "translate(77.49 -81.5) rotate(22.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#364f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#263860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#19243d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0e1422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#06090f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 5383.4,
    y1: 104.78,
    x2: 5466.76,
    y2: 57.88,
    gradientTransform: "matrix(-1.06, 0, -0.04, 0.95, 5741.1, 155.66)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 982.45,
    y1: -155.08,
    x2: 978.88,
    y2: -148.27,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 998.75,
    y1: -126,
    x2: 1007.36,
    y2: -128.57,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 993.84,
    y1: -141.4,
    x2: 989.44,
    y2: -133.03,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 998.75,
    y1: -111.13,
    x2: 1007.36,
    y2: -113.71,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 993.84,
    y1: -126.54,
    x2: 989.44,
    y2: -118.17,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 998.75,
    y1: -96.21,
    x2: 1007.36,
    y2: -98.79,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 993.84,
    y1: -111.61,
    x2: 989.44,
    y2: -103.25,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 998.75,
    y1: -81.35,
    x2: 1007.36,
    y2: -83.93,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 993.84,
    y1: -96.75,
    x2: 989.44,
    y2: -88.38,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 998.75,
    y1: -66.55,
    x2: 1007.36,
    y2: -69.12,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 993.84,
    y1: -81.95,
    x2: 989.44,
    y2: -73.58,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 998.75,
    y1: -51.68,
    x2: 1007.36,
    y2: -54.26,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 993.84,
    y1: -67.08,
    x2: 989.44,
    y2: -58.72,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 5033.22,
    y1: -132.52,
    x2: 5033.22,
    y2: -164.06,
    gradientTransform: "matrix(-1, 0.07, 0.07, 1, 5075.27, -55.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5277f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7670f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#836df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#8c6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a46df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb6df3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 2981.9,
    y1: 646.92,
    x2: 2986.19,
    y2: 605.68,
    gradientTransform: "translate(-2882.94 -713.99) rotate(5.42)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 2993.39,
    y1: 652.85,
    x2: 2993.05,
    y2: 604.36,
    gradientTransform: "translate(-2882.94 -713.99) rotate(5.42)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 2987.18,
    y1: 610.35,
    x2: 2992.89,
    y2: 577.98,
    gradientTransform: "translate(-2882.94 -713.99) rotate(5.42)",
    xlinkHref: "#linear-gradient-277"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 48.34,
    y1: 153.3,
    x2: 59,
    y2: 153.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 58.73,
    y1: 158.55,
    x2: 70.49,
    y2: 158.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 69.09,
    y1: 131.01,
    x2: 54.09,
    y2: 148.51,
    xlinkHref: "#linear-gradient-221"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 70.17,
    y1: 119.03,
    x2: 42.17,
    y2: 176.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 5659.32,
    y1: 608.99,
    x2: 5659.32,
    y2: 578.3,
    gradientTransform: "matrix(-1, -0.09, -0.09, 1, 5741.78, 103.87)",
    xlinkHref: "#linear-gradient-277"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-3",
    x1: 2994.7,
    y1: 573.23,
    x2: 2991.93,
    y2: 563.45,
    gradientTransform: "translate(-2882.94 -713.99) rotate(5.42)",
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 938.33,
    y1: -51.01,
    x2: 1127.18,
    y2: -157.27,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: 1005.65,
    y1: -143.34,
    x2: 1002.08,
    y2: -136.53,
    gradientTransform: "matrix(1.14, 0.02, -0.34, 0.87, -1123.71, 281.52)",
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0428\\u0430\\u0440_2",
    "data-name": "\\u0428\\u0430\\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.55,336,19.83,247.47c-5.71-3.22-5-9,1.6-12.88l20.81-11.15c6.59-3.89,16.56-4.44,22.26-1.23l151.72,88.5c5.71,3.22,5,9-1.59,12.88l-20.82,11.15C187.22,338.63,177.26,339.18,171.55,336Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.54,335.7,20.24,247.43c-5.66-3.18-4.95-8.9,1.58-12.76l20.43-10.92c6.53-3.86,16.41-4.41,22.06-1.22l151.3,88.27c5.66,3.18,4.95,8.9-1.58,12.76l-20.42,10.92C187.08,338.34,177.2,338.88,171.54,335.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.53,335.43l-150.88-88c-5.61-3.16-4.9-8.82,1.57-12.65l20-10.69c6.47-3.83,16.26-4.37,21.86-1.21l150.88,88c5.61,3.16,4.91,8.82-1.57,12.65l-20,10.69C186.93,338,177.14,338.58,171.53,335.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M171.52,335.15,21.06,247.37c-5.55-3.14-4.86-8.75,1.56-12.54l19.64-10.46c6.42-3.79,16.12-4.33,21.68-1.2L214.4,311c5.55,3.13,4.85,8.74-1.56,12.54L193.19,334C186.78,337.75,177.08,338.28,171.52,335.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M171.51,334.88l-150-87.55c-5.5-3.1-4.81-8.66,1.54-12.42l19.26-10.23c6.36-3.76,16-4.29,21.48-1.19l150,87.55c5.5,3.11,4.81,8.67-1.55,12.43L193,333.7C186.63,337.45,177,338,171.51,334.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M171.5,334.61,21.88,247.3c-5.45-3.08-4.77-8.59,1.53-12.31l18.87-10c6.3-3.73,15.82-4.25,21.28-1.18l149.62,87.31c5.45,3.08,4.77,8.59-1.53,12.31l-18.87,10C186.48,337.16,177,337.69,171.5,334.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M171.49,334.34,22.29,247.26c-5.4-3-4.73-8.5,1.52-12.19l18.47-9.77c6.24-3.69,15.69-4.22,21.09-1.17l149.2,87.08c5.4,3,4.72,8.5-1.52,12.19l-18.47,9.77C186.33,336.86,176.89,337.39,171.49,334.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M171.48,334.07,22.7,247.23c-5.35-3-4.68-8.43,1.5-12.09l18.09-9.54c6.18-3.65,15.54-4.17,20.89-1.15L212,311.29c5.35,3,4.68,8.43-1.5,12.08l-18.09,9.54C186.19,336.57,176.83,337.09,171.48,334.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M171.46,333.8,23.11,247.2c-5.3-3-4.64-8.36,1.49-12l17.7-9.31c6.12-3.62,15.39-4.13,20.7-1.14l148.35,86.6c5.3,3,4.64,8.35-1.49,12l-17.69,9.31C186,336.27,176.77,336.79,171.46,333.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M171.45,333.52,23.52,247.16c-5.25-3-4.59-8.27,1.48-11.86l17.3-9.08c6.07-3.58,15.25-4.09,20.51-1.13l147.93,86.36c5.25,3,4.59,8.28-1.48,11.86L192,332.39C185.89,336,176.71,336.49,171.45,333.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M171.44,333.25,23.93,247.13c-5.2-2.94-4.55-8.2,1.46-11.75l16.92-8.85c6-3.55,15.1-4.05,20.31-1.12l147.51,86.13c5.2,2.93,4.55,8.19-1.46,11.74l-16.92,8.85C185.74,335.68,176.65,336.19,171.44,333.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M171.43,333,24.35,247.09c-5.16-2.9-4.51-8.11,1.44-11.63l16.53-8.62c6-3.52,15-4,20.11-1.11l147.09,85.89c5.15,2.9,4.51,8.11-1.45,11.63l-16.52,8.62C185.59,335.39,176.59,335.89,171.43,333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M171.42,332.71,24.76,247.06c-5.11-2.88-4.47-8,1.43-11.52l16.13-8.39c5.9-3.49,14.82-4,19.92-1.1L208.91,311.7c5.1,2.88,4.46,8-1.43,11.52l-16.14,8.39C185.45,335.09,176.53,335.59,171.42,332.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M171.41,332.44,25.17,247c-5.06-2.85-4.43-8,1.41-11.41l15.75-8.16c5.84-3.45,14.67-3.94,19.73-1.09L208.3,311.78c5.06,2.85,4.42,8-1.42,11.41l-15.74,8.16C185.3,334.8,176.46,335.29,171.41,332.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M171.4,332.17,25.58,247c-5-2.82-4.38-7.88,1.4-11.3l15.36-7.92c5.78-3.42,14.52-3.9,19.53-1.08l145.82,85.17c5,2.83,4.38,7.88-1.4,11.3l-15.36,7.93C185.15,334.51,176.4,335,171.4,332.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M171.39,331.89,26,247c-5-2.8-4.34-7.8,1.39-11.19l15-7.69c5.73-3.39,14.38-3.86,19.34-1.07L207.08,312c5,2.79,4.33,7.8-1.39,11.18l-15,7.7C185,334.21,176.34,334.69,171.39,331.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M171.38,331.62l-145-84.7c-4.91-2.76-4.29-7.72,1.37-11.07l14.58-7.46c5.66-3.35,14.24-3.83,19.14-1.06l145,84.7c4.91,2.76,4.29,7.72-1.37,11.07l-14.58,7.47C184.85,333.92,176.28,334.39,171.38,331.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M171.36,331.35,26.81,246.89c-4.86-2.74-4.25-7.64,1.36-11l14.19-7.23c5.6-3.32,14.09-3.79,18.94-1l144.56,84.46c4.86,2.74,4.25,7.65-1.36,11l-14.19,7.24C184.7,333.62,176.22,334.09,171.36,331.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M171.35,331.08,27.22,246.86c-4.81-2.71-4.21-7.57,1.35-10.85l13.79-7c5.55-3.28,14-3.74,18.76-1l144.13,84.22c4.81,2.71,4.2,7.57-1.35,10.85l-13.79,7C184.56,333.33,176.16,333.79,171.35,331.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M171.34,330.81l-143.71-84c-4.76-2.68-4.16-7.48,1.33-10.73l13.41-6.78c5.49-3.24,13.8-3.7,18.56-1l143.71,84c4.76,2.68,4.16,7.48-1.33,10.73l-13.41,6.77C184.41,333,176.1,333.49,171.34,330.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M171.33,330.54,28,246.79c-4.71-2.66-4.12-7.41,1.32-10.62l13-6.55c5.44-3.21,13.66-3.66,18.37-1L204,312.36c4.71,2.65,4.12,7.41-1.32,10.62l-13,6.54C184.26,332.74,176,333.19,171.33,330.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M171.32,330.27,28.45,246.75c-4.66-2.62-4.07-7.33,1.3-10.5l12.63-6.32c5.38-3.18,13.51-3.63,18.17-1l142.87,83.51c4.66,2.63,4.07,7.33-1.3,10.51l-12.63,6.31C184.11,332.44,176,332.89,171.32,330.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M209.51,309.72h-1.08a7.8,7.8,0,0,0-2.28-1.88l-145.59-85c-5-2.81-13.68-2.33-19.43,1.07L26,231.68a11.78,11.78,0,0,0-3.48,3l-1.27,0v8.07h0c.16,1.67,1.25,3.23,3.33,4.4l145.58,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c2.73-1.61,4.29-3.59,4.66-5.53h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M170.18,324.92l-145.58-85c-5-2.81-4.36-7.84,1.39-11.24l15.14-7.8c5.75-3.4,14.45-3.88,19.43-1.07l145.59,85c5,2.81,4.35,7.84-1.4,11.24l-15.14,7.8C183.86,327.25,175.16,327.73,170.18,324.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M204.75,315.18,189.61,323c-5.75,3.4-14.45,3.88-19.43,1.07L24.6,239a6,6,0,0,1-3.31-4.21c-.3,2.08.77,4.08,3.31,5.51l145.58,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c3.44-2,5-4.65,4.7-7C209.15,311.45,207.57,313.51,204.75,315.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M245.46,293.42,93.74,204.91c-5.71-3.21-5-9,1.6-12.87l20.81-11.15c6.59-3.9,16.55-4.45,22.26-1.23l151.72,88.5c5.71,3.22,5,9-1.6,12.87l-20.81,11.16C261.13,296.08,251.17,296.63,245.46,293.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245.45,293.14,94.15,204.88c-5.66-3.19-5-8.9,1.58-12.76l20.43-10.92c6.53-3.86,16.41-4.41,22.06-1.22l151.3,88.26c5.66,3.19,5,8.9-1.58,12.76l-20.43,10.93C261,295.79,251.11,296.33,245.45,293.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.44,292.87l-150.88-88c-5.61-3.16-4.9-8.83,1.57-12.65l20-10.69c6.48-3.83,16.27-4.37,21.87-1.21l150.88,88c5.61,3.16,4.91,8.83-1.57,12.65l-20,10.69C260.84,295.49,251,296,245.44,292.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.43,292.6,95,204.81c-5.56-3.13-4.86-8.74,1.56-12.53l19.64-10.46c6.42-3.8,16.12-4.33,21.68-1.2L288.3,268.41c5.56,3.13,4.86,8.74-1.55,12.53L267.1,291.4C260.69,295.2,251,295.73,245.43,292.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.42,292.33l-150-87.55c-5.51-3.1-4.82-8.67,1.54-12.42l19.26-10.24c6.35-3.75,16-4.28,21.48-1.18l150,87.55c5.51,3.1,4.82,8.66-1.54,12.42L266.9,291.14C260.54,294.9,250.92,295.43,245.42,292.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M245.41,292.06,95.79,204.74c-5.46-3.07-4.77-8.58,1.53-12.31l18.86-10c6.3-3.72,15.83-4.25,21.29-1.17l149.61,87.31c5.46,3.08,4.78,8.59-1.52,12.31l-18.87,10C260.39,294.61,250.86,295.13,245.41,292.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M245.39,291.79,96.2,204.71c-5.4-3.05-4.73-8.51,1.52-12.2l18.47-9.77c6.24-3.69,15.69-4.21,21.09-1.16l149.19,87.07c5.41,3.05,4.73,8.51-1.51,12.2l-18.48,9.77C260.24,294.31,250.8,294.83,245.39,291.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M245.38,291.51,96.61,204.68c-5.35-3-4.68-8.43,1.5-12.09l18.09-9.54c6.18-3.65,15.54-4.17,20.89-1.15l148.77,86.84c5.36,3,4.69,8.42-1.5,12.08l-18.08,9.54C260.09,294,250.74,294.53,245.38,291.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M245.37,291.24,97,204.64c-5.3-3-4.64-8.35,1.49-12l17.69-9.31c6.13-3.62,15.4-4.13,20.7-1.14l148.36,86.6c5.3,3,4.64,8.35-1.49,12l-17.7,9.31C260,293.72,250.68,294.23,245.37,291.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M245.36,291,97.43,204.61c-5.25-3-4.59-8.27,1.47-11.86l17.31-9.08c6.07-3.59,15.25-4.09,20.51-1.13L284.65,268.9c5.25,3,4.59,8.27-1.48,11.86l-17.3,9.08C259.8,293.43,250.62,293.93,245.36,291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M245.35,290.7,97.84,204.57c-5.2-2.93-4.55-8.19,1.46-11.74L116.22,184c6-3.55,15.1-4.06,20.31-1.12L284,269c5.2,2.94,4.55,8.2-1.46,11.75l-16.92,8.85C259.65,293.13,250.56,293.63,245.35,290.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M245.34,290.43,98.25,204.54c-5.15-2.91-4.51-8.11,1.45-11.63l16.52-8.62c6-3.52,15-4,20.12-1.11l147.09,85.88c5.15,2.91,4.51,8.12-1.45,11.64l-16.52,8.62C259.5,292.84,250.5,293.33,245.34,290.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M245.33,290.16,98.66,204.51c-5.1-2.88-4.46-8,1.43-11.53l16.14-8.38c5.9-3.49,14.82-4,19.92-1.1l146.67,85.65c5.1,2.87,4.46,8-1.43,11.52l-16.14,8.39C259.35,292.54,250.43,293,245.33,290.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M245.32,289.88,99.07,204.47c-5-2.85-4.42-8,1.42-11.41l15.75-8.15c5.84-3.46,14.67-3.94,19.72-1.09l146.25,85.41c5.05,2.85,4.42,8-1.42,11.41L265,288.8C259.21,292.25,250.37,292.73,245.32,289.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M245.31,289.61,99.49,204.44c-5-2.82-4.38-7.88,1.4-11.3l15.35-7.92c5.78-3.42,14.53-3.9,19.54-1.08L281.6,269.31c5,2.82,4.38,7.88-1.41,11.3l-15.35,7.92C259.06,292,250.31,292.43,245.31,289.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M245.29,289.34,99.9,204.4c-5-2.79-4.34-7.8,1.38-11.18l15-7.7c5.72-3.38,14.38-3.86,19.34-1.06L281,269.39c4.95,2.8,4.33,7.8-1.39,11.19l-15,7.69C258.91,291.66,250.25,292.13,245.29,289.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M245.28,289.07l-145-84.7c-4.91-2.77-4.3-7.72,1.37-11.07l14.58-7.47c5.66-3.35,14.23-3.82,19.14-1.05l145,84.7c4.9,2.76,4.29,7.72-1.38,11.07L264.43,288C258.76,291.36,250.19,291.84,245.28,289.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M245.27,288.8,100.72,204.34c-4.86-2.74-4.25-7.65,1.36-11l14.18-7.24c5.61-3.31,14.1-3.78,19-1l144.56,84.46c4.86,2.74,4.25,7.64-1.36,11l-14.19,7.23C258.61,291.07,250.13,291.54,245.27,288.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M245.26,288.53,101.13,204.3c-4.81-2.71-4.21-7.56,1.34-10.84l13.8-7c5.55-3.28,14-3.74,18.75-1l144.14,84.22c4.81,2.71,4.2,7.57-1.35,10.85l-13.79,7C258.46,290.77,250.07,291.24,245.26,288.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M245.25,288.26l-143.71-84c-4.76-2.68-4.16-7.49,1.33-10.74l13.41-6.77c5.49-3.25,13.8-3.71,18.56-1l143.71,84c4.76,2.68,4.16,7.49-1.33,10.74l-13.41,6.77C258.32,290.48,250,290.94,245.25,288.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M245.24,288,102,204.23c-4.71-2.65-4.12-7.4,1.32-10.62l13-6.54c5.44-3.21,13.66-3.67,18.37-1L277.94,269.8c4.71,2.66,4.12,7.41-1.32,10.63l-13,6.54C258.17,290.18,250,290.64,245.24,288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M245.23,287.71,102.36,204.2c-4.66-2.62-4.07-7.33,1.3-10.51l12.63-6.31c5.38-3.18,13.51-3.63,18.17-1l142.87,83.51c4.66,2.62,4.07,7.33-1.31,10.51l-12.62,6.31C258,289.89,249.89,290.34,245.23,287.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M283.42,267.17h-1.09a7.55,7.55,0,0,0-2.28-1.88L134.47,180.25c-5-2.8-13.68-2.32-19.43,1.08L99.9,189.12a12,12,0,0,0-3.48,3l-1.28,0v8.07h0c.16,1.66,1.25,3.22,3.33,4.39l145.58,85c5,2.8,13.68,2.32,19.43-1.07l15.14-7.8c2.73-1.62,4.29-3.6,4.66-5.53h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M244.09,282.37,98.51,197.32c-5-2.8-4.36-7.83,1.39-11.23l15.14-7.8c5.75-3.4,14.45-3.88,19.43-1.07l145.58,85c5,2.81,4.36,7.84-1.39,11.24l-15.14,7.79C257.77,284.69,249.07,285.17,244.09,282.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M278.66,272.63l-15.14,7.8c-5.75,3.39-14.45,3.87-19.43,1.07L98.51,196.45a5.93,5.93,0,0,1-3.31-4.2c-.3,2.07.77,4.08,3.31,5.51l145.58,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c3.44-2,5-4.65,4.7-7C283.06,268.9,281.48,271,278.66,272.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.37,251.31l-151.72-88.5c-5.71-3.22-5-9,1.59-12.87l20.82-11.16c6.59-3.89,16.55-4.44,22.26-1.23L364,226.05c5.71,3.22,5,9-1.6,12.88l-20.81,11.15C335,254,325.07,254.53,319.37,251.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M319.36,251l-151.3-88.27c-5.66-3.18-4.95-8.9,1.58-12.76l20.43-10.92c6.53-3.86,16.4-4.4,22.06-1.22l151.3,88.27c5.66,3.18,4.95,8.9-1.58,12.76l-20.43,10.92C334.89,253.68,325,254.23,319.36,251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.35,250.77l-150.88-88c-5.61-3.16-4.91-8.82,1.57-12.65l20-10.69c6.47-3.83,16.27-4.37,21.87-1.21l150.88,88c5.61,3.16,4.9,8.82-1.57,12.65l-20,10.69C334.74,253.39,325,253.93,319.35,250.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M319.34,250.5,168.88,162.71c-5.56-3.13-4.86-8.75,1.55-12.54l19.65-10.46c6.41-3.79,16.12-4.33,21.67-1.2L362.21,226.3c5.56,3.13,4.86,8.74-1.55,12.54L341,249.3C334.6,253.09,324.89,253.63,319.34,250.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M319.33,250.22l-150-87.55c-5.51-3.1-4.82-8.66,1.54-12.42L190.09,140c6.35-3.76,16-4.29,21.48-1.19l150,87.55c5.51,3.11,4.82,8.67-1.54,12.43L340.8,249C334.45,252.8,324.83,253.33,319.33,250.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M319.31,250,169.7,162.64c-5.46-3.08-4.77-8.59,1.53-12.31l18.86-10c6.3-3.73,15.83-4.25,21.29-1.18L361,226.47c5.46,3.07,4.77,8.58-1.53,12.31l-18.86,10C334.3,252.5,324.77,253,319.31,250Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M319.3,249.68,170.11,162.6c-5.41-3-4.73-8.5,1.51-12.19l18.48-9.77c6.24-3.69,15.68-4.21,21.09-1.17l149.19,87.08c5.41,3,4.73,8.51-1.51,12.2l-18.48,9.77C334.15,252.21,324.71,252.73,319.3,249.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M319.29,249.41,170.52,162.57c-5.36-3-4.68-8.43,1.5-12.08L190.11,141c6.18-3.66,15.54-4.18,20.89-1.16l148.77,86.84c5.36,3,4.69,8.43-1.5,12.09l-18.08,9.53C334,251.91,324.65,252.43,319.29,249.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M319.28,249.14l-148.35-86.6c-5.31-3-4.64-8.35,1.49-12l17.69-9.3c6.13-3.63,15.4-4.14,20.7-1.15l148.35,86.6c5.31,3,4.64,8.35-1.48,12L340,248C333.85,251.62,324.59,252.13,319.28,249.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M319.27,248.87,171.34,162.5c-5.26-3-4.6-8.27,1.47-11.86l17.31-9.08c6.07-3.58,15.25-4.09,20.51-1.13l147.92,86.36c5.26,3,4.6,8.28-1.47,11.86l-17.3,9.08C333.71,251.32,324.53,251.83,319.27,248.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M319.26,248.59,171.75,162.47c-5.2-2.94-4.55-8.19,1.46-11.75l16.92-8.85c6-3.55,15.1-4.05,20.31-1.12l147.5,86.13c5.21,2.93,4.56,8.19-1.45,11.74l-16.92,8.85C333.56,251,324.46,251.53,319.26,248.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M319.25,248.32,172.16,162.43c-5.15-2.9-4.51-8.11,1.45-11.63l16.52-8.62c6-3.52,15-4,20.12-1.11L357.33,227c5.16,2.91,4.51,8.11-1.44,11.63l-16.53,8.62C333.41,250.73,324.4,251.23,319.25,248.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M319.24,248.05,172.57,162.4c-5.1-2.88-4.46-8,1.43-11.52l16.14-8.39c5.9-3.48,14.81-4,19.92-1.1L356.73,227c5.1,2.88,4.46,8-1.44,11.52L339.16,247C333.26,250.44,324.34,250.93,319.24,248.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.23,247.78,173,162.37c-5-2.85-4.42-8,1.42-11.41l15.75-8.16c5.83-3.45,14.67-3.94,19.72-1.09l146.25,85.41c5.05,2.85,4.42,8-1.42,11.41L339,246.69C333.11,250.14,324.28,250.63,319.23,247.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M319.21,247.51,173.39,162.33c-5-2.82-4.38-7.88,1.41-11.29l15.35-7.93c5.78-3.42,14.53-3.9,19.53-1.08l145.83,85.18c5,2.82,4.37,7.88-1.41,11.29l-15.35,7.93C333,249.85,324.22,250.33,319.21,247.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M319.2,247.24,173.8,162.3c-5-2.79-4.33-7.8,1.39-11.19l15-7.69c5.72-3.38,14.38-3.86,19.34-1.07l145.4,84.94c5,2.79,4.33,7.8-1.39,11.18l-15,7.7C332.82,249.55,324.16,250,319.2,247.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M319.19,247l-145-84.7c-4.9-2.76-4.29-7.72,1.38-11.07l14.58-7.46c5.66-3.35,14.23-3.82,19.14-1.06l145,84.7c4.9,2.77,4.29,7.72-1.38,11.07l-14.57,7.47C332.67,249.26,324.1,249.73,319.19,247Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M319.18,246.69,174.62,162.23c-4.85-2.74-4.24-7.64,1.37-11L190.17,144c5.61-3.32,14.09-3.79,19-1l144.56,84.46c4.85,2.74,4.24,7.65-1.36,11l-14.19,7.24C332.52,249,324,249.43,319.18,246.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.17,246.42,175,162.2c-4.81-2.71-4.21-7.57,1.34-10.85l13.8-7c5.55-3.28,13.95-3.75,18.75-1l144.14,84.22c4.8,2.71,4.2,7.57-1.35,10.85l-13.8,7C332.37,248.67,324,249.13,319.17,246.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M319.16,246.15l-143.71-84c-4.76-2.68-4.16-7.48,1.33-10.73l13.41-6.77c5.49-3.25,13.8-3.71,18.55-1l143.72,84c4.75,2.68,4.16,7.48-1.34,10.73l-13.4,6.77C332.23,248.37,323.92,248.83,319.16,246.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M319.15,245.88,175.86,162.13c-4.71-2.65-4.12-7.41,1.32-10.62l13-6.55c5.44-3.21,13.66-3.66,18.37-1L351.85,227.7c4.7,2.65,4.11,7.41-1.32,10.62l-13,6.54C332.08,248.08,323.85,248.53,319.15,245.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M319.14,245.61,176.27,162.1c-4.66-2.63-4.08-7.33,1.3-10.51l12.63-6.32c5.38-3.18,13.51-3.62,18.17-1l142.87,83.51c4.66,2.63,4.07,7.33-1.31,10.51l-12.62,6.31C331.93,247.78,323.79,248.23,319.14,245.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M357.32,225.06h-1.08a7.67,7.67,0,0,0-2.28-1.88l-145.59-85c-5-2.81-13.67-2.33-19.42,1.07L173.81,147a11.78,11.78,0,0,0-3.48,3l-1.28,0v8.07h0c.16,1.67,1.24,3.23,3.32,4.4l145.59,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c2.73-1.61,4.29-3.59,4.65-5.53h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M318,240.26l-145.59-85c-5-2.81-4.35-7.84,1.4-11.24l15.14-7.8c5.75-3.39,14.45-3.87,19.42-1.07l145.59,85c5,2.8,4.36,7.83-1.39,11.23l-15.14,7.8C331.68,242.59,323,243.07,318,240.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M352.57,230.52l-15.14,7.8c-5.75,3.4-14.45,3.88-19.43,1.07l-145.59-85a5.93,5.93,0,0,1-3.3-4.21c-.31,2.08.77,4.08,3.3,5.51L318,240.7c5,2.8,13.68,2.32,19.43-1.08l15.14-7.8c3.44-2,5-4.65,4.7-7C357,226.79,355.39,228.85,352.57,230.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "131.04 301.4 327.95 187.65 310.78 178.5 114.5 291.91 131.04 301.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "131.04 298.97 327.95 185.22 310.78 176.07 114.5 289.48 131.04 298.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "123.55 287.05 310.83 178.85 322.95 185.31 130.39 296.54 123.55 287.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "160.97 279.01 184.49 265.42 184.49 259.58 171.32 259.58 160.97 265.56 160.97 279.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "242.87 231.46 266.38 217.88 266.38 206.98 261.95 206.98 242.87 218 242.87 231.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M283.42,259l-1.09,0a7.42,7.42,0,0,0-2.28-1.89L134.47,172c-5-2.81-13.68-2.33-19.43,1.07l-15.14,7.8a11.78,11.78,0,0,0-3.48,3l-1.28,0V192h0c.16,1.67,1.25,3.23,3.33,4.4l145.58,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c2.73-1.61,4.29-3.59,4.66-5.53h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M283.42,257.28l-1.09,0a7.55,7.55,0,0,0-2.28-1.88l-145.58-85c-5-2.8-13.68-2.32-19.43,1.07l-15.14,7.8a12,12,0,0,0-3.48,3l-1.28,0v8.07h0c.16,1.67,1.25,3.23,3.33,4.4l145.58,85c5,2.8,13.68,2.32,19.43-1.08l15.14-7.79c2.73-1.62,4.29-3.6,4.66-5.54h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M244.09,272.49,98.51,187.44c-5-2.8-4.36-7.83,1.39-11.23l15.14-7.8c5.75-3.4,14.45-3.88,19.43-1.07l145.58,85c5,2.81,4.36,7.83-1.39,11.23l-15.14,7.8C257.77,274.81,249.07,275.29,244.09,272.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M278.66,262.75l-15.14,7.79c-5.75,3.4-14.45,3.88-19.43,1.08L98.51,186.57a5.93,5.93,0,0,1-3.31-4.2c-.3,2.07.77,4.08,3.31,5.51l145.58,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c3.44-2,5-4.65,4.7-7C283.06,259,281.48,261.08,278.66,262.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M357.32,216.85h-1.08A7.67,7.67,0,0,0,354,215l-145.59-85c-5-2.8-13.67-2.32-19.42,1.08l-15.14,7.79a12,12,0,0,0-3.48,3l-1.28,0v8.07h0c.16,1.66,1.24,3.22,3.32,4.39l145.59,85c5,2.8,13.68,2.32,19.43-1.07l15.14-7.8c2.73-1.62,4.29-3.6,4.65-5.53h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M357.32,215.18h-1.08a7.67,7.67,0,0,0-2.28-1.88l-145.59-85c-5-2.81-13.67-2.33-19.42,1.07l-15.14,7.8a11.78,11.78,0,0,0-3.48,3l-1.28,0v8.07h0c.16,1.67,1.24,3.23,3.32,4.4l145.59,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c2.73-1.61,4.29-3.59,4.65-5.53h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M318,230.38l-145.59-85c-5-2.81-4.35-7.84,1.4-11.24L189,126.3c5.75-3.4,14.45-3.88,19.42-1.07l145.59,85c5,2.81,4.36,7.84-1.39,11.24l-15.14,7.8C331.68,232.71,323,233.19,318,230.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M352.57,220.64l-15.14,7.8c-5.75,3.4-14.45,3.88-19.43,1.07l-145.59-85a5.93,5.93,0,0,1-3.3-4.21c-.31,2.08.77,4.08,3.3,5.51l145.59,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c3.44-2,5-4.65,4.7-7C357,216.91,355.39,219,352.57,220.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M209.51,301.5l-1.08,0a7.8,7.8,0,0,0-2.28-1.88l-145.59-85c-5-2.8-13.68-2.32-19.43,1.07L26,223.46a12,12,0,0,0-3.48,3l-1.27,0v8.07h0c.16,1.66,1.25,3.22,3.33,4.39L170.18,324c5,2.8,13.68,2.32,19.43-1.08l15.14-7.79c2.73-1.62,4.29-3.6,4.66-5.53h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M209.51,299.84h-1.08a7.8,7.8,0,0,0-2.28-1.88l-145.59-85c-5-2.81-13.68-2.33-19.43,1.07L26,221.8a11.78,11.78,0,0,0-3.48,3l-1.27,0v8.07h0a5.85,5.85,0,0,0,3.33,4.4l145.58,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c2.73-1.61,4.29-3.6,4.66-5.53h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M170.18,315,24.6,230c-5-2.8-4.36-7.83,1.39-11.23L41.13,211c5.75-3.4,14.45-3.88,19.43-1.07l145.59,85c5,2.81,4.35,7.84-1.4,11.24L189.61,314C183.86,317.36,175.16,317.84,170.18,315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M204.75,305.3l-15.14,7.8c-5.75,3.4-14.45,3.88-19.43,1.07l-145.58-85a6,6,0,0,1-3.31-4.21c-.3,2.07.77,4.08,3.31,5.51l145.58,85c5,2.81,13.68,2.33,19.43-1.07l15.14-7.8c3.44-2,5-4.65,4.7-7C209.15,301.57,207.57,303.63,204.75,305.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325,225.92a12.21,12.21,0,0,1-6.12-1.48l-65.38-38-65.38-38a6.43,6.43,0,0,1-3.51-5.59c0-2.48,1.54-4.8,4.22-6.35l1.21-9.91a15,15,0,0,1,7.43-1.89,12.21,12.21,0,0,1,6.12,1.48l70.29,40.18,70.29,40.18a6.49,6.49,0,0,1,3.51,5.6c0,2.48-1.54,4.79-4.23,6.34l-11,5.63A15,15,0,0,1,325,225.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M190.11,127.17a16.17,16.17,0,0,1,7.3-2,12,12,0,0,1,6.09,1.34c.08,0,4.05,2.24,4.1,2.27l65.9,37.69,5,2.86,65,37.16a6.8,6.8,0,0,1,3.61,5.47c.06,2.44-1.37,4.76-4.06,6.32l-5.9,3c-.07,0-5,2.52-5,2.52a14.9,14.9,0,0,1-7.32,1.76,12.58,12.58,0,0,1-6-1.54l-65-37.77-4.29-2.49-60.65-35.28a6.63,6.63,0,0,1-3.59-5.47A7.09,7.09,0,0,1,189,136.9l.12-1.45C189,135.38,190,127.25,190.11,127.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M190.16,127.83a17.6,17.6,0,0,1,7.17-2A11.79,11.79,0,0,1,203.4,127c.15,0,4,2.14,4.1,2.2l65.61,37.54,5,2.85,64.68,37a7.18,7.18,0,0,1,3.7,5.36c.12,2.4-1.19,4.72-3.9,6.28l-5.83,3.06c-.13.08-4.86,2.46-5,2.47a14.77,14.77,0,0,1-7.21,1.62,13,13,0,0,1-6-1.6L254,186.3l-4.26-2.48-60.24-35c-2-1.16-3.67-3.29-3.67-5.34a6.69,6.69,0,0,1,3.26-6.07l.06-1.41A44.68,44.68,0,0,1,190.16,127.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M190.21,128.49a19.25,19.25,0,0,1,7-2.09,11.66,11.66,0,0,1,6,1.07c.22,0,3.94,2.05,4.1,2.15L272.72,167l5,2.84,64.4,36.85c1.91,1.1,3.64,3.3,3.79,5.24.17,2.36-1,4.68-3.73,6.25l-5.78,3.07c-.19.11-4.75,2.38-5,2.4a14.39,14.39,0,0,1-7.1,1.49,13.38,13.38,0,0,1-5.92-1.66l-64.07-37.23L250,183.79,190.21,149c-1.91-1.1-3.75-3.27-3.75-5.21,0-2.13.47-4.61,2.78-5.94V136.5C188.88,136.29,189.8,128.73,190.21,128.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M190.26,129.15a21.16,21.16,0,0,1,6.91-2.15,11.42,11.42,0,0,1,6,.93c.3,0,3.9,2,4.11,2.08l65,37.23,4.95,2.83,64.11,36.69c1.8,1.05,3.69,3.3,3.88,5.13.23,2.32-.84,4.64-3.56,6.21L336,221.18c-.25.15-4.66,2.32-5,2.35a14.33,14.33,0,0,1-7,1.35,13.77,13.77,0,0,1-5.85-1.72l-63.64-37-4.21-2.44L190.9,149.25c-1.81-1.05-3.83-3.26-3.83-5.1,0-2,.12-4.54,2.29-5.79L189.3,137C188.82,136.75,189.71,129.46,190.26,129.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M190.31,129.81a23.79,23.79,0,0,1,6.78-2.22,11.23,11.23,0,0,1,6,.8,39.08,39.08,0,0,1,4.11,2l64.74,37.08,4.92,2.82,63.82,36.54c1.7,1,3.75,3.3,4,5,.29,2.29-.66,4.59-3.39,6.17l-5.66,3.09c-.32.19-4.56,2.26-5,2.29a14.07,14.07,0,0,1-6.88,1.22,14.62,14.62,0,0,1-5.79-1.77l-63.2-36.7-4.18-2.42-59-34.26c-1.7-1-3.91-3.25-3.9-5,0-1.9-.24-4.47,1.8-5.66l-.13-1.29C188.77,137.21,189.63,130.2,190.31,129.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M190.36,130.46a27,27,0,0,1,6.65-2.27,10.79,10.79,0,0,1,6,.66,30.38,30.38,0,0,1,4.11,2l64.45,36.91,4.91,2.81L340,206.92c1.6.92,3.81,3.29,4.06,4.89.37,2.27-.47,4.55-3.21,6.14l-5.6,3.1a46.4,46.4,0,0,1-4.93,2.22,13.67,13.67,0,0,1-6.77,1.09,15.1,15.1,0,0,1-5.72-1.83L255,186.1l-4.15-2.41-58.6-34c-1.59-.92-4-3.23-4-4.85,0-1.77-.6-4.4,1.32-5.51l-.19-1.25C188.72,137.67,189.54,130.94,190.36,130.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M190.41,131.12a31.44,31.44,0,0,1,6.52-2.34,10.63,10.63,0,0,1,5.93.53,26.1,26.1,0,0,1,4.12,1.88L271.14,168l4.88,2.8L339.27,207c1.49.86,4.15,3.26,4.15,4.78.83,2.13-.3,4.51-3.05,6.1L334.84,221a39.8,39.8,0,0,1-4.91,2.17,13.61,13.61,0,0,1-6.66.95,15.91,15.91,0,0,1-5.65-1.89l-62.33-36.16-4.13-2.39L193,149.91c-1.49-.86-4.06-3.21-4.06-4.72,0-1.66-.95-4.34.84-5.38l-.25-1.21C188.67,138.12,189.45,131.68,190.41,131.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M190.46,131.78a37.56,37.56,0,0,1,6.39-2.41,10.53,10.53,0,0,1,5.91.39,24.18,24.18,0,0,1,4.11,1.82l63.88,36.61,4.86,2.79,63,36.09c1.38.79,4.24,3.25,4.24,4.65.95,2.09-.12,4.48-2.88,6.07l-5.48,3.12a33,33,0,0,1-4.88,2.11,13.31,13.31,0,0,1-6.55.82c-1.44,0-4.55-1.36-5.59-2L255.54,186l-4.1-2.37-57.78-33.5c-1.38-.8-4.14-3.2-4.14-4.6s-1.31-4.27.36-5.23l-.32-1.17C188.61,138.58,189.37,132.41,190.46,131.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M190.51,132.44a43.61,43.61,0,0,1,6.26-2.47,10.28,10.28,0,0,1,5.88.25,20.75,20.75,0,0,1,4.12,1.75l63.58,36.46,4.84,2.78,62.67,35.93c1.28.74,4.34,3.25,4.34,4.54,1.07,2,.06,4.44-2.71,6l-5.42,3.13a31,31,0,0,1-4.86,2.05,13.1,13.1,0,0,1-6.44.68c-1.33,0-4.57-1.46-5.52-2L255.79,186l-4.07-2.35-57.37-33.25c-1.27-.74-4.22-3.18-4.22-4.47s-1.66-4.21-.13-5.1l-.37-1.13C188.56,139,189.28,133.15,190.51,132.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M190.56,133.1a56.54,56.54,0,0,1,6.13-2.54,10,10,0,0,1,5.85.12,18,18,0,0,1,4.13,1.69L270,168.67l4.81,2.76,62.39,35.79c1.17.67,4.43,3.23,4.43,4.42,1.19,2,.23,4.4-2.54,6l-5.36,3.14a26.62,26.62,0,0,1-4.84,2,12.67,12.67,0,0,1-6.33.54c-1.22,0-4.58-1.56-5.45-2.06L256,185.9l-4-2.34-57-33c-1.16-.68-4.3-3.16-4.29-4.35s-2-4.14-.62-4.95l-.44-1.09C188.51,139.49,189.19,133.89,190.56,133.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M190.61,133.76c1-.58,4.81-2.15,6-2.61a9.82,9.82,0,0,1,5.83,0,16.38,16.38,0,0,1,4.12,1.62l63,36.15,4.8,2.75,62.1,35.63c1.06.62,4.52,3.23,4.52,4.31,1.31,1.94.41,4.35-2.38,6l-5.29,3.15a24.06,24.06,0,0,1-4.82,1.94,12.45,12.45,0,0,1-6.22.4c-1.11,0-4.59-1.66-5.39-2.12L256.3,185.85l-4-2.32-56.55-32.74c-1.07-.61-4.38-3.14-4.38-4.22s-2.38-4.08-1.1-4.82l-.5-1.05C188.45,140,189.11,134.63,190.61,133.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M190.66,134.42c.91-.53,4.81-2.22,5.87-2.67a9.58,9.58,0,0,1,5.8-.15,15.34,15.34,0,0,1,4.13,1.55l62.71,36,4.77,2.74,61.82,35.48c.95.55,4.61,3.22,4.61,4.19,1.43,1.88.59,4.31-2.21,5.93l-5.23,3.16a21.84,21.84,0,0,1-4.8,1.87,12.12,12.12,0,0,1-6.11.27c-1,0-4.6-1.77-5.32-2.18L256.55,185.8l-4-2.3L196.43,151c-1-.55-4.46-3.13-4.46-4.1s-2.73-4-1.58-4.67l-.56-1C188.4,140.41,189,135.36,190.66,134.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M190.71,135.07c.81-.46,4.81-2.29,5.74-2.73a9.49,9.49,0,0,1,5.77-.29,14.07,14.07,0,0,1,4.14,1.5l62.42,35.84,4.75,2.73,61.52,35.33c.85.49,4.71,3.2,4.71,4.07,1.54,1.83.76,4.27-2,5.89l-5.18,3.17a19.33,19.33,0,0,1-4.77,1.81,11.77,11.77,0,0,1-6,.14c-.89,0-4.62-1.87-5.25-2.24L256.8,185.75l-4-2.28-55.73-32.24c-.85-.49-4.54-3.11-4.54-4s-3.09-3.95-2.06-4.54l-.63-1C188.35,140.86,188.93,136.1,190.71,135.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M190.76,135.73c.71-.4,4.82-2.38,5.61-2.79a9.17,9.17,0,0,1,5.74-.43,12.92,12.92,0,0,1,4.14,1.43l62.13,35.69,4.73,2.71,61.24,35.18c.75.43,4.8,3.2,4.8,4,1.66,1.78.94,4.23-1.87,5.85l-5.12,3.18a17.71,17.71,0,0,1-4.75,1.76,11.52,11.52,0,0,1-5.89,0c-.78,0-4.63-2-5.19-2.3L257.05,185.7l-3.92-2.27-55.32-32c-.75-.43-4.62-3.09-4.62-3.85s-3.44-3.88-2.55-4.39l-.68-.93C188.3,141.32,188.85,136.84,190.76,135.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M190.81,136.39c.61-.35,4.81-2.48,5.48-2.86,1.66-1,3.86-.84,5.72-.56a12.16,12.16,0,0,1,4.14,1.36L268,169.87l4.71,2.7,60.95,35c.64.37,4.89,3.19,4.89,3.83,1.78,1.74,1.12,4.2-1.71,5.83l-5.05,3.19a16.37,16.37,0,0,1-4.73,1.69,11.16,11.16,0,0,1-5.78-.13c-.67,0-4.64-2.08-5.12-2.36l-58.85-34-3.89-2.25L198.5,151.67c-.64-.36-4.7-3.07-4.7-3.72s-3.8-3.81-3-4.26l-.75-.89C188.24,141.78,188.76,137.58,190.81,136.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M190.86,137.05c.51-.29,4.71-2.93,5.35-2.93a11.75,11.75,0,0,1,5.69-.69,11.16,11.16,0,0,1,4.15,1.29l61.54,35.39,4.69,2.69L333,207.67c.53.31,5,3.18,5,3.72,1.9,1.69,1.29,4.16-1.54,5.79l-5,3.2a15.5,15.5,0,0,1-4.71,1.64,10.89,10.89,0,0,1-5.67-.27,38,38,0,0,1-5.06-2.42l-58.4-33.73-3.87-2.23-54.5-31.48c-.53-.3-4.77-3.06-4.77-3.6s-4.16-3.74-3.52-4.11l-.81-.85C188.19,142.23,188.67,138.32,190.86,137.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M190.91,137.71c.41-.23,4.71-3,5.22-3a11.52,11.52,0,0,1,5.66-.83,10.44,10.44,0,0,1,4.15,1.23l61.26,35.22,4.67,2.69,60.37,34.72c.43.24,5.08,3.17,5.08,3.6,2,1.64,1.47,4.11-1.37,5.75L331,220.32a14.43,14.43,0,0,1-4.69,1.57,10.51,10.51,0,0,1-5.56-.4,45.44,45.44,0,0,1-5-2.48l-58-33.46L254,183.33l-54.09-31.22c-.42-.24-4.85-3-4.85-3.47s-4.51-3.68-4-4l-.88-.81C188.14,142.69,188.59,139.05,190.91,137.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M191,138.37c.31-.18,4.7-3.06,5.09-3.06a11.66,11.66,0,0,1,5.64-1,10.1,10.1,0,0,1,4.15,1.17l61,35.07,4.64,2.67,60.09,34.57c.32.19,5.17,3.17,5.17,3.49,2.13,1.59,1.65,4.07-1.2,5.72l-4.88,3.22a13.31,13.31,0,0,1-4.66,1.52,10.22,10.22,0,0,1-5.45-.54c-.34,0-4.68-2.4-4.92-2.54L258.06,185.5l-3.81-2.2-53.68-31c-.32-.19-4.93-3-4.93-3.35s-4.87-3.62-4.48-3.84l-.94-.77C188.08,143.15,188.5,139.79,191,138.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M191,139c.21-.12,4.7-3.13,5-3.13a11.54,11.54,0,0,1,5.61-1.1,9.55,9.55,0,0,1,4.16,1.1l60.67,34.92,4.62,2.66,59.81,34.42c.21.12,5.26,3.15,5.26,3.37,2.25,1.54,1.82,4-1,5.68l-4.81,3.23a12.31,12.31,0,0,1-4.64,1.46,9.84,9.84,0,0,1-5.34-.67c-.23,0-4.7-2.51-4.86-2.6l-57.1-32.92-3.78-2.18-53.27-30.71c-.21-.13-5-3-5-3.23s-5.22-3.55-5-3.7l-1-.72C188,143.6,188.41,140.53,191,139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M191.07,139.68c.1-.05,4.69-3.18,4.82-3.18a11.29,11.29,0,0,1,5.58-1.24,8.92,8.92,0,0,1,4.16,1L266,171.06l4.6,2.65L330.14,208c.1.06,5.35,3.14,5.35,3.25,2.37,1.49,2,4-.87,5.64l-4.75,3.25a11.58,11.58,0,0,1-4.62,1.39,9.44,9.44,0,0,1-5.23-.8c-.11,0-4.71-2.61-4.79-2.66L258.57,185.4l-3.76-2.16L202,152.78c-.1-.06-5.09-3-5.09-3.1s-5.58-3.49-5.45-3.56l-1.06-.69C188,144.06,188.32,141.27,191.07,139.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M319.77,220.45,255.09,183.2,190.42,146c-2.49-1.44-2.18-4,.7-5.62l4.69-3.25c2.87-1.66,7.23-1.84,9.72-.4l64.67,37.25,64.68,37.25c2.49,1.43,2.18,3.95-.7,5.61l-4.69,3.25C326.61,221.71,322.26,221.89,319.77,220.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M320.17,219.5,194.13,147c-7.17-4.14-13-15.25-13-24.82V14.85c0-9.57,5.81-14,13-9.82l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68C333.16,219.24,327.34,223.64,320.17,219.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M324,215.27,195.65,141.45c-6-3.79-9.63-11.34-9.63-19.07V11.05a2.37,2.37,0,0,1,3.57-2l.42.24L318.47,83.18c7.08,4.09,9.63,11.34,9.63,19.07v111a2.56,2.56,0,0,1-3.83,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M318.47,83.18,190,9.25,189.59,9a2.37,2.37,0,0,0-3.57,2V122.38c0,7.73,3.68,15.28,9.63,19.07L324,215.27l.31.18a2.56,2.56,0,0,0,3.83-2.22v-111C328.1,94.52,325.55,87.27,318.47,83.18Zm8.13,130a1.07,1.07,0,0,1-1.07,1.06,1,1,0,0,1-.52-.15l-128.61-74c-5.37-3.41-8.88-10.4-8.88-17.76V11.05a.88.88,0,0,1,.88-.87.86.86,0,0,1,.43.13L317.72,84.49c7.34,4.23,8.88,12,8.88,17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M326.15,74.09l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-6.19,3.55-6.44,3.69h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,6.4-3.83,6.55-3.94,2.47-1.73,4-5.28,4-10.19V98.9C339.14,89.34,333.32,78.23,326.15,74.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M326,74.16,200,1.63C197.16,0,194.54-.31,192.4.52c-.27.1-6.08,3.47-6.33,3.61h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,6.29-3.76,6.44-3.87,2.47-1.73,4-5.28,4-10.19V99C339,89.41,333.21,78.3,326,74.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M325.93,74.23,199.89,1.7c-2.84-1.64-5.46-1.94-7.6-1.11-.27.1-6,3.4-6.22,3.54h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,6.18-3.69,6.33-3.8,2.47-1.72,4-5.27,4-10.19V99.05C338.92,89.48,333.1,78.37,325.93,74.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M325.82,74.3l-126-72.52C197,.14,194.32-.17,192.18.66c-.27.1-5.86,3.33-6.11,3.47h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,6.07-3.61,6.23-3.72,2.46-1.73,4-5.28,4-10.2V99.12C338.81,89.55,333,78.44,325.82,74.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M325.71,74.37l-126-72.52c-2.83-1.64-5.46-1.94-7.6-1.12-.27.11-5.75,3.26-6,3.4h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,6-3.54,6.12-3.65,2.46-1.73,4-5.28,4-10.2V99.19C338.7,89.63,332.88,78.52,325.71,74.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M325.6,74.45l-126-72.53C196.73.28,194.1,0,192,.8c-.27.11-5.64,3.19-5.89,3.33h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5.85-3.47,6-3.58,2.46-1.73,4-5.28,4-10.19V99.26C338.59,89.7,332.77,78.59,325.6,74.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M325.49,74.52,199.46,2C196.62.35,194,.05,191.86.88c-.28.1-5.54,3.11-5.79,3.25h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5.74-3.4,5.9-3.51,2.46-1.73,4-5.28,4-10.19V99.33C338.48,89.77,332.67,78.66,325.49,74.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M325.38,74.59l-126-72.53C196.51.43,193.88.12,191.75,1c-.28.1-5.43,3-5.68,3.18h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5.63-3.33,5.79-3.44,2.46-1.72,4-5.27,4-10.19V99.41C338.37,89.84,332.56,78.73,325.38,74.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M325.27,74.66l-126-72.52C196.4.5,193.77.2,191.64,1c-.28.11-5.32,3-5.57,3.11h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5.52-3.25,5.68-3.36,2.47-1.73,4-5.28,4-10.2V99.48C338.26,89.91,332.45,78.8,325.27,74.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M325.16,74.73l-126-72.52c-2.84-1.64-5.47-1.94-7.6-1.12-.27.11-5.21,2.9-5.46,3h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5.41-3.18,5.57-3.29,2.47-1.73,4-5.28,4-10.2V99.55C338.15,90,332.34,78.88,325.16,74.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M325.05,74.81,199,2.28c-2.84-1.64-5.47-1.94-7.6-1.12-.27.11-5.1,2.83-5.35,3h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5.3-3.11,5.46-3.22,2.47-1.73,4-5.28,4-10.19V99.62C338,90.06,332.23,79,325.05,74.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M325,74.88l-126-72.53c-2.84-1.64-5.47-1.94-7.6-1.11-.27.1-5,2.75-5.24,2.89h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5.19-3,5.35-3.15,2.47-1.72,4-5.27,4-10.19V99.69C337.93,90.13,332.12,79,325,74.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M324.84,75,198.8,2.42C196,.79,193.34.48,191.2,1.31c-.27.1-4.88,2.68-5.13,2.82h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5.08-3,5.24-3.07,2.47-1.73,4-5.28,4-10.2V99.77C337.82,90.2,332,79.09,324.84,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M324.73,75,198.69,2.5c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-4.77,2.61-5,2.75h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,5-2.89,5.13-3,2.47-1.73,4-5.28,4-10.2V99.84C337.71,90.28,331.9,79.16,324.73,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M324.62,75.1l-126-72.53C195.74.93,193.12.63,191,1.45c-.27.11-4.66,2.54-4.91,2.68h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,4.87-2.82,5-2.93,2.47-1.73,4-5.28,4-10.19V99.91C337.61,90.35,331.79,79.24,324.62,75.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M324.51,75.17l-126-72.53C195.63,1,193,.7,190.87,1.53c-.27.1-4.55,2.46-4.8,2.6h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,4.76-2.75,4.91-2.86,2.47-1.73,4-5.28,4-10.19V100C337.5,90.42,331.68,79.31,324.51,75.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M324.4,75.24l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.11-.27.1-4.44,2.39-4.69,2.53h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,4.65-2.68,4.8-2.79,2.47-1.72,4-5.27,4-10.19V100.06C337.39,90.49,331.57,79.38,324.4,75.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M324.29,75.31l-126-72.52c-2.84-1.64-5.46-1.95-7.6-1.12-.27.1-4.33,2.32-4.58,2.46h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,4.54-2.6,4.69-2.71,2.47-1.73,4-5.28,4-10.2V100.13C337.28,90.56,331.46,79.45,324.29,75.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M324.18,75.38l-126-72.52c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-4.22,2.25-4.47,2.39h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,4.43-2.53,4.58-2.64,2.47-1.73,4-5.28,4-10.2V100.2C337.17,90.64,331.35,79.53,324.18,75.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M324.07,75.46,198,2.93c-2.83-1.64-5.46-1.94-7.6-1.12-.27.11-4.11,2.18-4.36,2.32h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,4.32-2.46,4.47-2.57,2.47-1.73,4-5.28,4-10.19V100.27C337.06,90.71,331.24,79.6,324.07,75.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M324,75.53,197.92,3c-2.83-1.64-5.46-1.94-7.6-1.11-.27.1-4,2.1-4.25,2.24h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,4.21-2.39,4.37-2.5,2.46-1.73,4-5.28,4-10.19V100.34C337,90.78,331.13,79.67,324,75.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M323.85,75.6l-126-72.53C195,1.44,192.35,1.13,190.21,2c-.27.1-3.89,2-4.14,2.17h0c2.22-1.08,5-.88,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.81V209.68c0,6-2.27,9.92-5.71,11a2.08,2.08,0,0,0,1.13-.38c.17-.1,4.1-2.32,4.26-2.43,2.46-1.72,4-5.27,4-10.19V100.42C336.84,90.85,331,79.74,323.85,75.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M320.79,77.24l-126-72.52c-2.94-1.7-5.65-1.94-7.83-1a9.53,9.53,0,0,1,6.27,1.47l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,5.64-2,9.47-5.16,10.82,4-.63,6.72-4.75,6.72-11.29V102.06C333.78,92.5,328,81.39,320.79,77.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M198.43,34.29l-1.79-1V27.63l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M209,31.14c0,1.69-.24,2.81-.73,3.34S207,35,206,34.41a5.32,5.32,0,0,1-2.21-2.54,10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07A5.33,5.33,0,0,1,208.25,27,10.36,10.36,0,0,1,209,31.14Zm-4.14-2.4a10.33,10.33,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,10.06,10.06,0,0,0-.28-2.74,2.08,2.08,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,204.86,28.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M216.57,48.8l-1.79-1V42.15l0-.92,0-1a3.78,3.78,0,0,1-.62.31l-1,.34-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M227.14,45.65c0,1.7-.25,2.81-.73,3.35s-1.23.51-2.24-.07A5.31,5.31,0,0,1,222,46.39a10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,227.14,45.65ZM223,43.26a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.24.72.16.9-.26a6.66,6.66,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.13,2.13,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,223,43.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M237.26,65.65c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.41,10.41,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.29,5.29,0,0,1,2.22,2.56A10.28,10.28,0,0,1,237.26,65.65Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.27a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,233.12,63.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M245.23,71.71l-1.78-1V64.15l0-1a4.66,4.66,0,0,1-.62.32l-1,.33L241,62.07l2.72-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M199.88,42.31c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54A10.41,10.41,0,0,1,194,38.9c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.29,5.29,0,0,1,2.22,2.56A10.28,10.28,0,0,1,199.88,42.31Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.25.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,195.74,39.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M207.55,47.2l-1.79-1V40.55l0-.92,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M216.57,60.85l-1.79-1V54.19l0-.91,0-1a3.78,3.78,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M227.14,57.69c0,1.7-.25,2.82-.73,3.35s-1.23.51-2.24-.07A5.27,5.27,0,0,1,222,58.43a10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.33,5.33,0,0,1,2.22,2.56A10.35,10.35,0,0,1,227.14,57.69ZM223,55.3a10.33,10.33,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.9-.26a6.72,6.72,0,0,0,.28-2.4,10,10,0,0,0-.28-2.73,2.16,2.16,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,223,55.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M216.57,123l-1.79-1v-5.62l0-.92,0-1a3.78,3.78,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M227.14,119.88c0,1.69-.25,2.81-.73,3.34s-1.23.52-2.24-.07a5.29,5.29,0,0,1-2.21-2.53,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.36,10.36,0,0,1,227.14,119.88ZM223,117.49a10.3,10.3,0,0,0,.27,2.71,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.9-.26a6.66,6.66,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.1,2.1,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,223,117.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M235.81,81.72l-1.79-1V75.06l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M246.68,79.74c0,1.69-.24,2.81-.72,3.34s-1.24.52-2.24-.06a5.26,5.26,0,0,1-2.21-2.54,10.28,10.28,0,0,1-.75-4.16c0-1.71.24-2.84.73-3.37s1.22-.51,2.23.07a5.3,5.3,0,0,1,2.21,2.55A10.36,10.36,0,0,1,246.68,79.74Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.05,2.05,0,0,0,.91,1.3c.41.24.72.15.9-.26a6.66,6.66,0,0,0,.28-2.39,10.44,10.44,0,0,0-.28-2.73,2.1,2.1,0,0,0-.9-1.3c-.42-.25-.72-.16-.91.26A7,7,0,0,0,242.54,77.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M198.43,58.38l-1.79-1V51.72l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M209,55.22c0,1.7-.24,2.82-.73,3.35s-1.23.51-2.24-.07A5.32,5.32,0,0,1,203.82,56a10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.33,5.33,0,0,1,2.22,2.56A10.35,10.35,0,0,1,209,55.22Zm-4.14-2.39a10.33,10.33,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.4,9.9,9.9,0,0,0-.28-2.72,2.08,2.08,0,0,0-.9-1.31c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,204.86,52.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M216.57,72.89l-1.79-1V66.24l0-.91,0-1a3.09,3.09,0,0,1-.62.31l-1,.34-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M225.69,73.76l-1.79-1V67.11l0-.92,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M237.26,89.74c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.41,10.41,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.29,5.29,0,0,1,2.22,2.56A10.28,10.28,0,0,1,237.26,89.74Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.27a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,233.12,87.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M245.23,95.8l-1.78-1V88.24l0-1a4.66,4.66,0,0,1-.62.32l-1,.33L241,86.16l2.72-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M198.43,70.42l-1.79-1V63.77l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M209,67.27c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07A5.36,5.36,0,0,1,203.82,68a10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37S205,60,206,60.55a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,209,67.27Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.24.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,204.86,64.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M216.57,84.94l-1.79-1V78.28l0-.91,0-1a3.78,3.78,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M227.14,81.78c0,1.7-.25,2.82-.73,3.35s-1.23.51-2.24-.07A5.27,5.27,0,0,1,222,82.52a10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.37s1.23-.52,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.35,10.35,0,0,1,227.14,81.78ZM223,79.39a10.33,10.33,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.9-.26a6.72,6.72,0,0,0,.28-2.4,10,10,0,0,0-.28-2.73,2.16,2.16,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,223,79.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M237.26,101.79c0,1.69-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,237.26,101.79Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,233.12,99.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M245.23,107.85l-1.78-1v-6.54l0-1a4.23,4.23,0,0,1-.62.31l-1,.34L241,98.2l2.72-.91,1.47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M199.88,78.45c0,1.69-.24,2.81-.73,3.34s-1.23.52-2.24-.06a5.36,5.36,0,0,1-2.21-2.54A10.46,10.46,0,0,1,194,75c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,199.88,78.45Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2,2,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,195.74,76.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M207.55,83.34l-1.79-1V76.68l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.87-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M199.88,106.22c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07A5.32,5.32,0,0,1,194.7,107a10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.31,5.31,0,0,1,2.22,2.55A10.36,10.36,0,0,1,199.88,106.22Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.27a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,195.74,103.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M207.55,111.11l-1.79-1v-5.62l0-.92,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M216.57,97l-1.79-1V90.33l0-.91,0-1a4.11,4.11,0,0,1-.62.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M227.14,93.83c0,1.7-.25,2.81-.73,3.35s-1.23.51-2.24-.07A5.31,5.31,0,0,1,222,94.57a10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,227.14,93.83ZM223,91.44a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.24.72.16.9-.26a6.66,6.66,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.13,2.13,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,223,91.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M235.81,117.85l-1.79-1V111.2l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.87-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M246.68,115.87c0,1.7-.24,2.82-.72,3.35s-1.24.51-2.24-.07a5.22,5.22,0,0,1-2.21-2.54,10.2,10.2,0,0,1-.75-4.15c0-1.72.24-2.84.73-3.38s1.22-.51,2.23.07a5.37,5.37,0,0,1,2.21,2.56A10.28,10.28,0,0,1,246.68,115.87Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.08,2.08,0,0,0,.91,1.3c.41.24.72.15.9-.27a6.62,6.62,0,0,0,.28-2.39,10.44,10.44,0,0,0-.28-2.73,2.13,2.13,0,0,0-.9-1.3c-.42-.24-.72-.15-.91.26A7.07,7.07,0,0,0,242.54,113.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M235.81,53.88l-1.79-1V47.22l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.87-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M246.68,51.89c0,1.7-.24,2.82-.72,3.35s-1.24.51-2.24-.07a5.22,5.22,0,0,1-2.21-2.54,10.2,10.2,0,0,1-.75-4.15c0-1.72.24-2.84.73-3.38s1.22-.51,2.23.07a5.37,5.37,0,0,1,2.21,2.56A10.35,10.35,0,0,1,246.68,51.89Zm-4.14-2.39a10.33,10.33,0,0,0,.27,2.72,2.08,2.08,0,0,0,.91,1.3c.41.24.72.15.9-.27a6.62,6.62,0,0,0,.28-2.39,10.44,10.44,0,0,0-.28-2.73,2.16,2.16,0,0,0-.9-1.3c-.42-.24-.72-.15-.91.26A7.07,7.07,0,0,0,242.54,49.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M198.43,94.51l-1.79-1V87.86l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.86-1.73L197,84l1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M209,91.36c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,209,91.36ZM204.86,89a10.38,10.38,0,0,0,.27,2.72A2.06,2.06,0,0,0,206,93c.42.24.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,204.86,89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M216.57,109l-1.79-1v-5.63l0-.91,0-1a3.78,3.78,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.91,1.47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M225.69,109.89l-1.79-1v-5.62l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M237.26,125.88c0,1.69-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,237.26,125.88Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,233.12,123.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M245.23,131.94l-1.78-1v-6.54l0-1a4.23,4.23,0,0,1-.62.31l-1,.34-.86-1.74,2.72-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M314.32,106.47c0,1.69-.24,2.81-.73,3.34s-1.23.52-2.24-.07a5.34,5.34,0,0,1-2.21-2.53,10.46,10.46,0,0,1-.74-4.16c0-1.72.24-2.84.72-3.37s1.23-.51,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.36,10.36,0,0,1,314.32,106.47Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,9.93,9.93,0,0,0-.28-2.73,2,2,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,310.18,104.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M321,119.87l-1.79-1v-5.62l0-.92,0-1a4.74,4.74,0,0,1-.61.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M312.87,122.53l-1.79-1v-5.62l0-.92,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.87-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M322.49,127.9c0,1.69-.25,2.81-.73,3.34s-1.23.52-2.24-.07a5.29,5.29,0,0,1-2.21-2.53,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.36,10.36,0,0,1,322.49,127.9Zm-4.14-2.39a10.84,10.84,0,0,0,.26,2.71,2.12,2.12,0,0,0,.91,1.3c.42.24.72.15.9-.26a6.7,6.7,0,0,0,.28-2.39,9.93,9.93,0,0,0-.28-2.73,2.1,2.1,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,318.35,125.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M312.87,196.06l-1.79-1v-5.62l0-.92,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.91,1.47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M322.49,201.42c0,1.7-.25,2.82-.73,3.35s-1.23.51-2.24-.07a5.27,5.27,0,0,1-2.21-2.54,10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.33,5.33,0,0,1,2.22,2.56A10.28,10.28,0,0,1,322.49,201.42ZM318.35,199a10.93,10.93,0,0,0,.26,2.72,2.12,2.12,0,0,0,.91,1.3q.63.36.9-.27a6.62,6.62,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.13,2.13,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,318.35,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M314.32,130.56c0,1.69-.24,2.81-.73,3.34s-1.23.52-2.24-.07a5.34,5.34,0,0,1-2.21-2.53,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.36,10.36,0,0,1,314.32,130.56Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,310.18,128.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M321,144l-1.79-1v-5.62l0-.92,0-1a4.74,4.74,0,0,1-.61.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M314.32,142.6c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,314.32,142.6Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.27a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,310.18,140.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M321,156l-1.79-1v-5.62l0-.91,0-1a4.29,4.29,0,0,1-.61.31l-1,.34-.86-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M312.87,158.67l-1.79-1V152l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M322.49,164c0,1.7-.25,2.81-.73,3.35s-1.23.51-2.24-.07a5.27,5.27,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,322.49,164Zm-4.14-2.39a10.93,10.93,0,0,0,.26,2.72,2.12,2.12,0,0,0,.91,1.3q.63.36.9-.27a6.62,6.62,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.13,2.13,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,318.35,161.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M312.87,96.65l-1.79-1V90l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.34L308.67,87l2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M322.49,102c0,1.7-.25,2.81-.73,3.35s-1.23.51-2.24-.07a5.27,5.27,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.29,5.29,0,0,1,2.22,2.56A10.28,10.28,0,0,1,322.49,102Zm-4.14-2.39a10.93,10.93,0,0,0,.26,2.72,2.12,2.12,0,0,0,.91,1.3q.63.36.9-.27a6.62,6.62,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.13,2.13,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,318.35,99.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M314.32,166.69c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.41,10.41,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.29,5.29,0,0,1,2.22,2.56A10.28,10.28,0,0,1,314.32,166.69Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.25.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,310.18,164.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M321,180.1l-1.79-1v-5.62l0-.91,0-1a4.29,4.29,0,0,1-.61.31l-1,.34-.86-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M257,79.18c0,1.7-.25,2.82-.73,3.35S255,83,254,82.46a5.32,5.32,0,0,1-2.21-2.54,10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07A5.33,5.33,0,0,1,256.2,75,10.31,10.31,0,0,1,257,79.18Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3q.63.36.9-.27a6.62,6.62,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,252.81,76.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M264.89,84.22l-1.79-1V77.57l0-.92,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.87-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M274.33,82.66l-1.79-1V76l0-.91,0-1a4.29,4.29,0,0,1-.61.31l-1,.34L270.13,73l2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M284.92,74.76c0,1.69-.24,2.81-.72,3.34S283,78.62,282,78a5.24,5.24,0,0,1-2.21-2.53,10.28,10.28,0,0,1-.75-4.16c0-1.71.24-2.84.73-3.37S281,67.46,282,68a5.37,5.37,0,0,1,2.21,2.56A10.36,10.36,0,0,1,284.92,74.76Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.05,2.05,0,0,0,.91,1.3c.41.24.72.15.9-.26a6.7,6.7,0,0,0,.28-2.39,10.44,10.44,0,0,0-.28-2.73,2.1,2.1,0,0,0-.9-1.3c-.42-.25-.72-.16-.91.26A7,7,0,0,0,280.78,72.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M293.57,104.77l-1.79-1V98.12l0-.92,0-1a3.74,3.74,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M305.27,100.79c0,1.7-.25,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,305.27,100.79Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.24.72.16.91-.26a7,7,0,0,0,.27-2.39A10,10,0,0,0,303.2,97a2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,301.13,98.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M255.5,95.25l-1.79-1V88.6l0-.92,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M266.34,92.25c0,1.69-.24,2.81-.73,3.34s-1.23.52-2.24-.06A5.36,5.36,0,0,1,261.16,93a10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,266.34,92.25Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,9.93,9.93,0,0,0-.28-2.73,2,2,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,262.2,89.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M255.5,68.4l-1.79-1V61.74l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M266.34,65.39c0,1.7-.24,2.82-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.33,5.33,0,0,1,2.22,2.56A10.28,10.28,0,0,1,266.34,65.39ZM262.2,63a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.27a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,262.2,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M274.33,94.7l-1.79-1V88.05l0-.92,0-1a4.74,4.74,0,0,1-.61.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M283.47,90.82l-1.79-1V84.17l0-.91,0-1a3.38,3.38,0,0,1-.62.31l-1,.34-.86-1.73,2.72-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M274.33,157.16l-1.79-1v-5.62l0-.92,0-1a4.29,4.29,0,0,1-.61.31l-1,.34-.86-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M283.47,153.28l-1.79-1v-5.62l0-.92,0-1a4.23,4.23,0,0,1-.62.31l-1,.34-.86-1.73,2.72-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M295,111.82c0,1.69-.24,2.81-.73,3.34s-1.23.52-2.24-.07a5.34,5.34,0,0,1-2.21-2.53,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.36,10.36,0,0,1,295,111.82Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,9.93,9.93,0,0,0-.28-2.73,2,2,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.25A7.1,7.1,0,0,0,290.88,109.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M303.82,116.86l-1.79-1V110.2l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M255.5,107.29l-1.79-1v-5.62l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M266.34,104.29c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.41,10.41,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,266.34,104.29Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.25.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,262.2,101.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M274.33,106.75l-1.79-1v-5.62l0-.91,0-1a4.29,4.29,0,0,1-.61.31l-1,.34-.86-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M284.92,98.85c0,1.69-.24,2.81-.72,3.34s-1.24.52-2.24-.07a5.24,5.24,0,0,1-2.21-2.53,10.28,10.28,0,0,1-.75-4.16c0-1.71.24-2.84.73-3.37s1.22-.52,2.23.07a5.3,5.3,0,0,1,2.21,2.55A10.36,10.36,0,0,1,284.92,98.85Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.91,1.3c.41.24.72.15.9-.26a6.7,6.7,0,0,0,.28-2.39,10.44,10.44,0,0,0-.28-2.73,2.1,2.1,0,0,0-.9-1.3c-.42-.25-.72-.16-.91.26A7,7,0,0,0,280.78,96.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M295,123.86c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.31,5.31,0,0,1,2.22,2.55A10.36,10.36,0,0,1,295,123.86Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.25.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,290.88,121.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M303.82,128.9l-1.79-1v-5.62l0-.92,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M257,115.32c0,1.7-.25,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,257,115.32Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.08,2.08,0,0,0,.9,1.29c.42.24.72.16.9-.26a6.66,6.66,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,252.81,112.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M264.89,120.36l-1.79-1V113.7l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M264.89,169.58l-1.79-1v-5.63l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.91,1.47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M274.33,118.79l-1.79-1v-5.62l0-.92,0-1a4.74,4.74,0,0,1-.61.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M284.92,110.89c0,1.7-.24,2.81-.72,3.35s-1.24.51-2.24-.07a5.22,5.22,0,0,1-2.21-2.54,10.25,10.25,0,0,1-.75-4.16c0-1.71.24-2.83.73-3.37s1.22-.51,2.23.07a5.34,5.34,0,0,1,2.21,2.55A10.36,10.36,0,0,1,284.92,110.89Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.08,2.08,0,0,0,.91,1.3c.41.24.72.15.9-.27a6.62,6.62,0,0,0,.28-2.39,10.44,10.44,0,0,0-.28-2.73,2.13,2.13,0,0,0-.9-1.3c-.42-.24-.72-.15-.91.26A7.07,7.07,0,0,0,280.78,108.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M293.57,140.91l-1.79-1v-5.62l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.33-.87-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M305.27,136.92c0,1.7-.25,2.82-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.37s1.23-.52,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.35,10.35,0,0,1,305.27,136.92Zm-4.14-2.39a10.33,10.33,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.4,10,10,0,0,0-.28-2.73,2.08,2.08,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,301.13,134.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M293.57,191.28l-1.79-1v-5.62l0-.92,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.87-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M305.27,187.3c0,1.7-.25,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,305.27,187.3Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.24.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,301.13,184.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M255.5,131.38l-1.79-1v-5.62l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M266.34,128.38c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.29,5.29,0,0,1,2.22,2.56A10.28,10.28,0,0,1,266.34,128.38ZM262.2,126a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.27a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,262.2,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M274.33,130.84l-1.79-1v-5.62l0-.91,0-1a4.29,4.29,0,0,1-.61.31l-1,.34-.86-1.74,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M283.47,127l-1.79-1V120.3l0-.91,0-1a4.23,4.23,0,0,1-.62.31l-1,.34-.86-1.74,2.72-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M295,148c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.31,5.31,0,0,1,2.22,2.55A10.36,10.36,0,0,1,295,148Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.27a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,290.88,145.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M303.82,153,302,152v-5.62l0-.92,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M257,139.41c0,1.7-.25,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54A10.43,10.43,0,0,1,251,136c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,257,139.41ZM252.81,137a10.38,10.38,0,0,0,.27,2.72A2.08,2.08,0,0,0,254,141c.42.24.72.16.9-.26a6.66,6.66,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,252.81,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M266.34,140.43c0,1.69-.24,2.81-.73,3.34s-1.23.52-2.24-.06a5.36,5.36,0,0,1-2.21-2.54,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,266.34,140.43ZM262.2,138a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2,2,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,262.2,138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M274.33,142.88l-1.79-1v-5.62l0-.92,0-1a4.74,4.74,0,0,1-.61.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M284.92,135c0,1.7-.24,2.81-.72,3.35s-1.24.51-2.24-.07a5.22,5.22,0,0,1-2.21-2.54,10.23,10.23,0,0,1-.75-4.15c0-1.72.24-2.84.73-3.38s1.22-.51,2.23.07a5.34,5.34,0,0,1,2.21,2.55A10.36,10.36,0,0,1,284.92,135Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.08,2.08,0,0,0,.91,1.3c.41.24.72.15.9-.27a6.62,6.62,0,0,0,.28-2.39,10.44,10.44,0,0,0-.28-2.73,2.13,2.13,0,0,0-.9-1.3c-.42-.24-.72-.15-.91.26A7.07,7.07,0,0,0,280.78,132.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M284.92,173.8c0,1.69-.24,2.81-.72,3.34s-1.24.52-2.24-.07a5.24,5.24,0,0,1-2.21-2.53,10.28,10.28,0,0,1-.75-4.16c0-1.72.24-2.84.73-3.37s1.22-.52,2.23.06a5.37,5.37,0,0,1,2.21,2.56A10.36,10.36,0,0,1,284.92,173.8Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.91,1.3c.41.24.72.15.9-.26a6.7,6.7,0,0,0,.28-2.39,10.34,10.34,0,0,0-.28-2.73,2.15,2.15,0,0,0-.9-1.31c-.42-.24-.72-.15-.91.26A7.1,7.1,0,0,0,280.78,171.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M275.74,178.08c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.31,5.31,0,0,1,2.22,2.55A10.36,10.36,0,0,1,275.74,178.08Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.25.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,271.6,175.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M295,160c0,1.69-.24,2.81-.73,3.34s-1.23.52-2.24-.07a5.34,5.34,0,0,1-2.21-2.53,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.36,10.36,0,0,1,295,160Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2,2,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.26A7,7,0,0,0,290.88,157.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M303.82,165,302,164v-5.62l0-.91,0-1a6.75,6.75,0,0,1-.62.31l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M216.57,135.44l-1.79-1v-5.62l0-.91,0-1a3.78,3.78,0,0,1-.62.31l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M227.14,132.28c0,1.7-.25,2.82-.73,3.35s-1.23.51-2.24-.07A5.27,5.27,0,0,1,222,133a10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.33,5.33,0,0,1,2.22,2.56A10.31,10.31,0,0,1,227.14,132.28ZM223,129.89a10.33,10.33,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3q.63.36.9-.27a6.62,6.62,0,0,0,.28-2.39,10,10,0,0,0-.28-2.73,2.16,2.16,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,223,129.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M199.88,118.63c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,199.88,118.63Zm-4.14-2.39A10.38,10.38,0,0,0,196,119a2.06,2.06,0,0,0,.9,1.29c.42.24.72.16.91-.26a7,7,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,195.74,116.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M207.55,123.52l-1.79-1v-5.63l0-.91,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.87-1.74,2.73-.91,1.47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M237.26,138.28c0,1.7-.24,2.82-.73,3.35s-1.23.51-2.24-.07a5.34,5.34,0,0,1-2.21-2.53,10.46,10.46,0,0,1-.74-4.16c0-1.72.24-2.84.72-3.37s1.23-.52,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.35,10.35,0,0,1,237.26,138.28Zm-4.14-2.39a10.33,10.33,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.4,9.9,9.9,0,0,0-.28-2.72,2.08,2.08,0,0,0-.9-1.31c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,233.12,135.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M245.23,144.35l-1.78-1v-6.53l0-1a5.65,5.65,0,0,1-.62.31l-1,.33L241,134.7l2.72-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M314.32,179.1c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.36,5.36,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.07a5.26,5.26,0,0,1,2.22,2.55A10.36,10.36,0,0,1,314.32,179.1Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.24.72.16.91-.26a7,7,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7,7,0,0,0,310.18,176.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M321,192.51l-1.79-1v-5.62l0-.91,0-1a4.74,4.74,0,0,1-.61.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M274.33,169.57l-1.79-1v-5.63l0-.91,0-1a4.29,4.29,0,0,1-.61.31l-1,.34-.86-1.74,2.73-.91,1.47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M283.47,165.69l-1.79-1V159l0-.91,0-1a4.23,4.23,0,0,1-.62.31l-1,.34-.86-1.74,2.72-.91,1.47.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M257,151.82c0,1.69-.25,2.81-.73,3.34s-1.23.52-2.24-.07a5.34,5.34,0,0,1-2.21-2.53,10.46,10.46,0,0,1-.74-4.16c0-1.71.24-2.84.72-3.37s1.23-.51,2.23.06a5.33,5.33,0,0,1,2.22,2.56A10.36,10.36,0,0,1,257,151.82Zm-4.14-2.39a10.3,10.3,0,0,0,.27,2.71,2.08,2.08,0,0,0,.9,1.3c.42.24.72.15.9-.26a6.7,6.7,0,0,0,.28-2.39,9.93,9.93,0,0,0-.28-2.73,2,2,0,0,0-.9-1.3c-.42-.25-.72-.16-.9.25A7.1,7.1,0,0,0,252.81,149.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M266.34,152.83c0,1.7-.24,2.82-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.33,5.33,0,0,1,2.22,2.56A10.35,10.35,0,0,1,266.34,152.83Zm-4.14-2.39a10.33,10.33,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.26a7,7,0,0,0,.27-2.4,10,10,0,0,0-.28-2.73,2.08,2.08,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,262.2,150.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M295,172.4c0,1.7-.24,2.82-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.37,10.37,0,0,1-.74-4.15c0-1.72.24-2.84.72-3.38s1.23-.51,2.23.07a5.33,5.33,0,0,1,2.22,2.56A10.31,10.31,0,0,1,295,172.4ZM290.88,170a10.38,10.38,0,0,0,.27,2.72,2.11,2.11,0,0,0,.9,1.3c.42.24.72.15.91-.27a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.08,2.08,0,0,0-.9-1.3c-.42-.24-.72-.15-.9.26A7.07,7.07,0,0,0,290.88,170Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M303.82,177.44l-1.79-1v-5.62l0-.91,0-1a5.38,5.38,0,0,1-.62.32l-1,.33-.86-1.73,2.73-.92,1.47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M295,85.55c0,1.7-.24,2.81-.73,3.35s-1.23.51-2.24-.07a5.32,5.32,0,0,1-2.21-2.54,10.43,10.43,0,0,1-.74-4.16c0-1.71.24-2.83.72-3.37s1.23-.51,2.23.07a5.31,5.31,0,0,1,2.22,2.55A10.36,10.36,0,0,1,295,85.55Zm-4.14-2.39a10.38,10.38,0,0,0,.27,2.72,2.06,2.06,0,0,0,.9,1.29c.42.25.72.16.91-.26a6.93,6.93,0,0,0,.27-2.39,10,10,0,0,0-.28-2.73,2.05,2.05,0,0,0-.9-1.3c-.42-.24-.72-.16-.9.26A7.07,7.07,0,0,0,290.88,83.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M303.82,90.59l-1.79-1V83.94l0-.92,0-1a4.81,4.81,0,0,1-.62.31l-1,.34-.86-1.74,2.73-.91,1.47.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.75,73.87c-7.14-4.12-12.92-.82-12.92,7.37v65.34c0,8.19,5.78,18.17,12.92,22.29l60.93,35.51c7.14,4.12,15.78.37,15.78-7.82V131.21c0-8.18-8.64-17.71-15.78-21.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M193.15,74.88c-7.1-4.1-12.85-.82-12.85,7.33v64.44c0,8.15,5.75,18.08,12.85,22.18l60.11,35c7.1,4.1,15.46.41,15.46-7.74V131.68c0-8.15-8.36-17.66-15.46-21.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M193.56,75.89c-7.07-4.08-12.79-.81-12.79,7.3v63.52c0,8.11,5.72,18,12.79,22.07l59.28,34.56c7.07,4.08,15.13.45,15.13-7.66V132.15c0-8.11-8.06-17.62-15.13-21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M194,76.9c-7-4.06-12.74-.81-12.74,7.26v62.62c0,8.07,5.7,17.9,12.74,22l58.45,34.09c7,4.06,14.81.48,14.81-7.59V132.62c0-8.07-7.78-17.57-14.81-21.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M194.37,77.91c-7-4-12.67-.81-12.67,7.22v61.72c0,8,5.68,17.81,12.67,21.85L252,202.31c7,4,14.49.52,14.49-7.51V133.09c0-8-7.5-17.53-14.49-21.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M194.78,78.92c-7-4-12.61-.8-12.61,7.19v60.8c0,8,5.65,17.73,12.61,21.75l56.8,33.13c7,4,14.16.56,14.16-7.43V133.55c0-8-7.2-17.47-14.16-21.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M195.19,79.93c-6.93-4-12.55-.8-12.55,7.15V147c0,8,5.62,17.63,12.55,21.63l56,32.67c6.93,4,13.85.59,13.85-7.36V134c0-8-6.92-17.43-13.85-21.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M195.59,80.94c-6.89-4-12.48-.79-12.48,7.12v59c0,7.9,5.59,17.54,12.48,21.52l55.14,32.19c6.9,4,13.52.63,13.52-7.28v-59c0-7.91-6.62-17.38-13.52-21.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M196,82c-6.86-4-12.42-.79-12.42,7.08v58.08c0,7.87,5.56,17.46,12.42,21.42l54.31,31.71c6.86,4,13.2.67,13.2-7.2V135c0-7.87-6.34-17.34-13.2-21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M196.4,83c-6.82-3.94-12.35-.78-12.35,7v57.18c0,7.83,5.53,17.37,12.35,21.31l53.49,31.23c6.82,3.94,12.87.71,12.87-7.12V135.43c0-7.83-6.05-17.29-12.87-21.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M196.81,84c-6.79-3.92-12.29-.78-12.29,7v56.26c0,7.79,5.5,17.29,12.29,21.2l52.66,30.77c6.79,3.92,12.55.74,12.55-7.05V135.89c0-7.79-5.76-17.24-12.55-21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M197.22,85c-6.76-3.9-12.23-.78-12.23,7v55.36c0,7.75,5.47,17.19,12.23,21.09l51.83,30.29c6.75,3.9,12.23.78,12.23-7V136.36c0-7.75-5.48-17.19-12.23-21.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249,267.25a12.32,12.32,0,0,1-6.12-1.47l-65.38-38-65.38-38a6.45,6.45,0,0,1-3.51-5.6c0-2.48,1.54-4.8,4.22-6.35l1.21-9.9a15,15,0,0,1,7.43-1.89,12.32,12.32,0,0,1,6.12,1.47l70.29,40.18,70.29,40.19a6.46,6.46,0,0,1,3.51,5.59c0,2.48-1.54,4.8-4.23,6.35l-11,5.62A15,15,0,0,1,249,267.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M114.11,168.5a16.17,16.17,0,0,1,7.3-1.95,12.07,12.07,0,0,1,6.09,1.34c.08,0,4.05,2.24,4.1,2.27l65.9,37.69,5,2.87,65,37.15a6.82,6.82,0,0,1,3.61,5.48c.06,2.43-1.37,4.75-4.06,6.31l-5.9,3c-.07,0-5,2.52-5,2.53a14.89,14.89,0,0,1-7.32,1.75,12.58,12.58,0,0,1-6.05-1.53l-64.95-37.77-4.29-2.5-60.65-35.27a6.65,6.65,0,0,1-3.59-5.47,7.07,7.07,0,0,1,3.74-6.21l.12-1.46C113,176.71,114,168.58,114.11,168.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M114.16,169.16a17.76,17.76,0,0,1,7.17-2,11.79,11.79,0,0,1,6.07,1.21c.15,0,4,2.15,4.1,2.21l65.61,37.53,5,2.86,64.68,37a7.16,7.16,0,0,1,3.7,5.36c.12,2.39-1.19,4.71-3.9,6.28l-5.83,3.06c-.13.07-4.86,2.45-5,2.46a14.66,14.66,0,0,1-7.21,1.62,13.07,13.07,0,0,1-6-1.59L178,227.64l-4.26-2.48-60.24-35c-2-1.17-3.67-3.3-3.67-5.35a6.71,6.71,0,0,1,3.26-6.07l.06-1.41A44.68,44.68,0,0,1,114.16,169.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M114.21,169.82a19.24,19.24,0,0,1,7-2.08,11.56,11.56,0,0,1,6,1.07c.22,0,3.94,2.05,4.1,2.14l65.33,37.38,5,2.84L266.08,248c1.91,1.11,3.64,3.31,3.79,5.24.17,2.36-1,4.68-3.73,6.25l-5.78,3.07c-.19.11-4.75,2.39-5,2.4a14.39,14.39,0,0,1-7.1,1.49,13.51,13.51,0,0,1-5.92-1.65l-64.07-37.23L174,225.13l-59.83-34.77c-1.91-1.11-3.75-3.28-3.75-5.22,0-2.13.47-4.6,2.78-5.93v-1.38C112.88,177.63,113.8,170.06,114.21,169.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M114.26,170.48a21.16,21.16,0,0,1,6.91-2.15,11.42,11.42,0,0,1,6,.93c.3,0,3.9,2,4.11,2.08l65,37.23,5,2.83,64.11,36.7c1.8,1,3.69,3.3,3.88,5.12.23,2.32-.84,4.64-3.56,6.21L260,262.51c-.25.15-4.66,2.33-5,2.35a14.22,14.22,0,0,1-7,1.35,13.91,13.91,0,0,1-5.85-1.71l-63.64-37-4.21-2.45L114.9,190.58c-1.81-1-3.83-3.26-3.83-5.1,0-2,.12-4.53,2.29-5.79l-.06-1.33C112.82,178.09,113.71,170.8,114.26,170.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M114.31,171.14a23.47,23.47,0,0,1,6.78-2.21,11.13,11.13,0,0,1,6,.79,37.28,37.28,0,0,1,4.11,2l64.74,37.07,4.92,2.82,63.82,36.54c1.7,1,3.75,3.3,4,5,.29,2.29-.66,4.6-3.39,6.18l-5.66,3.09c-.32.18-4.56,2.25-5,2.28a14,14,0,0,1-6.88,1.22,14.62,14.62,0,0,1-5.79-1.77l-63.2-36.69-4.18-2.43-59-34.26c-1.7-1-3.91-3.24-3.9-5,0-1.89-.24-4.47,1.8-5.65l-.13-1.3C112.77,178.54,113.63,171.53,114.31,171.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M114.36,171.8a27,27,0,0,1,6.65-2.28,11,11,0,0,1,6,.66,31.63,31.63,0,0,1,4.11,1.95l64.45,36.92,4.91,2.81L264,248.25c1.6.92,3.81,3.29,4.06,4.89.37,2.27-.47,4.56-3.21,6.14l-5.6,3.1a48.57,48.57,0,0,1-4.93,2.23,13.78,13.78,0,0,1-6.77,1.08,15.1,15.1,0,0,1-5.72-1.83L179,227.44,174.88,225l-58.6-34c-1.59-.92-4-3.23-4-4.85s-.6-4.4,1.32-5.51l-.19-1.25C112.72,179,113.54,172.27,114.36,171.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M114.41,172.46a30.89,30.89,0,0,1,6.52-2.35,10.72,10.72,0,0,1,5.93.53,27,27,0,0,1,4.12,1.88l64.16,36.77,4.88,2.79,63.25,36.24c1.49.86,4.15,3.27,4.15,4.78.83,2.13-.3,4.51-3.05,6.1l-5.53,3.11a39.8,39.8,0,0,1-4.91,2.17,13.5,13.5,0,0,1-6.66.95,15.91,15.91,0,0,1-5.65-1.89l-62.33-36.15-4.13-2.4L117,191.24c-1.49-.86-4.06-3.21-4.06-4.72,0-1.66-1-4.34.84-5.37l-.25-1.22C112.67,179.46,113.45,173,114.41,172.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M114.46,173.11a36.72,36.72,0,0,1,6.39-2.4,10.53,10.53,0,0,1,5.91.39,23.38,23.38,0,0,1,4.11,1.81l63.88,36.62,4.86,2.78,63,36.09c1.38.8,4.24,3.25,4.24,4.66.95,2.08-.12,4.47-2.88,6.07l-5.48,3.12a35.22,35.22,0,0,1-4.88,2.11,13.3,13.3,0,0,1-6.55.81c-1.44,0-4.55-1.35-5.59-1.95l-61.89-35.88-4.1-2.38-57.78-33.5c-1.38-.8-4.14-3.19-4.14-4.59s-1.31-4.28.36-5.24l-.32-1.17C112.61,179.91,113.37,173.75,114.46,173.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M114.51,173.77a46.08,46.08,0,0,1,6.26-2.47,10.28,10.28,0,0,1,5.88.25,20.78,20.78,0,0,1,4.12,1.76l63.58,36.46,4.84,2.77,62.67,35.94c1.28.73,4.34,3.24,4.34,4.54,1.07,2,.06,4.43-2.71,6l-5.42,3.13a30.12,30.12,0,0,1-4.86,2.05,13,13,0,0,1-6.44.68c-1.33,0-4.57-1.46-5.52-2l-61.46-35.61-4.07-2.36-57.37-33.25c-1.27-.73-4.22-3.17-4.22-4.47s-1.66-4.21-.13-5.09l-.37-1.13C112.56,180.37,113.28,174.49,114.51,173.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M114.56,174.43a56.54,56.54,0,0,1,6.13-2.54,10.12,10.12,0,0,1,5.85.12,18.45,18.45,0,0,1,4.13,1.69L194,210l4.81,2.77,62.39,35.78c1.17.68,4.43,3.24,4.43,4.42,1.19,2,.23,4.4-2.54,6l-5.36,3.14a25.93,25.93,0,0,1-4.84,2,12.68,12.68,0,0,1-6.33.55c-1.22,0-4.58-1.56-5.45-2.07l-61-35.35-4-2.33-57-33c-1.16-.67-4.3-3.16-4.29-4.34s-2-4.15-.62-5l-.44-1.09C112.51,180.83,113.19,175.22,114.56,174.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M114.61,175.09c1-.58,4.81-2.15,6-2.6a9.9,9.9,0,0,1,5.83,0,17.17,17.17,0,0,1,4.12,1.62l63,36.15,4.8,2.75,62.1,35.64c1.06.61,4.52,3.22,4.52,4.3,1.31,1.94.41,4.36-2.38,6l-5.29,3.15a24.63,24.63,0,0,1-4.82,1.93,12.57,12.57,0,0,1-6.22.41c-1.11,0-4.59-1.67-5.39-2.13L180.3,227.18l-4-2.32-56.55-32.74c-1.07-.61-4.38-3.14-4.38-4.22s-2.38-4.08-1.1-4.81l-.5-1.05C112.45,181.28,113.11,176,114.61,175.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M114.66,175.75c.91-.52,4.81-2.22,5.87-2.67a9.66,9.66,0,0,1,5.8-.15,15,15,0,0,1,4.13,1.56l62.71,36,4.77,2.74,61.82,35.48c.95.56,4.61,3.22,4.61,4.19,1.43,1.89.59,4.32-2.21,5.93L256.93,262a21.84,21.84,0,0,1-4.8,1.87,12.12,12.12,0,0,1-6.11.28c-1,0-4.6-1.77-5.32-2.19l-60.15-34.81-4-2.3-56.14-32.49c-1-.55-4.46-3.12-4.46-4.09s-2.73-4-1.58-4.68l-.56-1C112.4,181.74,113,176.7,114.66,175.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M114.71,176.41c.81-.47,4.81-2.3,5.74-2.73a9.34,9.34,0,0,1,5.77-.29,13.78,13.78,0,0,1,4.14,1.49l62.42,35.84,4.75,2.73,61.52,35.33c.85.49,4.71,3.21,4.71,4.07,1.54,1.84.76,4.27-2,5.89l-5.18,3.17a19.76,19.76,0,0,1-4.77,1.82,11.88,11.88,0,0,1-6,.14c-.89,0-4.62-1.88-5.25-2.25L180.8,227.08l-4-2.28-55.73-32.23c-.85-.5-4.54-3.11-4.54-4s-3.09-3.94-2.06-4.53l-.63-1C112.35,182.2,112.93,177.44,114.71,176.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M114.76,177.07c.71-.41,4.82-2.39,5.61-2.8a9.16,9.16,0,0,1,5.74-.42,12.67,12.67,0,0,1,4.14,1.42L192.38,211l4.73,2.72,61.24,35.17c.75.43,4.8,3.2,4.8,4,1.66,1.79.94,4.23-1.87,5.86l-5.12,3.18a18,18,0,0,1-4.75,1.75,11.64,11.64,0,0,1-5.89,0c-.78,0-4.63-2-5.19-2.31L181.05,227l-3.92-2.26-55.32-32c-.75-.43-4.62-3.1-4.62-3.85s-3.44-3.88-2.55-4.4l-.68-.93C112.3,182.65,112.85,178.17,114.76,177.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M114.81,177.72c.61-.34,4.81-2.47,5.48-2.86,1.66-1,3.86-.84,5.72-.56a12.17,12.17,0,0,1,4.14,1.37L192,211.2l4.71,2.7,60.95,35c.64.37,4.89,3.19,4.89,3.84,1.78,1.73,1.12,4.19-1.71,5.82l-5,3.19a16.69,16.69,0,0,1-4.73,1.7,11.26,11.26,0,0,1-5.78-.13c-.67,0-4.64-2.09-5.12-2.37L181.3,227l-3.89-2.25L122.5,193c-.64-.37-4.7-3.08-4.7-3.73s-3.8-3.81-3-4.25l-.75-.89C112.24,183.11,112.76,178.91,114.81,177.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M114.86,178.38c.51-.29,4.71-2.92,5.35-2.92a11.75,11.75,0,0,1,5.69-.7,11.36,11.36,0,0,1,4.15,1.3l61.54,35.38,4.69,2.69L257,249c.53.3,5,3.18,5,3.72,1.9,1.68,1.29,4.15-1.54,5.78l-5,3.21a15.48,15.48,0,0,1-4.71,1.63,10.89,10.89,0,0,1-5.67-.26,38,38,0,0,1-5.06-2.43l-58.4-33.73-3.87-2.23-54.5-31.47c-.53-.31-4.77-3.06-4.77-3.6s-4.16-3.75-3.52-4.12l-.81-.85C112.19,183.57,112.67,179.65,114.86,178.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M114.91,179c.41-.23,4.71-3,5.22-3a11.76,11.76,0,0,1,5.66-.83,10.61,10.61,0,0,1,4.15,1.23l61.26,35.23,4.67,2.68,60.37,34.72c.43.25,5.08,3.17,5.08,3.6,2,1.64,1.47,4.12-1.37,5.76L255,261.65a14.2,14.2,0,0,1-4.69,1.57,10.61,10.61,0,0,1-5.56-.39,47.29,47.29,0,0,1-5-2.48l-58-33.47L178,224.67l-54.09-31.22c-.42-.25-4.85-3-4.85-3.48s-4.51-3.68-4-4l-.88-.81C112.14,184,112.59,180.39,114.91,179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M115,179.7c.31-.17,4.7-3.06,5.09-3.06a11.66,11.66,0,0,1,5.64-1,9.94,9.94,0,0,1,4.15,1.16l61,35.08,4.64,2.67,60.09,34.57c.32.18,5.17,3.16,5.17,3.48,2.13,1.59,1.65,4.08-1.2,5.72l-4.88,3.22A13.31,13.31,0,0,1,250,263.1a10.22,10.22,0,0,1-5.45-.53c-.34,0-4.68-2.41-4.92-2.54l-57.54-33.2-3.81-2.19-53.68-31c-.32-.19-4.93-3-4.93-3.35s-4.87-3.62-4.48-3.84l-.94-.77C112.08,184.48,112.5,181.12,115,179.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M115,180.36c.21-.12,4.7-3.12,5-3.12a11.43,11.43,0,0,1,5.61-1.1,9.29,9.29,0,0,1,4.16,1.1l60.67,34.92,4.62,2.66,59.81,34.41c.21.13,5.26,3.16,5.26,3.37,2.25,1.54,1.82,4-1,5.68l-4.81,3.24a12.48,12.48,0,0,1-4.64,1.45,9.84,9.84,0,0,1-5.34-.66c-.23,0-4.7-2.51-4.86-2.6l-57.1-32.93-3.78-2.18-53.27-30.71c-.21-.12-5-3-5-3.23s-5.22-3.55-5-3.69l-1-.73C112,184.94,112.41,181.86,115,180.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M115.07,181c.1-.06,4.69-3.19,4.82-3.19a11.51,11.51,0,0,1,5.58-1.24,9,9,0,0,1,4.16,1L190,212.39l4.6,2.65,59.52,34.27c.1.06,5.35,3.14,5.35,3.25,2.37,1.49,2,4-.87,5.65l-4.75,3.24a11.75,11.75,0,0,1-4.62,1.4,9.62,9.62,0,0,1-5.23-.8c-.11,0-4.71-2.62-4.79-2.66l-56.66-32.66-3.76-2.16L126,194.11c-.1-.06-5.09-3-5.09-3.1s-5.58-3.49-5.45-3.56l-1.06-.69C112,185.39,112.32,182.6,115.07,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M243.77,261.79l-64.68-37.25-64.67-37.25c-2.49-1.44-2.18-3.95.7-5.61l4.69-3.25c2.87-1.67,7.23-1.85,9.72-.41l64.67,37.25,64.68,37.25c2.49,1.44,2.18,4-.7,5.61l-4.69,3.25C250.61,263,246.26,263.22,243.77,261.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M244.17,260.83l-126-72.53c-7.17-4.14-13-15.25-13-24.81V56.18c0-9.56,5.81-14,13-9.82l126,72.53c7.17,4.14,13,15.25,13,24.82V251C257.16,260.57,251.34,265,244.17,260.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M248,256.6,119.65,182.78c-6-3.78-9.63-11.34-9.63-19.07V52.39a2.37,2.37,0,0,1,3.57-2l.42.25,128.46,73.93c7.08,4.08,9.63,11.34,9.63,19.07v111a2.56,2.56,0,0,1-3.83,2.22A2.35,2.35,0,0,1,248,256.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M242.47,124.52,114,50.59l-.42-.25a2.37,2.37,0,0,0-3.57,2V163.71c0,7.73,3.68,15.29,9.63,19.07L248,256.6a2.35,2.35,0,0,0,.31.18,2.56,2.56,0,0,0,3.83-2.22v-111C252.1,135.86,249.55,128.6,242.47,124.52Zm8.13,130a1.07,1.07,0,0,1-1.07,1.06,1.1,1.1,0,0,1-.52-.14l-128.61-74c-5.37-3.42-8.88-10.4-8.88-17.77V52.39a.88.88,0,0,1,.88-.87.85.85,0,0,1,.43.12l128.89,74.18c7.34,4.23,8.88,12,8.88,17.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M250.15,115.42l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.11-.27.1-6.19,3.54-6.44,3.68h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,6.4-3.83,6.55-3.94,2.47-1.72,4-5.28,4-10.19V140.23C263.14,130.67,257.32,119.56,250.15,115.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M250,115.49,124,43c-2.84-1.63-5.46-1.94-7.6-1.11-.27.1-6.08,3.47-6.33,3.61h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,6.29-3.75,6.44-3.86,2.47-1.73,4-5.28,4-10.2V140.31C263,130.74,257.21,119.63,250,115.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M249.93,115.56,123.89,43c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-6,3.4-6.22,3.54h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,6.18-3.68,6.33-3.79,2.47-1.73,4-5.28,4-10.2V140.38C262.92,130.81,257.1,119.7,249.93,115.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M249.82,115.63l-126-72.52c-2.83-1.64-5.46-1.94-7.6-1.12-.27.11-5.86,3.33-6.11,3.47h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,6.07-3.61,6.23-3.72,2.46-1.73,4-5.28,4-10.19V140.45C262.81,130.89,257,119.78,249.82,115.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M249.71,115.71l-126-72.53c-2.83-1.64-5.46-1.94-7.6-1.11-.27.1-5.75,3.25-6,3.39h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,6-3.54,6.12-3.65,2.46-1.73,4-5.28,4-10.19V140.52C262.7,131,256.88,119.85,249.71,115.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M249.6,115.78l-126-72.53c-2.83-1.64-5.46-1.94-7.6-1.11-.27.1-5.64,3.18-5.89,3.32h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5.85-3.47,6-3.58,2.46-1.72,4-5.27,4-10.19V140.6C262.59,131,256.77,119.92,249.6,115.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M249.49,115.85l-126-72.53c-2.84-1.63-5.47-1.94-7.6-1.11-.28.1-5.54,3.11-5.79,3.25h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5.74-3.39,5.9-3.5,2.46-1.73,4-5.28,4-10.2V140.67C262.48,131.1,256.67,120,249.49,115.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M249.38,115.92l-126-72.52c-2.84-1.64-5.47-1.94-7.6-1.12-.28.11-5.43,3-5.68,3.18h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5.63-3.32,5.79-3.43,2.46-1.73,4-5.28,4-10.2V140.74C262.37,131.18,256.56,120.07,249.38,115.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M249.27,116l-126-72.53c-2.84-1.64-5.47-1.94-7.6-1.12-.28.11-5.32,3-5.57,3.11h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5.52-3.25,5.68-3.36,2.47-1.73,4-5.28,4-10.19V140.81C262.26,131.25,256.45,120.14,249.27,116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M249.16,116.07l-126-72.53c-2.84-1.64-5.47-1.94-7.6-1.11-.27.1-5.21,2.89-5.46,3h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5.41-3.18,5.57-3.29,2.47-1.73,4-5.28,4-10.19V140.88C262.15,131.32,256.34,120.21,249.16,116.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M249.05,116.14,123,43.61c-2.84-1.63-5.47-1.94-7.6-1.11-.27.1-5.1,2.82-5.35,3h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5.3-3.11,5.46-3.22,2.47-1.72,4-5.27,4-10.19V141C262,131.39,256.23,120.28,249.05,116.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M249,116.21l-126-72.52c-2.84-1.64-5.47-1.95-7.6-1.12-.27.11-5,2.75-5.24,2.89h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5.19-3,5.35-3.14,2.47-1.73,4-5.28,4-10.2V141C261.93,131.46,256.12,120.35,249,116.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M248.84,116.28l-126-72.52c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-4.88,2.68-5.13,2.82h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5.08-3,5.24-3.07,2.47-1.73,4-5.28,4-10.2V141.1C261.82,131.54,256,120.43,248.84,116.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M248.73,116.36l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-4.77,2.61-5,2.75h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,5-2.89,5.13-3,2.47-1.73,4-5.28,4-10.19V141.17C261.71,131.61,255.9,120.5,248.73,116.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M248.62,116.43l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.11-.27.1-4.66,2.53-4.91,2.67h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,4.87-2.82,5-2.93,2.47-1.72,4-5.28,4-10.19V141.24C261.61,131.68,255.79,120.57,248.62,116.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M248.51,116.5,122.47,44c-2.84-1.63-5.46-1.94-7.6-1.11-.27.1-4.55,2.46-4.8,2.6h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,4.76-2.74,4.91-2.85,2.47-1.73,4-5.28,4-10.2V141.32C261.5,131.75,255.68,120.64,248.51,116.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M248.4,116.57l-126-72.52c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-4.44,2.39-4.69,2.53h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,4.65-2.67,4.8-2.78,2.47-1.73,4-5.28,4-10.2V141.39C261.39,131.82,255.57,120.71,248.4,116.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M248.29,116.65l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-4.33,2.32-4.58,2.46h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,4.54-2.6,4.69-2.71,2.47-1.73,4-5.28,4-10.19V141.46C261.28,131.9,255.46,120.79,248.29,116.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M248.18,116.72l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.11-.27.1-4.22,2.24-4.47,2.38h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,4.43-2.53,4.58-2.64,2.47-1.73,4-5.28,4-10.19V141.53C261.17,132,255.35,120.86,248.18,116.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M248.07,116.79,122,44.26c-2.83-1.64-5.46-1.94-7.6-1.11-.27.1-4.11,2.17-4.36,2.31h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,4.32-2.46,4.47-2.57,2.47-1.72,4-5.27,4-10.19V141.61C261.06,132,255.24,120.93,248.07,116.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M248,116.86l-126-72.52c-2.83-1.64-5.46-2-7.6-1.12-.27.1-4,2.1-4.25,2.24h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,4.21-2.38,4.37-2.49,2.46-1.73,4-5.28,4-10.2V141.68C261,132.11,255.13,121,248,116.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M247.85,116.93l-126-72.52c-2.83-1.64-5.46-1.94-7.6-1.12-.27.11-3.89,2-4.14,2.17h0c2.22-1.07,5-.87,8.08.89l126,72.53c7.17,4.14,13,15.25,13,24.82V251c0,6-2.27,9.92-5.71,11.05a2.21,2.21,0,0,0,1.13-.39c.17-.09,4.1-2.31,4.26-2.42,2.46-1.73,4-5.28,4-10.2V141.75C260.84,132.19,255,121.08,247.85,116.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M244.79,118.58l-126-72.53c-2.94-1.7-5.65-1.94-7.83-1a9.65,9.65,0,0,1,6.27,1.47l126,72.53c7.17,4.14,13,15.25,13,24.81V251.17c0,5.64-2,9.46-5.16,10.81,4-.63,6.72-4.75,6.72-11.28V143.39C257.78,133.83,252,122.72,244.79,118.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "172.81 135.35 172.81 132.94 154.32 122.48 154.32 124.88 172.81 135.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "130.02 93.66 130.02 96.07 179.11 124.05 179.11 121.64 130.02 93.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "160.52 121.08 130.02 103.5 130.02 105.9 160.52 123.49 160.52 121.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "151.06 110.62 130.02 98.49 130.02 100.9 151.06 113.03 151.06 110.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "153.43 111.99 153.43 114.39 207.62 145.19 207.62 142.78 153.43 111.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "162.89 122.45 162.89 124.86 190.3 140.56 190.3 138.15 162.89 122.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "209.99 146.56 227.49 156.58 227.49 154.18 209.99 144.15 209.99 146.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "192.67 141.93 243.35 170.51 243.35 168.11 192.67 139.52 192.67 141.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "151.95 121.11 130.02 108.47 130.02 110.88 151.95 123.52 151.95 121.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "175.18 136.72 194.1 147.51 194.1 145.11 175.18 134.31 175.18 136.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "172.81 113.72 172.81 111.31 154.32 100.84 154.32 103.25 172.81 113.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "123.15 68.11 123.15 70.52 179.11 102.41 179.11 100 123.15 68.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "160.52 99.45 123.15 77.94 123.15 80.35 160.52 101.86 160.52 99.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "151.06 88.98 123.15 72.94 123.15 75.35 151.06 91.39 151.06 88.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "153.43 90.35 153.43 92.76 207.62 123.56 207.62 121.15 153.43 90.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "162.89 100.81 162.89 103.22 190.3 118.92 190.3 116.51 162.89 100.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "209.99 124.92 243.35 143.88 243.35 141.47 209.99 122.52 209.99 124.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "192.67 120.29 227.49 139.95 227.49 137.54 192.67 117.88 192.67 120.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "151.95 99.47 123.15 82.92 123.15 85.33 151.95 101.88 151.95 99.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "175.18 115.08 194.1 125.88 194.1 123.47 175.18 112.68 175.18 115.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "175.65 158.68 175.65 156.27 154.32 144.12 154.32 146.53 175.65 158.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "137.02 119.33 137.02 121.74 179.11 145.69 179.11 143.28 137.02 119.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "160.52 142.72 137.02 129.16 137.02 131.57 160.52 145.13 160.52 142.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "143.78 128.18 137.02 124.16 137.02 126.57 143.78 130.58 143.78 128.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "146.16 129.54 146.16 131.95 207.62 166.83 207.62 164.42 146.16 129.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "162.89 144.09 162.89 146.5 182.66 157.93 182.66 155.52 162.89 144.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "209.99 168.2 243.35 187.15 243.35 184.74 209.99 165.79 209.99 168.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "185.03 159.3 218.85 178.21 218.85 175.8 185.03 156.89 185.03 159.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "151.95 142.75 137.02 134.14 137.02 136.54 151.95 145.16 151.95 142.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "178.02 160.04 209.85 178.04 209.85 175.64 178.02 157.64 178.02 160.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "172.81 178.85 172.81 176.44 154.32 165.98 154.32 168.38 172.81 178.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "130.02 137.16 130.02 139.57 179.11 167.55 179.11 165.14 130.02 137.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "160.52 164.58 130.02 147 130.02 149.4 160.52 166.99 160.52 164.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "151.06 154.12 130.02 141.99 130.02 144.4 151.06 156.53 151.06 154.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "153.43 155.49 153.43 157.89 207.62 188.69 207.62 186.28 153.43 155.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "162.89 165.95 162.89 168.36 190.3 184.06 190.3 181.65 162.89 165.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "209.99 190.06 227.49 200.08 227.49 197.68 209.99 187.65 209.99 190.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "192.67 185.43 243.35 214.01 243.35 211.61 192.67 183.02 192.67 185.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "151.95 164.61 130.02 151.97 130.02 154.38 151.95 167.02 151.95 164.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "175.18 180.22 194.1 191.01 194.1 188.61 175.18 177.81 175.18 180.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "172.81 200.49 172.81 198.08 154.32 187.62 154.32 190.03 172.81 200.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "123.15 154.89 123.15 157.29 179.11 189.19 179.11 186.78 123.15 154.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "160.52 186.22 123.15 164.72 123.15 167.13 160.52 188.63 160.52 186.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "143.78 171.68 123.15 159.72 123.15 162.12 143.78 174.08 143.78 171.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "146.16 173.04 146.16 175.45 207.62 210.33 207.62 207.92 146.16 173.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "162.89 187.59 162.89 190 182.66 201.43 182.66 199.02 162.89 187.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "209.99 211.7 243.35 230.65 243.35 228.24 209.99 209.29 209.99 211.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "185.03 202.8 213.04 218.48 213.04 216.07 185.03 200.39 185.03 202.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "151.95 186.25 123.15 169.69 123.15 172.1 151.95 188.66 151.95 186.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "175.18 201.86 194.1 212.65 194.1 210.25 175.18 199.45 175.18 201.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 103.71 120.93 105.74 120.93 103.33 117.4 101.3 117.4 103.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 98.74 120.93 100.77 120.93 98.36 117.4 96.33 117.4 98.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 115.37 120.93 117.41 120.93 115.01 117.4 112.97 117.4 115.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 110.54 120.93 112.56 120.93 110.15 117.4 108.14 117.4 110.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 93.73 120.93 95.76 120.93 93.35 117.4 91.33 117.4 93.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 88.9 120.93 90.92 120.93 88.51 117.4 86.5 117.4 88.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 120.38 120.93 122.41 120.93 120 117.4 117.97 117.4 120.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 72.1 120.93 74.12 120.93 71.72 117.4 69.69 117.4 72.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 77.1 120.93 79.13 120.93 76.72 117.4 74.69 117.4 77.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 82.08 120.93 84.1 120.93 81.69 117.4 79.67 117.4 82.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 67.27 120.93 69.28 120.93 66.87 117.4 64.86 117.4 67.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 158.87 120.93 160.91 120.93 158.51 117.4 156.47 117.4 158.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "120.93 168.47 117.4 166.44 117.4 168.85 120.93 170.88 120.93 168.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 161.47 117.4 163.88 120.93 165.91 120.93 163.5 117.4 161.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 154.04 120.93 156.06 120.93 153.65 117.4 151.64 117.4 154.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 125.35 120.93 127.38 120.93 124.97 117.4 122.94 117.4 125.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 137.23 120.93 139.26 120.93 136.85 117.4 134.82 117.4 137.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 147.21 120.93 149.24 120.93 146.83 117.4 144.8 117.4 147.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 132.4 120.93 134.41 120.93 132.01 117.4 130 117.4 132.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "117.4 142.24 120.93 144.26 120.93 141.86 117.4 139.83 117.4 142.24"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.92,114.78c-7.3-4.22-13.23-.84-13.23,7.54v66.9c0,8.38,5.93,18.6,13.23,22.82l62.39,36.35c7.31,4.22,16.16.38,16.16-8v-66.9c0-8.39-8.85-18.14-16.16-22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M117.34,115.81c-7.27-4.2-13.17-.84-13.17,7.51v66c0,8.34,5.9,18.51,13.17,22.7l61.54,35.87c7.27,4.2,15.82.42,15.82-7.92V174c0-8.35-8.55-18.09-15.82-22.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M117.75,116.85c-7.23-4.18-13.1-.84-13.1,7.46v65.05c0,8.3,5.87,18.41,13.1,22.59l60.7,35.39c7.23,4.17,15.49.45,15.49-7.85v-65c0-8.31-8.26-18-15.49-22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M118.17,117.88c-7.2-4.16-13-.83-13,7.43v64.11c0,8.26,5.84,18.33,13,22.49L178,246.81c7.2,4.15,15.17.49,15.17-7.77V174.92c0-8.26-8-18-15.17-22.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M118.59,118.91c-7.17-4.13-13-.82-13,7.4v63.18c0,8.22,5.81,18.24,13,22.37l59,34.42c7.17,4.13,14.84.53,14.84-7.69V175.4c0-8.22-7.67-17.94-14.84-22.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M119,120c-7.13-4.12-12.9-.82-12.9,7.36v62.25c0,8.18,5.77,18.15,12.9,22.26l58.15,33.93c7.13,4.11,14.51.56,14.51-7.61V175.88c0-8.18-7.38-17.89-14.51-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M119.42,121c-7.09-4.09-12.84-.81-12.84,7.32v61.33c0,8.14,5.75,18.05,12.84,22.15l57.3,33.44c7.09,4.09,14.17.6,14.17-7.53V176.36c0-8.14-7.08-17.84-14.17-21.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M119.83,122c-7-4.08-12.77-.82-12.77,7.28v60.4c0,8.09,5.72,18,12.77,22l56.46,33c7.06,4.07,13.84.64,13.84-7.46V176.84c0-8.1-6.78-17.8-13.84-21.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M120.25,123.05c-7-4-12.71-.81-12.71,7.25v59.46c0,8.06,5.69,17.88,12.71,21.93l55.61,32.47c7,4.05,13.51.68,13.51-7.38V177.32c0-8.06-6.49-17.75-13.51-21.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M120.67,124.08c-7-4-12.65-.8-12.65,7.22v58.53c0,8,5.66,17.78,12.65,21.82l54.76,32c7,4,13.18.72,13.18-7.3V177.8c0-8-6.2-17.7-13.18-21.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M121.08,125.12c-7-4-12.58-.8-12.58,7.17V189.9c0,8,5.63,17.69,12.58,21.7L175,243.1c6.95,4,12.85.76,12.85-7.22v-57.6c0-8-5.9-17.65-12.85-21.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M121.5,126.15c-6.92-4-12.52-.79-12.52,7.14V190c0,7.93,5.6,17.6,12.52,21.59l53.06,31c6.92,4,12.52.8,12.52-7.14V178.76c0-7.94-5.6-17.61-12.52-21.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.69,310.58a12.32,12.32,0,0,1-6.12-1.47l-65.38-38L38.8,233a6.48,6.48,0,0,1-3.51-5.59c0-2.49,1.54-4.8,4.23-6.35l1.21-9.91a15,15,0,0,1,7.43-1.89,12.21,12.21,0,0,1,6.12,1.48L124.57,251l70.28,40.18a6.48,6.48,0,0,1,3.51,5.59c0,2.49-1.54,4.8-4.22,6.35l-11,5.63A15.15,15.15,0,0,1,175.69,310.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M40.78,211.84a16.27,16.27,0,0,1,7.3-2,12.09,12.09,0,0,1,6.09,1.34c.08,0,4,2.25,4.1,2.28l65.9,37.69,5,2.86,65,37.15a6.78,6.78,0,0,1,3.6,5.48c.06,2.44-1.36,4.76-4.06,6.32l-5.9,3.05c-.06,0-4.95,2.51-5,2.52a14.79,14.79,0,0,1-7.32,1.75,12.65,12.65,0,0,1-6.06-1.53L104.44,271l-4.29-2.5L39.49,233.25a6.67,6.67,0,0,1-3.59-5.47,7.11,7.11,0,0,1,3.75-6.21l.12-1.45C39.65,220.05,40.64,211.92,40.78,211.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M40.83,212.5a17.4,17.4,0,0,1,7.17-2,11.84,11.84,0,0,1,6.06,1.2c.15,0,4,2.15,4.1,2.21l65.62,37.54,5,2.85,64.68,37a7.16,7.16,0,0,1,3.69,5.36c.12,2.39-1.18,4.72-3.89,6.28L187.41,306c-.12.07-4.86,2.45-5,2.46a14.55,14.55,0,0,1-7.21,1.62,13,13,0,0,1-6-1.59L104.69,271l-4.26-2.48-60.25-35c-2-1.17-3.66-3.29-3.66-5.34a6.67,6.67,0,0,1,3.26-6.07l0-1.42A44.49,44.49,0,0,1,40.83,212.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M40.88,213.16a19.06,19.06,0,0,1,7-2.09,11.56,11.56,0,0,1,6,1.07c.22,0,3.94,2.05,4.1,2.14l65.32,37.38,5,2.85,64.4,36.85c1.91,1.1,3.64,3.3,3.78,5.24.18,2.35-1,4.67-3.72,6.24L187,305.91c-.19.11-4.76,2.39-5,2.41a14.49,14.49,0,0,1-7.1,1.48,13.37,13.37,0,0,1-5.92-1.65l-64.08-37.23-4.23-2.46L40.88,233.69c-1.92-1.1-3.75-3.28-3.75-5.22,0-2.13.47-4.6,2.77-5.93v-1.37C39.54,221,40.47,213.39,40.88,213.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M40.93,213.81a21.15,21.15,0,0,1,6.91-2.14,11.22,11.22,0,0,1,6,.93c.3,0,3.89,2,4.11,2.08l65,37.22,5,2.83,64.1,36.7c1.81,1,3.69,3.3,3.88,5.13.24,2.32-.83,4.63-3.55,6.21l-5.72,3.08c-.25.14-4.66,2.32-5,2.34a14.06,14.06,0,0,1-12.85-.36l-63.64-37-4.2-2.44L41.57,233.91c-1.81-1-3.83-3.26-3.83-5.09,0-2,.12-4.54,2.29-5.79L40,221.69C39.49,221.42,40.38,214.13,40.93,213.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M41,214.47a23.78,23.78,0,0,1,6.78-2.21,11.08,11.08,0,0,1,6,.8,37.25,37.25,0,0,1,4.11,2l64.75,37.07,4.92,2.82,63.82,36.55c1.7,1,3.75,3.29,4,5,.3,2.3-.65,4.6-3.39,6.18l-5.65,3.09c-.32.18-4.56,2.26-5,2.29a14,14,0,0,1-6.88,1.21,14.41,14.41,0,0,1-5.79-1.77l-63.2-36.69-4.18-2.43-59-34.26c-1.7-1-3.91-3.24-3.91-5,0-1.89-.24-4.47,1.81-5.65L40,222.22C39.44,221.88,40.29,214.87,41,214.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M41,215.13a26.88,26.88,0,0,1,6.65-2.28,11,11,0,0,1,6,.66,33.68,33.68,0,0,1,4.11,2l64.45,36.92,4.9,2.81,63.54,36.39c1.59.92,3.81,3.29,4.06,4.89.36,2.27-.48,4.56-3.22,6.14l-5.6,3.1a46.31,46.31,0,0,1-4.92,2.23,13.78,13.78,0,0,1-6.77,1.08,15.1,15.1,0,0,1-5.72-1.83L105.7,270.77l-4.15-2.41-58.6-34c-1.6-.92-4-3.22-4-4.84,0-1.78-.59-4.41,1.33-5.51l-.19-1.26C39.39,222.33,40.21,215.61,41,215.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M41.08,215.79a30.87,30.87,0,0,1,6.52-2.34,10.74,10.74,0,0,1,5.93.52,26.56,26.56,0,0,1,4.12,1.89l64.16,36.76,4.88,2.8,63.25,36.24c1.48.86,4.15,3.26,4.15,4.77.83,2.14-.3,4.52-3.05,6.11l-5.54,3.11a42.9,42.9,0,0,1-4.9,2.17,13.49,13.49,0,0,1-6.66.94,15.83,15.83,0,0,1-5.66-1.89L106,270.72l-4.12-2.39L43.64,234.57c-1.49-.85-4.06-3.21-4.06-4.72s-1-4.34.84-5.37l-.26-1.21C39.33,222.79,40.12,216.34,41.08,215.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M41.13,216.45A36.43,36.43,0,0,1,47.52,214a10.49,10.49,0,0,1,5.9.39,22.49,22.49,0,0,1,4.12,1.82l63.87,36.61,4.86,2.78,63,36.09c1.39.8,4.25,3.26,4.25,4.66,1,2.09-.12,4.48-2.88,6.07l-5.48,3.12a35.75,35.75,0,0,1-4.88,2.11,13.19,13.19,0,0,1-6.55.81c-1.45,0-4.56-1.35-5.59-1.95l-61.9-35.88-4.09-2.37L44.33,234.8c-1.38-.8-4.14-3.2-4.14-4.6s-1.31-4.27.35-5.23l-.31-1.18C39.28,223.25,40,217.08,41.13,216.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M41.18,217.11a44.35,44.35,0,0,1,6.26-2.48,10.29,10.29,0,0,1,5.88.26,21,21,0,0,1,4.12,1.75L121,253.1l4.84,2.77,62.67,35.94c1.28.74,4.34,3.24,4.34,4.54,1.07,2,0,4.43-2.72,6l-5.41,3.13a30.12,30.12,0,0,1-4.86,2.05,13,13,0,0,1-6.44.68c-1.34,0-4.57-1.45-5.52-2l-61.46-35.61-4.07-2.36L45,235c-1.27-.74-4.22-3.18-4.22-4.48s-1.66-4.2-.13-5.09l-.38-1.13C39.23,223.7,40,217.82,41.18,217.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M41.23,217.77a54.92,54.92,0,0,1,6.13-2.54,10,10,0,0,1,5.85.12A18.54,18.54,0,0,1,57.33,217l63.3,36.31,4.81,2.76,62.39,35.79c1.17.67,4.43,3.23,4.43,4.42,1.19,2,.23,4.39-2.55,6l-5.35,3.14a28,28,0,0,1-4.84,2,12.79,12.79,0,0,1-6.33.54c-1.23,0-4.58-1.56-5.46-2.07l-61-35.34-4-2.34-57-33c-1.17-.68-4.3-3.16-4.3-4.35s-2-4.14-.61-5l-.44-1.09C39.17,224.16,39.86,218.56,41.23,217.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M41.28,218.42c1-.58,4.8-2.14,6-2.6a9.87,9.87,0,0,1,5.82,0,16.7,16.7,0,0,1,4.13,1.63l63,36.15,4.8,2.75L187.13,292c1.06.61,4.52,3.23,4.52,4.31,1.3,1.93.41,4.35-2.38,6l-5.3,3.15a23.94,23.94,0,0,1-4.81,1.93,12.38,12.38,0,0,1-6.23.41c-1.11,0-4.59-1.67-5.38-2.12L107,270.52l-4-2.32L46.4,235.46c-1.06-.62-4.38-3.15-4.38-4.23s-2.37-4.07-1.09-4.81l-.5-1C39.12,224.62,39.77,219.29,41.28,218.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M41.33,219.08c.9-.52,4.81-2.21,5.87-2.66a9.58,9.58,0,0,1,5.8-.16,15.36,15.36,0,0,1,4.13,1.56l62.71,36,4.77,2.74L186.42,292c1,.55,4.62,3.21,4.62,4.18,1.42,1.89.58,4.32-2.21,5.93l-5.24,3.16a21.79,21.79,0,0,1-4.79,1.88,12.27,12.27,0,0,1-6.12.27c-1,0-4.6-1.77-5.31-2.18l-60.16-34.81-4-2.31L47.09,235.68c-1-.55-4.45-3.13-4.45-4.1s-2.74-4-1.59-4.68l-.56-1C39.07,225.07,39.69,220,41.33,219.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M41.38,219.74c.8-.46,4.81-2.29,5.74-2.73a9.41,9.41,0,0,1,5.77-.29A14.1,14.1,0,0,1,57,218.21l62.42,35.84,4.75,2.73,61.53,35.33c.85.49,4.71,3.21,4.71,4.07,1.54,1.84.76,4.28-2,5.9l-5.18,3.17a19.74,19.74,0,0,1-4.77,1.81,11.92,11.92,0,0,1-6,.14c-.88,0-4.61-1.88-5.25-2.24l-59.71-34.54-4-2.29L47.78,235.9c-.85-.49-4.53-3.11-4.53-4s-3.09-4-2.07-4.54l-.62-1C39,225.53,39.6,220.77,41.38,219.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M41.43,220.4c.7-.41,4.81-2.38,5.6-2.8a9.2,9.2,0,0,1,5.75-.42,12.77,12.77,0,0,1,4.14,1.43l62.13,35.68,4.73,2.72L185,292.19c.74.43,4.8,3.2,4.8,3.95,1.66,1.79.94,4.24-1.88,5.86l-5.11,3.18a18.69,18.69,0,0,1-4.75,1.76,11.56,11.56,0,0,1-5.9,0c-.77,0-4.62-2-5.18-2.3l-59.28-34.27-3.93-2.27-55.32-32c-.74-.43-4.61-3.09-4.61-3.85s-3.45-3.88-2.55-4.4l-.69-.92C39,226,39.51,221.51,41.43,220.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M41.48,221.06c.6-.35,4.81-2.48,5.47-2.86,1.67-1,3.87-.85,5.72-.56A11.94,11.94,0,0,1,56.82,219l61.83,35.53,4.71,2.71,61,35c.63.37,4.89,3.19,4.89,3.84,1.78,1.74,1.11,4.19-1.71,5.82l-5.05,3.2a17.1,17.1,0,0,1-4.73,1.69,11.31,11.31,0,0,1-5.79-.13c-.66,0-4.64-2.09-5.12-2.36l-58.84-34-3.9-2.25-54.9-31.73c-.64-.37-4.7-3.08-4.7-3.72s-3.8-3.82-3-4.26l-.75-.89C38.91,226.44,39.43,222.24,41.48,221.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M41.53,221.72c.5-.29,4.71-2.93,5.34-2.93a11.93,11.93,0,0,1,5.7-.7,11.31,11.31,0,0,1,4.14,1.3l61.55,35.38,4.69,2.7,60.66,34.87c.54.31,5,3.18,5,3.72,1.89,1.69,1.29,4.15-1.54,5.79l-5,3.2a15.42,15.42,0,0,1-4.7,1.63,10.94,10.94,0,0,1-5.68-.26,38.45,38.45,0,0,1-5.05-2.42l-58.41-33.73L104.36,268l-54.5-31.47c-.53-.31-4.78-3.06-4.78-3.6s-4.15-3.75-3.51-4.12l-.81-.84C38.86,226.9,39.34,223,41.53,221.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M41.58,222.38c.4-.24,4.7-3,5.21-3a11.82,11.82,0,0,1,5.67-.83,10.66,10.66,0,0,1,4.15,1.23L117.87,255l4.66,2.68,60.38,34.73c.43.24,5.08,3.17,5.08,3.6,2,1.64,1.47,4.11-1.37,5.75L181.68,305a14.31,14.31,0,0,1-4.68,1.58,10.55,10.55,0,0,1-5.57-.4,48.11,48.11,0,0,1-5-2.48l-58-33.46L104.64,268,50.55,236.78c-.43-.24-4.85-3-4.85-3.47s-4.52-3.69-4-4l-.87-.81C38.8,227.36,39.25,223.72,41.58,222.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M41.63,223c.3-.17,4.7-3.05,5.08-3.05a11.57,11.57,0,0,1,5.64-1,10.1,10.1,0,0,1,4.16,1.17l61,35.07,4.65,2.67,60.09,34.57c.32.18,5.17,3.16,5.17,3.49,2.13,1.58,1.64,4.07-1.21,5.71l-4.87,3.23a13.44,13.44,0,0,1-4.66,1.51,10.27,10.27,0,0,1-5.46-.53c-.33,0-4.68-2.4-4.92-2.54l-57.53-33.19-3.81-2.2L51.24,237c-.32-.18-4.93-3-4.93-3.35s-4.87-3.61-4.49-3.84l-.93-.76C38.75,227.81,39.16,224.46,41.63,223Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M41.68,223.69c.2-.11,4.7-3.12,5-3.12a11.56,11.56,0,0,1,5.62-1.1,9.51,9.51,0,0,1,4.15,1.1l60.68,34.92,4.62,2.66,59.81,34.42c.21.12,5.25,3.15,5.25,3.36,2.26,1.54,1.83,4-1,5.69l-4.81,3.23a12.55,12.55,0,0,1-4.64,1.46,10,10,0,0,1-5.35-.67c-.22,0-4.69-2.51-4.85-2.6L109,270.12l-3.78-2.18L51.93,237.22c-.21-.12-5-3-5-3.22s-5.23-3.55-5-3.7l-1-.73C38.7,228.27,39.08,225.2,41.68,223.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M41.73,224.35c.1-.06,4.7-3.18,4.82-3.18a11.33,11.33,0,0,1,5.59-1.24,8.91,8.91,0,0,1,4.16,1l60.38,34.77,4.61,2.65,59.51,34.26c.11.06,5.35,3.15,5.35,3.25,2.38,1.49,2,4-.86,5.65l-4.75,3.24a11.8,11.8,0,0,1-4.62,1.4,9.49,9.49,0,0,1-5.24-.8c-.11,0-4.7-2.61-4.78-2.66l-56.67-32.65-3.75-2.17L52.62,237.44c-.11-.06-5.09-3-5.09-3.1s-5.58-3.48-5.45-3.56L41,230.1C38.65,228.73,39,225.93,41.73,224.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M170.43,305.12l-64.67-37.25L41.08,230.62c-2.49-1.44-2.18-4,.7-5.61l4.69-3.25c2.88-1.66,7.23-1.84,9.73-.4l64.67,37.24,64.67,37.25c2.5,1.44,2.18,3.95-.69,5.62l-4.7,3.25C177.28,306.38,172.92,306.56,170.43,305.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M170.84,304.16l-126-72.52c-7.17-4.15-13-15.26-13-24.82V99.51c0-9.56,5.82-14,13-9.81l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3C183.83,303.91,178,308.3,170.84,304.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M174.62,299.94,46.32,226.11c-6-3.78-9.63-11.33-9.63-19.07V95.72a2.37,2.37,0,0,1,3.57-2l.42.24,128.46,73.93c7.08,4.08,9.63,11.34,9.63,19.07v111a2.56,2.56,0,0,1-3.83,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M169.14,167.85,40.68,93.92l-.42-.24a2.37,2.37,0,0,0-3.57,2V207c0,7.74,3.68,15.29,9.63,19.07l128.3,73.83.32.18a2.56,2.56,0,0,0,3.83-2.23v-111C178.77,179.19,176.22,171.93,169.14,167.85Zm8.12,130A1.06,1.06,0,0,1,176.2,299a1,1,0,0,1-.52-.14l-128.61-74c-5.37-3.41-8.88-10.4-8.88-17.77V95.72a.87.87,0,0,1,.87-.87.88.88,0,0,1,.44.12l128.88,74.18c7.34,4.23,8.88,12,8.88,17.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M176.82,158.75l-126-72.52c-2.84-1.64-5.47-2-7.6-1.12-.27.11-6.19,3.54-6.45,3.69h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,6.39-3.82,6.55-3.93,2.47-1.73,4-5.28,4-10.2V183.57C189.8,174,184,162.89,176.82,158.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M176.71,158.82,50.67,86.3c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-6.08,3.47-6.34,3.62h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,6.28-3.75,6.44-3.86,2.47-1.73,4-5.28,4-10.2V183.64C189.69,174.08,183.88,163,176.71,158.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M176.6,158.9l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-6,3.4-6.23,3.55h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,6.17-3.68,6.33-3.79,2.47-1.73,4-5.28,4-10.19V183.71C189.58,174.15,183.77,163,176.6,158.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M176.49,159l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.11-.27.1-5.86,3.32-6.12,3.47h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,6.07-3.61,6.22-3.72,2.47-1.72,4-5.28,4-10.19V183.78C189.48,174.22,183.66,163.11,176.49,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M176.38,159l-126-72.53c-2.84-1.63-5.46-1.94-7.6-1.11-.27.1-5.75,3.25-6,3.4h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,6-3.54,6.11-3.65,2.47-1.72,4-5.27,4-10.19V183.86C189.37,174.29,183.55,163.18,176.38,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M176.27,159.11l-126-72.52c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-5.64,3.18-5.9,3.33h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5.85-3.46,6-3.57,2.47-1.73,4-5.28,4-10.2V183.93C189.26,174.36,183.44,163.25,176.27,159.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M176.16,159.18l-126-72.52c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-5.53,3.11-5.79,3.26h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5.74-3.39,5.89-3.5,2.47-1.73,4-5.28,4-10.19V184C189.15,174.44,183.33,163.33,176.16,159.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M176.05,159.26,50,86.73c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-5.42,3-5.68,3.19h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5.63-3.32,5.78-3.43,2.47-1.73,4-5.28,4-10.19V184.07C189,174.51,183.22,163.4,176.05,159.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M175.94,159.33,49.9,86.8c-2.83-1.64-5.46-1.94-7.6-1.11-.27.1-5.31,3-5.57,3.11h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5.52-3.25,5.67-3.36,2.47-1.72,4-5.27,4-10.19V184.15C188.93,174.58,183.11,163.47,175.94,159.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M175.83,159.4l-126-72.53c-2.83-1.63-5.46-1.94-7.6-1.11-.27.1-5.2,2.89-5.46,3h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5.41-3.17,5.57-3.28,2.46-1.73,4-5.28,4-10.2V184.22C188.82,174.65,183,163.54,175.83,159.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M175.72,159.47,49.68,87c-2.83-1.64-5.46-1.94-7.6-1.12-.27.11-5.09,2.82-5.35,3h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5.3-3.1,5.46-3.21,2.46-1.73,4-5.28,4-10.2V184.29C188.71,174.73,182.89,163.61,175.72,159.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M175.61,159.55,49.57,87c-2.83-1.64-5.46-1.94-7.6-1.12-.27.11-5,2.75-5.24,2.9h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5.19-3,5.35-3.14,2.46-1.73,4-5.28,4-10.19V184.36C188.6,174.8,182.79,163.69,175.61,159.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M175.5,159.62l-126-72.53C46.63,85.45,44,85.15,41.87,86c-.28.1-4.88,2.67-5.14,2.82h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5.08-3,5.24-3.07,2.46-1.73,4-5.28,4-10.19V184.43C188.49,174.87,182.68,163.76,175.5,159.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M175.39,159.69l-126-72.53c-2.84-1.64-5.47-1.94-7.6-1.11-.28.1-4.77,2.6-5,2.75h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,5-2.89,5.13-3,2.47-1.72,4-5.27,4-10.19V184.51C188.38,174.94,182.57,163.83,175.39,159.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M175.28,159.76l-126-72.52c-2.84-1.64-5.47-1.95-7.6-1.12-.28.11-4.66,2.53-4.92,2.68h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,4.86-2.81,5-2.92,2.47-1.73,4-5.28,4-10.2V184.58C188.27,175,182.46,163.9,175.28,159.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M175.17,159.83l-126-72.52c-2.84-1.64-5.47-1.94-7.6-1.12-.27.11-4.55,2.46-4.81,2.61h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,4.75-2.74,4.91-2.85,2.47-1.73,4-5.28,4-10.2V184.65C188.16,175.09,182.35,164,175.17,159.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M175.07,159.91,49,87.38c-2.84-1.64-5.47-1.94-7.6-1.12-.27.11-4.44,2.39-4.7,2.54h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,4.64-2.67,4.8-2.78,2.47-1.73,4-5.28,4-10.19V184.72C188.05,175.16,182.24,164.05,175.07,159.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M175,160l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.11-.27.1-4.33,2.31-4.59,2.46h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,4.53-2.6,4.69-2.71,2.47-1.72,4-5.28,4-10.19V184.79C187.94,175.23,182.13,164.12,175,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M174.85,160.05l-126-72.53c-2.84-1.63-5.46-1.94-7.6-1.11-.27.1-4.22,2.24-4.48,2.39h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39l4.58-2.63c2.47-1.73,4-5.28,4-10.2V184.87C187.83,175.3,182,164.19,174.85,160.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M174.74,160.12,48.7,87.6c-2.84-1.64-5.46-1.94-7.6-1.12-.27.11-4.11,2.17-4.37,2.32h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,4.31-2.45,4.47-2.56,2.47-1.73,4-5.28,4-10.2V184.94C187.73,175.37,181.91,164.26,174.74,160.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M174.63,160.19l-126-72.52C45.75,86,43.13,85.73,41,86.55c-.27.11-4,2.1-4.26,2.25h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,4.21-2.38,4.36-2.49,2.47-1.73,4-5.28,4-10.19V185C187.62,175.45,181.8,164.34,174.63,160.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M174.52,160.27l-126-72.53c-2.84-1.64-5.46-1.94-7.6-1.11-.27.1-3.89,2-4.15,2.17h0c2.22-1.08,5-.88,8.09.89l126,72.52c7.17,4.14,13,15.25,13,24.82v107.3c0,6-2.27,9.93-5.72,11.05a2.08,2.08,0,0,0,1.14-.39c.17-.09,4.1-2.31,4.25-2.42,2.47-1.73,4-5.28,4-10.19V185.08C187.51,175.52,181.69,164.41,174.52,160.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M171.46,161.91l-126-72.53c-2.94-1.69-5.64-1.94-7.82-1a9.66,9.66,0,0,1,6.27,1.47l126,72.53c7.18,4.14,13,15.25,13,24.81V294.5c0,5.64-2,9.46-5.16,10.82,4-.64,6.72-4.75,6.72-11.29V186.73C184.45,177.16,178.63,166.05,171.46,161.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "83.99 220.46 44.93 197.72 44.93 194.2 83.99 216.94 83.99 220.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "83.99 227.09 44.93 204.34 44.93 201.82 83.99 224.57 83.99 227.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "83.99 232.38 44.93 209.64 44.93 207.62 83.99 230.36 83.99 232.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "83.99 211.64 44.93 188.9 44.93 164.9 83.99 187.65 83.99 211.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "127.49 246.13 88.42 223.39 88.42 219.87 127.49 242.62 127.49 246.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "127.49 252.76 88.42 230.02 88.42 227.5 127.49 250.24 127.49 252.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "127.49 258.05 88.42 235.31 88.42 233.29 127.49 256.03 127.49 258.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "127.49 237.31 88.42 214.57 88.42 190.58 127.49 213.32 127.49 237.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "171.28 272.11 132.22 249.37 132.22 245.85 171.28 268.59 171.28 272.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "171.28 278.74 132.22 255.99 132.22 253.47 171.28 276.21 171.28 278.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "171.28 284.03 132.22 261.28 132.22 259.26 171.28 282.01 171.28 284.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "83.99 236.88 44.93 214.14 44.93 212.78 83.99 235.53 83.99 236.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "127.49 262.55 88.42 239.81 88.42 238.46 127.49 261.2 127.49 262.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "171.28 288.53 132.22 265.78 132.22 264.43 171.28 287.17 171.28 288.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "171.28 263.29 132.22 240.55 132.22 216.55 171.28 239.29 171.28 263.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-288",
    points: "171.19 229.3 44.9 156.87 44.9 107.45 171.19 179.88 171.19 229.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "171.19 201.63 51.34 132.76 51.34 121.1 171.19 189.97 171.19 201.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "171.19 213.04 87.34 164.84 87.34 160.43 171.19 208.63 171.19 213.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M119.86,193.71l-24.06-14c-1.94-1.12-3.52-4.15-3.52-6.73v-1.8c0-2.58,1.58-3.78,3.52-2.66l24.06,14c1.94,1.12,3.52,4.15,3.52,6.73v1.8C123.38,193.63,121.8,194.83,119.86,193.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M87.84,153.88l18.31,10.63V162.1L87.84,151.47Zm20.68,9.59v2.41l21.77,12.51V176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M101.33,166.55,119.81,177v-2.41l-18.48-10.47Zm-24.3-14L99,165.18v-2.41L77,150.14ZM122.18,176v2.41l18.93,10.79v-2.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "127.08 166.37 95.58 148.22 95.58 151.68 127.08 169.83 127.08 166.37"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-293",
    cx: 165.64,
    cy: 307.1,
    rx: 18.9,
    ry: 8.81
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147,336.48a2.3,2.3,0,0,1-1.15-.27l-1.15-.75a1.21,1.21,0,0,1-.66-1,1.41,1.41,0,0,1,.79-1.19l5.52-4.12a2.83,2.83,0,0,1,1.4-.36c.22,0,.79-4.34,1.34-8.65s1.1-8.6,1.26-8.51l2.36,1.09c.21.12,0,4.64-.23,9.18s-.56,9.1-.56,9.31a1.39,1.39,0,0,1-.79,1.19l-3.37,1.89-3.37,1.89A2.81,2.81,0,0,1,147,336.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M156.35,313.68c.21.12,0,4.43-.21,8.76s-.53,8.69-.54,8.9a1.39,1.39,0,0,1-.76,1.14L152.18,334l-.6.34s-3.25,1.81-3.27,1.8a2.73,2.73,0,0,1-1.28.33H147a2.31,2.31,0,0,1-1.11-.27l-1.11-.72a1.2,1.2,0,0,1-.64-1,1.36,1.36,0,0,1,.75-1.15s4.35-3.26,4.36-3.27l.93-.69a2.73,2.73,0,0,1,1.34-.35,12.22,12.22,0,0,0,.61-3.05c.22-1.49.48-3.35.74-5.21.29-2.16.59-4.31.81-5.85a9.83,9.83,0,0,1,.44-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M156,314.69c.21.12,0,4.23-.18,8.35s-.52,8.27-.53,8.48a1.33,1.33,0,0,1-.73,1.08L152,334s-.58.33-.58.33-3.13,1.72-3.17,1.72a2.63,2.63,0,0,1-1.23.3h-.07a2.29,2.29,0,0,1-1.07-.26l-1.08-.7a1.12,1.12,0,0,1-.61-1,1.27,1.27,0,0,1,.71-1.1s4.13-3.12,4.16-3.14l.89-.66a2.62,2.62,0,0,1,1.28-.33,12,12,0,0,0,.61-2.92c.21-1.42.48-3.19.74-5,.3-2.05.6-4.09.82-5.55a8.21,8.21,0,0,1,.44-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M155.57,315.7c.22.12.06,4-.15,7.93s-.51,7.86-.52,8.06a1.32,1.32,0,0,1-.7,1l-2.48,1.38-.56.32c-.06,0-3,1.64-3.07,1.63a2.58,2.58,0,0,1-1.19.28h-.06a2.1,2.1,0,0,1-1-.26l-1-.66a1.09,1.09,0,0,1-.59-.92,1.21,1.21,0,0,1,.66-1.05s3.92-3,4-3l.85-.63a2.53,2.53,0,0,1,1.23-.32,11.66,11.66,0,0,0,.59-2.77c.22-1.36.49-3,.75-4.72.3-1.94.62-3.87.83-5.25a7.93,7.93,0,0,1,.43-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M155.19,316.71c.21.12.07,3.81-.14,7.52s-.49,7.43-.51,7.64a1.28,1.28,0,0,1-.66,1l-2.39,1.32-.55.31c-.07,0-2.89,1.56-3,1.55a2.55,2.55,0,0,1-1.15.25h-.05a2,2,0,0,1-1-.26l-1-.64a1.07,1.07,0,0,1-.57-.88,1.17,1.17,0,0,1,.62-1c0-.05,3.71-2.85,3.77-2.89l.82-.6a2.4,2.4,0,0,1,1.17-.31,10.07,10.07,0,0,0,.59-2.63c.21-1.29.5-2.88.76-4.46.3-1.85.63-3.66.83-4.95a7.13,7.13,0,0,1,.43-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M154.8,317.72c.21.12.08,3.61-.11,7.11s-.47,7-.5,7.22a1.25,1.25,0,0,1-.63.92l-2.3,1.27s-.51.29-.53.29S148,336,147.87,336a2.65,2.65,0,0,1-1.1.24h-.06a2.19,2.19,0,0,1-1-.25l-1-.62a1,1,0,0,1-.54-.83,1.12,1.12,0,0,1,.58-1c0-.05,3.48-2.71,3.57-2.76l.78-.57a2.42,2.42,0,0,1,1.11-.3,9.7,9.7,0,0,0,.59-2.49c.2-1.22.5-2.72.76-4.21.31-1.74.64-3.44.84-4.65a6.18,6.18,0,0,1,.42-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M154.41,318.73c.21.13.09,3.4-.08,6.69s-.46,6.6-.49,6.8a1.19,1.19,0,0,1-.6.87L151,334.31s-.48.27-.5.28-2.65,1.41-2.76,1.38a2.45,2.45,0,0,1-1.06.22h0a2.05,2.05,0,0,1-.91-.25l-.93-.59a1,1,0,0,1-.53-.79,1,1,0,0,1,.54-.9c0-.07,3.27-2.58,3.38-2.64l.73-.54a2.4,2.4,0,0,1,1.07-.28,9.53,9.53,0,0,0,.57-2.35c.2-1.16.51-2.57.77-4,.31-1.63.66-3.22.85-4.35a5.22,5.22,0,0,1,.42-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M154,319.74c.21.13.11,3.19-.06,6.28s-.44,6.18-.48,6.38a1.14,1.14,0,0,1-.56.82l-2.13,1.17-.48.26c-.13.05-2.53,1.33-2.66,1.3a2.56,2.56,0,0,1-1,.19h0a2,2,0,0,1-.87-.24l-.9-.57a.93.93,0,0,1-.5-.74,1,1,0,0,1,.49-.86c0-.08,3.06-2.44,3.18-2.51l.7-.51a2.26,2.26,0,0,1,1-.27,8.23,8.23,0,0,0,.57-2.21c.2-1.09.51-2.42.78-3.72.31-1.52.66-3,.85-4.05a4.76,4.76,0,0,1,.41-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M153.63,320.75c.21.13.12,3,0,5.86s-.39,5.77-.47,6a1,1,0,0,1-.54.77l-2,1.12-.46.25c-.15.06-2.41,1.24-2.56,1.21a2.39,2.39,0,0,1-1,.17h0a1.83,1.83,0,0,1-.83-.24l-.87-.53a.91.91,0,0,1-.47-.71.92.92,0,0,1,.44-.81c0-.09,2.85-2.3,3-2.38l.66-.48a2.17,2.17,0,0,1,1-.26,7.35,7.35,0,0,0,.57-2.07c.19-1,.51-2.26.78-3.47.32-1.41.68-2.78.86-3.74A4.16,4.16,0,0,1,152,320Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M153.24,321.76c.21.13.14,2.78,0,5.45s-.36,5.35-.45,5.54a.9.9,0,0,1-.51.71l-1.94,1.07-.45.24a25.56,25.56,0,0,1-2.45,1.13,2.34,2.34,0,0,1-.92.14h0a2,2,0,0,1-.8-.23l-.82-.51a.87.87,0,0,1-.46-.66.85.85,0,0,1,.41-.76,30.38,30.38,0,0,1,2.79-2.26l.62-.45a2.08,2.08,0,0,1,.89-.25,6.82,6.82,0,0,0,.56-1.92c.19-1,.52-2.11.79-3.23.32-1.31.69-2.56.87-3.44a3.66,3.66,0,0,1,.4-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M152.85,322.78c.21.12.15,2.56,0,5a43.94,43.94,0,0,1-.45,5.13.84.84,0,0,1-.47.66l-1.85,1-.43.23a21.06,21.06,0,0,1-2.35,1,2.29,2.29,0,0,1-.88.12h0a1.94,1.94,0,0,1-.75-.22l-.79-.49a.82.82,0,0,1-.43-.62.78.78,0,0,1,.36-.71,25.18,25.18,0,0,1,2.59-2.13l.59-.42a2,2,0,0,1,.84-.23,6.46,6.46,0,0,0,.55-1.79c.18-.9.52-1.95.8-3,.32-1.2.7-2.34.88-3.14a2.89,2.89,0,0,1,.39-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M152.46,323.79c.21.12.17,2.36,0,4.61a36.28,36.28,0,0,1-.44,4.7.81.81,0,0,1-.44.61l-1.77,1-.4.22a18.09,18.09,0,0,1-2.25,1,2.28,2.28,0,0,1-.83.09h0a1.79,1.79,0,0,1-.71-.22l-.76-.46a.72.72,0,0,1-.09-1.24,21,21,0,0,1,2.4-2l.55-.39a2,2,0,0,1,.78-.22,5.83,5.83,0,0,0,.55-1.65c.18-.83.52-1.79.8-2.73s.71-2.12.89-2.84a2.61,2.61,0,0,1,.38-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M152.07,324.8c.21.12.18,2.15.07,4.19a27.48,27.48,0,0,1-.42,4.29.72.72,0,0,1-.41.55l-1.68.91s-.34.19-.38.2a13.9,13.9,0,0,1-2.15.88,2.29,2.29,0,0,1-.79.07h0a1.87,1.87,0,0,1-.68-.21l-.71-.44a.72.72,0,0,1-.39-.53.65.65,0,0,1,.28-.61,15.6,15.6,0,0,1,2.19-1.88l.52-.36a1.94,1.94,0,0,1,.72-.21,5.07,5.07,0,0,0,.54-1.5c.18-.77.53-1.64.82-2.49s.72-1.9.89-2.53.34-.93.38-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M151.68,325.81c.21.12.2,1.94.1,3.78a20.81,20.81,0,0,1-.42,3.87.69.69,0,0,1-.37.5l-1.59.85s-.32.18-.36.19a11.57,11.57,0,0,1-2,.8,2.32,2.32,0,0,1-.75,0h0a1.86,1.86,0,0,1-.64-.21l-.68-.4a.72.72,0,0,1-.36-.49.62.62,0,0,1,.23-.57,12.21,12.21,0,0,1,2-1.75l.48-.32a1.65,1.65,0,0,1,.67-.21,4.54,4.54,0,0,0,.53-1.36,19.73,19.73,0,0,1,.82-2.23c.33-.88.73-1.68.9-2.24s.34-.81.37-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M151.29,326.82c.21.12.21,1.74.13,3.37a15.59,15.59,0,0,1-.41,3.44.6.6,0,0,1-.34.45l-1.5.8-.34.18a9.57,9.57,0,0,1-2,.71,2.33,2.33,0,0,1-.7,0h0a1.87,1.87,0,0,1-.59-.2l-.65-.38a.67.67,0,0,1-.33-.44.56.56,0,0,1,.18-.53,9.44,9.44,0,0,1,1.81-1.62l.43-.29a1.66,1.66,0,0,1,.62-.19,4.2,4.2,0,0,0,.53-1.23,14.84,14.84,0,0,1,.82-2c.34-.78.66-1.49.91-1.94.06-.48.34-.68.37-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M150.9,327.83c.21.12.23,1.53.15,2.95a11.89,11.89,0,0,1-.39,3,.61.61,0,0,1-.31.39l-1.41.75-.33.17a8.18,8.18,0,0,1-1.84.63,2.44,2.44,0,0,1-.66,0h0a2,2,0,0,1-.55-.19l-.61-.36a.65.65,0,0,1-.32-.4.5.5,0,0,1,.15-.47c-.06-.18,1.35-1.35,1.6-1.5l.4-.26a1.6,1.6,0,0,1,.56-.18,3.42,3.42,0,0,0,.52-1.08,10.27,10.27,0,0,1,.84-1.74,14.09,14.09,0,0,1,.91-1.63c0-.42.34-.57.36-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M150.51,328.84a5.68,5.68,0,0,1,.18,2.54,8.17,8.17,0,0,1-.39,2.61.52.52,0,0,1-.27.34l-1.33.69a2.11,2.11,0,0,1-.3.16,6.36,6.36,0,0,1-1.74.54,2.09,2.09,0,0,1-.61,0h0a1.91,1.91,0,0,1-.52-.19l-.57-.33a.61.61,0,0,1-.29-.35.47.47,0,0,1,.1-.43c-.06-.19,1.14-1.21,1.41-1.37l.36-.23a1.48,1.48,0,0,1,.5-.17,3.15,3.15,0,0,0,.52-.94,7.64,7.64,0,0,1,.84-1.49,9.43,9.43,0,0,1,.92-1.33.47.47,0,0,1,.36-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M150.12,329.85c.21.12.26,1.12.21,2.12a5.63,5.63,0,0,1-.38,2.19.48.48,0,0,1-.24.29l-1.24.64-.28.15a5.29,5.29,0,0,1-1.64.45,2.73,2.73,0,0,1-.57,0h0a2.29,2.29,0,0,1-.48-.19l-.53-.31a.59.59,0,0,1-.28-.31.42.42,0,0,1,.06-.38c-.06-.19.92-1.07,1.22-1.24l.32-.2a1.72,1.72,0,0,1,.45-.16,1.79,1.79,0,0,0,.51-.8,14.22,14.22,0,0,1,.84-1.24,6.31,6.31,0,0,1,.93-1,.37.37,0,0,1,.35-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M149.73,330.86c.21.12.27.91.23,1.71a3.91,3.91,0,0,1-.36,1.77.46.46,0,0,1-.21.23l-1.15.59-.26.14a2.88,2.88,0,0,1-2.06.3h0a2.53,2.53,0,0,1-.44-.18l-.5-.29a.56.56,0,0,1-.25-.26.35.35,0,0,1,0-.33c-.07-.21.7-.94,1-1.11l.29-.18a1.64,1.64,0,0,1,.39-.14,1.52,1.52,0,0,0,.5-.66,8.24,8.24,0,0,1,.86-1,3.67,3.67,0,0,1,.93-.73c0-.21.34-.19.35-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M149.34,331.87c.21.12.29.7.26,1.29a2.43,2.43,0,0,1-.35,1.36.62.62,0,0,1-.18.18l-1.06.53-.24.13a3.52,3.52,0,0,1-1.44.28,1.32,1.32,0,0,1-.48-.09h0a2.76,2.76,0,0,1-.39-.18l-.47-.25a.54.54,0,0,1-.22-.23.35.35,0,0,1,0-.28c-.07-.22.49-.8.82-1l.25-.15a1.62,1.62,0,0,1,.33-.13s.47-.34.5-.52a5.09,5.09,0,0,1,.86-.75,2.33,2.33,0,0,1,.94-.42c0-.14.33-.08.34-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M149,332.88c.21.12.3.5.29.88a1.52,1.52,0,0,1-.35.93.89.89,0,0,1-.14.13l-1,.48a1,1,0,0,1-.23.11,2.8,2.8,0,0,1-1.33.21,1.52,1.52,0,0,1-.43-.12h0l-.36-.17-.42-.23a.76.76,0,0,1-.21-.18.44.44,0,0,1-.07-.24c-.07-.23.28-.66.62-.85l.22-.12a1.81,1.81,0,0,1,.28-.12s.47-.29.48-.38a3.44,3.44,0,0,1,.87-.5,1.75,1.75,0,0,1,.95-.12c0-.07.33.05.34.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M145.72,335.45l-.71-.37c-.47-.27-.41-.74.13-1.05l.88-.43a2,2,0,0,1,1.83-.08l.71.37c.46.27.41.74-.13,1.05l-.89.43A2,2,0,0,1,145.72,335.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.31,343.51a2.39,2.39,0,0,1-1.23-.3l-1.24-.8a1.31,1.31,0,0,1-.71-1.13A1.53,1.53,0,0,1,157,340l5.94-4.43a3.05,3.05,0,0,1,1.49-.38c.24,0,.77-4.46,1.28-8.91s1-8.86,1.18-8.76l2.55,1.18c.22.13.09,4.79-.09,9.47s-.43,9.4-.43,9.62a1.5,1.5,0,0,1-.85,1.28l-3.62,2-3.62,2A3.12,3.12,0,0,1,159.31,343.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M169,319.74c.23.13.11,4.58-.07,9.05s-.41,9-.42,9.19a1.48,1.48,0,0,1-.82,1.23l-2.85,1.59-.65.36s-3.49,1.94-3.51,1.94a3,3,0,0,1-1.37.35h-.08a2.36,2.36,0,0,1-1.19-.3l-1.2-.77a1.25,1.25,0,0,1-.68-1.08,1.45,1.45,0,0,1,.81-1.23s4.46-3.36,4.48-3.37l1.2-.89a3,3,0,0,1,1.44-.37,11.77,11.77,0,0,0,.56-2.89c.21-1.57.47-3.6.72-5.62.28-2.22.56-4.44.77-6a9.94,9.94,0,0,1,.42-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M168.61,320.79c.23.13.12,4.37-.05,8.62s-.41,8.54-.42,8.76a1.44,1.44,0,0,1-.78,1.17l-2.76,1.54-.63.35s-3.36,1.85-3.4,1.84a2.91,2.91,0,0,1-1.33.33h-.06a2.41,2.41,0,0,1-1.15-.28l-1.16-.75a1.19,1.19,0,0,1-.66-1,1.37,1.37,0,0,1,.76-1.18s4.25-3.22,4.28-3.24l1.15-.85a2.89,2.89,0,0,1,1.38-.36,10.45,10.45,0,0,0,.56-2.75c.21-1.51.48-3.44.73-5.36.28-2.11.57-4.21.78-5.71a8.73,8.73,0,0,1,.42-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M168.21,321.84c.22.13.13,4.15,0,8.2s-.4,8.1-.42,8.32a1.38,1.38,0,0,1-.75,1.11L164.35,341s-.59.34-.61.34-3.23,1.77-3.29,1.76a3,3,0,0,1-1.28.3h-.06a2.31,2.31,0,0,1-1.11-.28l-1.12-.72a1.17,1.17,0,0,1-.63-1,1.31,1.31,0,0,1,.71-1.12s4-3.08,4.08-3.11l1.1-.82a2.78,2.78,0,0,1,1.32-.34,9.6,9.6,0,0,0,.56-2.62c.21-1.44.49-3.27.74-5.09.29-2,.59-4,.79-5.4a7.76,7.76,0,0,1,.42-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M167.8,322.89c.23.13.15,3.94,0,7.77s-.39,7.67-.42,7.89a1.32,1.32,0,0,1-.71,1.05L164.1,341l-.58.32c-.08,0-3.11,1.68-3.18,1.67a3,3,0,0,1-1.24.28H159A2.22,2.22,0,0,1,158,343l-1.08-.69a1.13,1.13,0,0,1-.61-.94,1.23,1.23,0,0,1,.66-1.07c0-.05,3.81-2.94,3.89-3l1-.78a2.62,2.62,0,0,1,1.26-.33,9.38,9.38,0,0,0,.54-2.49c.21-1.36.5-3.1.77-4.82.28-1.89.6-3.76.79-5.09a6.84,6.84,0,0,1,.42-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M167.4,323.94c.23.13.16,3.72,0,7.34s-.38,7.24-.41,7.46a1.31,1.31,0,0,1-.68,1l-2.47,1.36-.56.32c-.1,0-3,1.59-3.07,1.57a2.76,2.76,0,0,1-1.19.25H159a2.37,2.37,0,0,1-1-.26l-1-.67a1.07,1.07,0,0,1-.58-.89,1.17,1.17,0,0,1,.62-1c0-.06,3.59-2.79,3.68-2.85l1-.73a2.56,2.56,0,0,1,1.2-.32,8.15,8.15,0,0,0,.54-2.36c.21-1.29.51-2.93.78-4.55.29-1.78.61-3.54.81-4.78a6.18,6.18,0,0,1,.4-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M167,325c.23.13.16,3.51,0,6.91s-.37,6.81-.41,7a1.28,1.28,0,0,1-.64.94l-2.38,1.31-.54.3c-.11,0-2.84,1.51-3,1.48a2.64,2.64,0,0,1-1.14.23h-.05a2.15,2.15,0,0,1-1-.26l-1-.64a1,1,0,0,1-.57-.84,1.15,1.15,0,0,1,.58-1c0-.07,3.37-2.66,3.48-2.72l1-.7a2.58,2.58,0,0,1,1.15-.3,8.43,8.43,0,0,0,.53-2.22c.2-1.23.51-2.77.79-4.29.3-1.67.63-3.31.82-4.47a5.49,5.49,0,0,1,.4-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M166.6,326c.22.13.17,3.3.05,6.48s-.36,6.38-.4,6.6a1.27,1.27,0,0,1-.61.88l-2.29,1.26-.52.28c-.13.06-2.71,1.42-2.85,1.4a2.75,2.75,0,0,1-1.09.2h0a2.19,2.19,0,0,1-.94-.26l-1-.61a1,1,0,0,1-.54-.8,1.06,1.06,0,0,1,.53-.92c0-.09,3.15-2.52,3.28-2.59l.91-.66a2.41,2.41,0,0,1,1.08-.29,7.35,7.35,0,0,0,.53-2.09c.2-1.16.52-2.6.8-4s.64-3.09.83-4.16a4.82,4.82,0,0,1,.4-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M166.19,327.09c.23.13.19,3.08.08,6.05s-.32,6-.4,6.17a1.05,1.05,0,0,1-.58.82l-2.19,1.2-.49.28c-.16.06-2.59,1.33-2.75,1.3a2.71,2.71,0,0,1-1,.18h0a2.11,2.11,0,0,1-.89-.26l-.93-.57a.92.92,0,0,1,0-1.63c0-.1,2.93-2.38,3.08-2.46l.86-.62a2.32,2.32,0,0,1,1-.28,6.64,6.64,0,0,0,.53-2c.19-1.09.53-2.43.81-3.75s.66-2.86.84-3.85a4.08,4.08,0,0,1,.4-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M165.79,328.14c.23.13.2,2.87.09,5.62a56.57,56.57,0,0,1-.39,5.74,1,1,0,0,1-.54.77l-2.09,1.14-.48.26c-.18.07-2.46,1.25-2.63,1.21a2.53,2.53,0,0,1-1,.15h0a2.06,2.06,0,0,1-.85-.24l-.89-.55a.86.86,0,0,1-.05-1.53,32.17,32.17,0,0,1,2.87-2.33l.81-.59a2.26,2.26,0,0,1,1-.26,6.25,6.25,0,0,0,.52-1.83c.19-1,.53-2.26.82-3.48s.68-2.63.85-3.54a3.52,3.52,0,0,1,.4-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M165.39,329.19c.22.13.21,2.65.11,5.2a46.24,46.24,0,0,1-.39,5.3.92.92,0,0,1-.51.71l-2,1.08s-.42.24-.46.25a23.13,23.13,0,0,1-2.52,1.12,2.49,2.49,0,0,1-.95.13h0a2.07,2.07,0,0,1-.81-.24l-.85-.52a.89.89,0,0,1-.46-.67.84.84,0,0,1,.39-.77,27,27,0,0,1,2.67-2.2l.77-.54a2.09,2.09,0,0,1,.9-.26,5.81,5.81,0,0,0,.52-1.69c.18-.95.54-2.09.83-3.21s.69-2.41.87-3.23.34-1.21.39-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M165,330.23c.23.14.23,2.45.14,4.78a35.62,35.62,0,0,1-.39,4.87.86.86,0,0,1-.47.65l-1.9,1s-.4.22-.44.23a18.64,18.64,0,0,1-2.41,1,2.68,2.68,0,0,1-.9.1h0a1.89,1.89,0,0,1-.76-.24l-.81-.49a.83.83,0,0,1-.44-.62.79.79,0,0,1,.34-.72,21.39,21.39,0,0,1,2.47-2.07l.72-.5a2,2,0,0,1,.84-.25,4.83,4.83,0,0,0,.51-1.55c.19-.89.55-1.93.85-2.95s.71-2.18.88-2.92a2.73,2.73,0,0,1,.38-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M164.58,331.28c.23.13.24,2.23.16,4.35a28.62,28.62,0,0,1-.39,4.44.79.79,0,0,1-.44.59l-1.8,1-.41.22a16,16,0,0,1-2.31.94,2.39,2.39,0,0,1-.85.07h0a2.14,2.14,0,0,1-.73-.22l-.77-.47a.79.79,0,0,1-.41-.57.72.72,0,0,1,.29-.67,16.73,16.73,0,0,1,2.27-1.94l.67-.47a2.07,2.07,0,0,1,.79-.23,4.69,4.69,0,0,0,.5-1.42c.19-.82.56-1.76.86-2.68s.73-1.95.89-2.61a2.09,2.09,0,0,1,.38-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M164.18,332.33c.23.13.25,2,.17,3.92a21.13,21.13,0,0,1-.38,4,.75.75,0,0,1-.4.54l-1.71.91-.39.21a12.94,12.94,0,0,1-2.2.85,2.37,2.37,0,0,1-.8.05h0a2.09,2.09,0,0,1-.68-.22l-.73-.44a.76.76,0,0,1-.39-.53.63.63,0,0,1,.25-.61,11.81,11.81,0,0,1,2.07-1.81l.62-.43a1.89,1.89,0,0,1,.72-.22,4,4,0,0,0,.5-1.29,24.55,24.55,0,0,1,.87-2.41c.33-.9.74-1.72.9-2.3s.35-.83.38-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M163.77,333.38c.23.13.26,1.81.2,3.49a15.22,15.22,0,0,1-.38,3.58.69.69,0,0,1-.37.48l-1.61.86-.37.19a9.7,9.7,0,0,1-2.08.76,2.4,2.4,0,0,1-.76,0h0a2,2,0,0,1-.64-.22l-.69-.41a.71.71,0,0,1-.36-.48.58.58,0,0,1,.2-.56,8.93,8.93,0,0,1,1.87-1.68l.57-.39a1.83,1.83,0,0,1,.66-.21,3.56,3.56,0,0,0,.5-1.16,17,17,0,0,1,.88-2.14c.34-.79.67-1.53.91-2,.07-.51.35-.71.38-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M163.37,334.43c.23.13.27,1.59.22,3.06a11.64,11.64,0,0,1-.38,3.15.6.6,0,0,1-.33.42l-1.52.8-.35.19a8.5,8.5,0,0,1-2,.67,2.81,2.81,0,0,1-.71,0,0,0,0,0,0,0,0,2,2,0,0,1-.6-.22l-.65-.38a.69.69,0,0,1-.35-.43.55.55,0,0,1,.16-.51c-.06-.19,1.4-1.4,1.67-1.56l.52-.35a1.81,1.81,0,0,1,.61-.19,3.27,3.27,0,0,0,.49-1,11.42,11.42,0,0,1,.89-1.88,15.57,15.57,0,0,1,.93-1.67.64.64,0,0,1,.37-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M163,335.48c.23.13.28,1.38.24,2.63a8.35,8.35,0,0,1-.38,2.72.55.55,0,0,1-.3.36l-1.42.75-.32.17a7.07,7.07,0,0,1-1.87.58,2.44,2.44,0,0,1-.66,0h0a2.39,2.39,0,0,1-.55-.2l-.62-.36a.65.65,0,0,1-.32-.38.53.53,0,0,1,.11-.47c-.06-.19,1.18-1.25,1.47-1.42l.48-.31a1.64,1.64,0,0,1,.54-.18,2.87,2.87,0,0,0,.49-.89,8.31,8.31,0,0,1,.9-1.61,10.84,10.84,0,0,1,.94-1.36.5.5,0,0,1,.37-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M162.57,336.53c.22.13.29,1.16.25,2.21a5.65,5.65,0,0,1-.37,2.28.57.57,0,0,1-.26.31l-1.33.68a1.73,1.73,0,0,1-.3.16,5.46,5.46,0,0,1-1.76.49,2.51,2.51,0,0,1-.61-.05h0a2.25,2.25,0,0,1-.51-.2l-.57-.33a.65.65,0,0,1-.3-.34.46.46,0,0,1,.06-.41c-.06-.21,1-1.11,1.27-1.29l.43-.27a1.62,1.62,0,0,1,.48-.17,1.56,1.56,0,0,0,.49-.76,14.38,14.38,0,0,1,.91-1.34,6.14,6.14,0,0,1,.95-1.05.38.38,0,0,1,.36-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M162.16,337.58c.23.13.31.95.28,1.78a4,4,0,0,1-.36,1.85.6.6,0,0,1-.23.25l-1.24.63a1.83,1.83,0,0,1-.28.14,4.5,4.5,0,0,1-1.65.41,5,5,0,0,1-.56-.08h0a2.22,2.22,0,0,1-.47-.2l-.54-.3a.62.62,0,0,1-.27-.29.41.41,0,0,1,0-.36c-.07-.22.73-1,1.06-1.16l.38-.24a2,2,0,0,1,.43-.15s.44-.37.47-.63a9.51,9.51,0,0,1,.93-1.07,3.92,3.92,0,0,1,1-.74c0-.22.35-.2.36-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M161.76,338.63c.23.13.32.73.3,1.35a2.41,2.41,0,0,1-.36,1.42.53.53,0,0,1-.2.19l-1.14.58-.26.13a3.81,3.81,0,0,1-1.53.31,1.51,1.51,0,0,1-.52-.11h0a4.27,4.27,0,0,1-.43-.18l-.5-.28a.61.61,0,0,1-.24-.24.43.43,0,0,1,0-.31c-.07-.24.52-.84.86-1l.34-.2a2.24,2.24,0,0,1,.36-.14s.45-.32.47-.5a5.46,5.46,0,0,1,.94-.8,2.36,2.36,0,0,1,1-.43c0-.15.34-.08.35-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M161.36,339.67a1,1,0,0,1,.31.93,1.53,1.53,0,0,1-.35,1,.73.73,0,0,1-.16.14l-1,.52-.24.12a3,3,0,0,1-1.43.22,1.42,1.42,0,0,1-.47-.13h0l-.38-.18-.46-.25a.54.54,0,0,1-.22-.2.41.41,0,0,1-.08-.25c-.07-.25.3-.7.66-.91l.29-.15a2.88,2.88,0,0,1,.31-.13s.45-.28.46-.36a3.33,3.33,0,0,1,.95-.54,1.72,1.72,0,0,1,1-.12c0-.07.35.05.35.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M157.91,342.4l-.77-.4c-.5-.29-.44-.79.14-1.13l.95-.46a2.16,2.16,0,0,1,2-.08l.76.39c.51.29.44.8-.14,1.14l-.94.46A2.19,2.19,0,0,1,157.91,342.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M163.25,270.9c-2.59.42-10.16,10.74-11.14,13.16s-.28,13.85-.28,13.85-.18-.44.89,0c2.07.88,1.59,1.64,1.59,1.64l3.17-12.21,8.05-7.51S165.85,270.49,163.25,270.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M165.53,279.85a25.53,25.53,0,0,0-.28-4.55c-3.26,2.61-8.76,9.39-9.59,11.43-.64,1.58-.71,6.8-.68,10.27l2.5-9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M164.57,336.08v3c0,1-5.07,3.81-6,3.89s-3.21-.93-2-1.95,3.73-3.2,3.73-4.54S164.57,336.08,164.57,336.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M163.74,335.93c0,.67,0,1.65,0,2.17,0,1-4.38,3.93-5.28,4-.51.05-1.77-.57-1.89-1.08l0,0c-1.18,1,1.13,2,2,1.95s6-2.92,6-3.89v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M151.49,328.16s.73,2.62,1.12,3.58-3.82,3.31-5.32,4-4.08-.7-3-1.51,3.5-2.81,3.31-4.23S151.49,328.16,151.49,328.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M152.61,331.74c-.39-1-1.12-3.58-1.12-3.58s-.35,0-.83.11a24.21,24.21,0,0,1,.72,2.94c.13,1.06-3.33,3-4.71,3.58a2.89,2.89,0,0,1-2.54-.36c-.47.8,1.79,1.87,3.16,1.28S153,332.7,152.61,331.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M161.05,295.64s-10.43,4.17-16.57,7.48c-5.36,2.88-4.92,4.94-4.42,7.19.7,3.18,7.39,20.39,7.39,20.39a3.83,3.83,0,0,0,2.46,0c2.79-1,2.16-1.85,2.16-1.85L148.84,312l23.76-8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M168.07,300.66l-1.31-.94-18.44,10.51a2.47,2.47,0,0,0-1.26,2.65L151,330.24c1.53-.79,1.09-1.39,1.09-1.39L148.84,312,167,305.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M166.9,298.13s-7.57,13.31-8.58,16c-1.23,3.22,1.6,22.9,1.6,22.9a4.46,4.46,0,0,0,2.75.88c1.88.07,2.43-.62,2.43-.62s1.78-18.36,2-19.67,8.11-5.28,10.52-7.39c4.47-3.93,1.15-14.57,1.15-14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M161.24,273.19c-.06,2.84-1.12,23.07-1.12,23.07a13.77,13.77,0,0,0,7.24,4.39c5.59,1.51,12.39-.94,12.39-.94s-.17-7.68-.21-13,.46-9,.13-11.23c-.19-1.25-2.89-2.91-7-4.79S161.31,270.14,161.24,273.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M174.54,273.32c0,2.22-5.67,4.55-5.67,4.55s-2.82-2.29-2.82-4.55c0-1.35,1.9-2.45,4.25-2.45S174.54,272,174.54,273.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M152.1,296.82s-.9,1.84-1.2,2.48-.24,3.58.65,4.24,2.76-1.74,2.76-1.74l.36-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M166.5,267.31c-.14-.87.95-1.79,2.46-2.05s2.84.23,3,1.1h0s1.62,6.31,1.63,6.32c.18,1.05-1.14,2.16-3,2.47s-3.42-.28-3.6-1.33c0,0-.54-6.51-.54-6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M171.38,269.53a10.22,10.22,0,0,0,.2-3.79,3.25,3.25,0,0,0-2.62-.48c-1.51.26-2.6,1.18-2.46,2.05h0s.53,6.5.54,6.51a1.28,1.28,0,0,0,.32.62A8.31,8.31,0,0,0,171.38,269.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M164.22,262.9c-1.23,2.46.17,10.3,2.66,10.25s4.75-3.17,5.32-5.21.45-6.28-1.76-7.25A4.73,4.73,0,0,0,164.22,262.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M179.43,298.24l-3.74,2.24c0,7.75-2.29,8.54-7.22,12.32-3.86,3-3.62,3.05-3.62,7.62,0,3.74-.47,12.53-.64,17.32a1.85,1.85,0,0,0,.89-.47s1.78-18.36,2-19.67,8.12-5.28,10.53-7.39C180.71,307.51,180.11,301.64,179.43,298.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M162.06,262.5c-.45,1.66.85,3.22,3.79,3a12.14,12.14,0,0,0,4.25-.91s.11,2.38.45,2.44.57-1.76,1.3-1.48.15,2.87.77,3.32.87-1.05.87-2.86.4-6.44-3.62-6.72S162.43,261.13,162.06,262.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M162.42,313.3l-17.67-10.2a.83.83,0,0,1-.47-.67v-.87c0-.31.23.22.67,0l10-5.79a3,3,0,0,1,2.72-.11l17.67,10.2c.23.13.4-.44.46-.26s0,.87,0,.93a1.11,1.11,0,0,1-.66.9l-10,5.79A3,3,0,0,1,162.42,313.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M162.42,312.44l-17.67-10.2c-.7-.4-.61-1.1.2-1.57l10-5.79a3,3,0,0,1,2.72-.11L175.36,305c.7.4.61,1.11-.19,1.57l-10,5.79A3,3,0,0,1,162.42,312.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M163.6,312.36a2.13,2.13,0,0,1-1-.22l-17.66-10.2c-.11-.07-.3-.2-.3-.38s.19-.41.49-.58l10-5.79a2.74,2.74,0,0,1,1.36-.34,2,2,0,0,1,1,.23l17.66,10.2c.11.06.3.19.3.37s-.18.41-.49.59L165,312A2.74,2.74,0,0,1,163.6,312.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M163.29,310,149,301.74c-.29-.17-.25-.46.08-.65l5.38-3.11a1.26,1.26,0,0,1,1.13,0l14.34,8.28c.29.17.25.46-.08.65L164.41,310A1.23,1.23,0,0,1,163.29,310Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M154.73,298.59l.92.53a.45.45,0,0,0,.42,0c.12-.07.12-.18,0-.24l-.92-.53a.48.48,0,0,0-.42,0A.13.13,0,0,0,154.73,298.59Zm1.57.91.44.25a.45.45,0,0,0,.42,0c.12-.07.12-.18,0-.24l-.44-.26a.51.51,0,0,0-.42,0A.14.14,0,0,0,156.3,299.5Zm1.09.63.44.25a.45.45,0,0,0,.42,0c.12-.07.12-.18,0-.24l-.44-.26a.51.51,0,0,0-.42,0A.14.14,0,0,0,157.39,300.13Zm1.09.63.44.25a.45.45,0,0,0,.42,0,.13.13,0,0,0,0-.25l-.44-.25a.51.51,0,0,0-.42,0A.14.14,0,0,0,158.48,300.76Zm1.09.63.44.25a.51.51,0,0,0,.42,0,.13.13,0,0,0,0-.25l-.44-.25a.48.48,0,0,0-.42,0A.14.14,0,0,0,159.57,301.39Zm1.09.62.44.26a.51.51,0,0,0,.42,0,.13.13,0,0,0,0-.25l-.44-.25a.45.45,0,0,0-.42,0C160.55,301.84,160.55,302,160.66,302Zm1.09.63.44.26a.51.51,0,0,0,.42,0,.13.13,0,0,0,0-.25l-.44-.25a.45.45,0,0,0-.42,0C161.64,302.47,161.64,302.58,161.75,302.64Zm1.09.63.44.26a.51.51,0,0,0,.42,0,.13.13,0,0,0,0-.25l-.44-.25a.45.45,0,0,0-.42,0C162.73,303.1,162.73,303.21,162.84,303.27Zm1.09.63.44.25a.48.48,0,0,0,.42,0,.13.13,0,0,0,0-.25l-.44-.25a.45.45,0,0,0-.42,0C163.82,303.73,163.82,303.84,163.93,303.9Zm1.09.63.44.25a.45.45,0,0,0,.42,0c.12-.06.12-.17,0-.24l-.44-.25a.45.45,0,0,0-.42,0C164.91,304.36,164.91,304.47,165,304.53Zm1.09.63.44.25a.45.45,0,0,0,.42,0c.12-.06.12-.17,0-.24l-.43-.25a.47.47,0,0,0-.43,0A.13.13,0,0,0,166.11,305.16Zm1.09.63.44.25a.45.45,0,0,0,.42,0c.12-.06.12-.17,0-.24l-.43-.25a.47.47,0,0,0-.43,0C167.09,305.61,167.09,305.72,167.2,305.79Zm1.12.64.43.26a.51.51,0,0,0,.42,0,.13.13,0,0,0,0-.25l-.43-.25a.45.45,0,0,0-.42,0C168.2,306.26,168.2,306.37,168.32,306.43Zm-14.57-7.24.38.22a.57.57,0,0,0,.48,0l.37-.22a.15.15,0,0,0,0-.28l-.38-.21a.54.54,0,0,0-.48,0l-.37.22C153.61,299,153.62,299.11,153.75,299.19Zm1.95.85.37-.22a.15.15,0,0,0,0-.28l-.38-.21a.54.54,0,0,0-.48,0l-.37.22c-.14.08-.13.2,0,.28l.38.22A.57.57,0,0,0,155.7,300Zm.23.41.38.21a.54.54,0,0,0,.48,0l.37-.22a.15.15,0,0,0,0-.28l-.38-.22a.57.57,0,0,0-.48,0l-.37.22C155.79,300.25,155.8,300.37,155.93,300.45Zm1.09.63.38.21a.54.54,0,0,0,.48,0l.37-.22a.15.15,0,0,0,0-.28l-.38-.22a.57.57,0,0,0-.48,0l-.37.22A.15.15,0,0,0,157,301.08Zm2.32.35-.38-.22a.57.57,0,0,0-.48,0l-.37.22a.15.15,0,0,0,0,.28l.38.21a.51.51,0,0,0,.48,0l.37-.21A.15.15,0,0,0,159.34,301.43Zm1.09.63-.38-.22a.57.57,0,0,0-.48,0l-.37.22c-.13.07-.13.2,0,.28l.38.21a.51.51,0,0,0,.48,0l.37-.21A.15.15,0,0,0,160.43,302.06Zm1.09.63-.38-.22a.54.54,0,0,0-.48,0l-.37.22a.14.14,0,0,0,0,.27l.38.22a.51.51,0,0,0,.48,0l.37-.21A.15.15,0,0,0,161.52,302.69Zm1.09.63-.38-.22a.51.51,0,0,0-.48,0l-.37.22a.14.14,0,0,0,0,.27l.38.22a.51.51,0,0,0,.48,0l.37-.21A.15.15,0,0,0,162.61,303.32Zm1.09.63-.38-.22a.51.51,0,0,0-.48,0l-.37.22a.14.14,0,0,0,0,.27l.38.22a.51.51,0,0,0,.48,0l.37-.21A.15.15,0,0,0,163.7,304Zm1.09.63-.38-.22a.51.51,0,0,0-.48,0l-.37.22a.14.14,0,0,0,0,.27l.38.22a.51.51,0,0,0,.48,0l.37-.21C164.92,304.78,164.92,304.65,164.79,304.58Zm-.14.9.38.22a.51.51,0,0,0,.48,0l.37-.22a.14.14,0,0,0,0-.27l-.38-.22a.51.51,0,0,0-.48,0l-.37.22A.14.14,0,0,0,164.65,305.48Zm2.32.36-.38-.22a.51.51,0,0,0-.48,0l-.37.21c-.13.08-.13.21,0,.28l.38.22a.51.51,0,0,0,.48,0l.37-.22A.14.14,0,0,0,167,305.84Zm1.6.92-.86-.5a.51.51,0,0,0-.48,0l-.38.22a.14.14,0,0,0,0,.27l.86.5a.51.51,0,0,0,.48,0l.38-.21A.15.15,0,0,0,168.57,306.76Zm-15.83-7,.86.5a.51.51,0,0,0,.48,0l.37-.22c.14-.07.14-.2,0-.27l-.86-.5a.51.51,0,0,0-.48,0l-.37.21C152.6,299.57,152.61,299.69,152.74,299.77Zm1.57.91.38.22a.57.57,0,0,0,.48,0l.37-.22c.14-.07.14-.2,0-.27l-.37-.22a.51.51,0,0,0-.48,0l-.38.21A.15.15,0,0,0,154.31,300.68Zm1.47.85a.57.57,0,0,0,.48,0l.37-.22c.14-.07.14-.2,0-.28l-.37-.21a.51.51,0,0,0-.48,0l-.38.21a.15.15,0,0,0,0,.28Zm1.09.63a.57.57,0,0,0,.48,0l.37-.22c.14-.08.14-.2,0-.28l-.37-.21a.51.51,0,0,0-.48,0l-.38.21a.15.15,0,0,0,0,.28Zm1.09-.09-.38.22a.15.15,0,0,0,0,.28l.38.22a.57.57,0,0,0,.48,0l.38-.22c.13-.08.13-.2,0-.28l-.37-.21A.54.54,0,0,0,158,302.07Zm1.11.62-.42.24a.13.13,0,0,0,0,.25l.42.25a.49.49,0,0,0,.44,0l.42-.24a.13.13,0,0,0,0-.25l-.43-.25A.47.47,0,0,0,159.07,302.69Zm1.09.63-.42.24a.13.13,0,0,0,0,.25l.42.25a.49.49,0,0,0,.44,0l.42-.24c.12-.07.12-.19,0-.25l-.43-.25A.47.47,0,0,0,160.16,303.32Zm1.09.63-.42.24a.13.13,0,0,0,0,.25l.42.25a.49.49,0,0,0,.44,0l.42-.24a.14.14,0,0,0,0-.26l-.43-.24A.47.47,0,0,0,161.25,304Zm1.09.63-.42.24a.13.13,0,0,0,0,.25l.42.25a.49.49,0,0,0,.44,0l.42-.25c.12-.06.12-.18,0-.25l-.43-.24A.47.47,0,0,0,162.34,304.58Zm1.09.63-.42.24a.13.13,0,0,0,0,.25l.42.25a.49.49,0,0,0,.44,0l.42-.25c.12-.06.12-.18,0-.25l-.43-.24A.47.47,0,0,0,163.43,305.21Zm1.53,1.37.42-.25a.13.13,0,0,0,0-.25l-.43-.24a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l.42.25A.49.49,0,0,0,165,306.58Zm1.09.63.42-.25a.13.13,0,0,0,0-.25l-.43-.24a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l.42.25A.52.52,0,0,0,166.05,307.21Zm1.53.15-.42-.25a.49.49,0,0,0-.44,0l-.42.24a.13.13,0,0,0,0,.25l.43.25a.47.47,0,0,0,.43,0l.42-.24C167.7,307.54,167.7,307.42,167.58,307.36Zm-15.87-7,1.36.79a.49.49,0,0,0,.44,0l.42-.24a.13.13,0,0,0,0-.25l-1.37-.79a.47.47,0,0,0-.43,0l-.43.24C151.58,300.16,151.59,300.27,151.71,300.34Zm2,1.18.42.24a.49.49,0,0,0,.44,0l.42-.24a.13.13,0,0,0,0-.25l-.43-.25a.47.47,0,0,0-.43,0l-.42.24A.14.14,0,0,0,153.74,301.52Zm1.09.62.42.25a.49.49,0,0,0,.44,0l.42-.24a.13.13,0,0,0,0-.25l-.43-.25a.47.47,0,0,0-.43,0l-.42.24C154.71,302,154.71,302.08,154.83,302.14Zm1.09.63.42.25a.49.49,0,0,0,.44,0l.42-.24a.13.13,0,0,0,0-.25l-.43-.25a.47.47,0,0,0-.43,0l-.42.24A.13.13,0,0,0,155.92,302.77Zm2,.88.42-.24c.12-.07.12-.19,0-.25l-.43-.25a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l.42.25A.49.49,0,0,0,157.87,303.65Zm1.09.63.42-.24a.14.14,0,0,0,0-.26l-.43-.24a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l.42.25A.49.49,0,0,0,159,304.28Zm1.09.63.42-.25c.12-.06.12-.18,0-.25l-.43-.24a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l.42.25A.49.49,0,0,0,160.05,304.91Zm1.09.63.42-.25a.13.13,0,0,0,0-.25l-.43-.24a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l.42.25A.49.49,0,0,0,161.14,305.54Zm1.09.63.42-.25a.13.13,0,0,0,0-.25l-.43-.24a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l.42.25A.52.52,0,0,0,162.23,306.17Zm1.09.63.42-.25a.13.13,0,0,0,0-.25l-.43-.24a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l.42.24A.52.52,0,0,0,163.32,306.8Zm.23.38.42.24a.49.49,0,0,0,.44,0l.42-.24a.13.13,0,0,0,0-.25l-.43-.24a.47.47,0,0,0-.43,0l-.42.24A.13.13,0,0,0,163.55,307.18Zm3,.76-1.08-.62a.47.47,0,0,0-.43,0l-.42.24a.13.13,0,0,0,0,.25l1.08.62a.47.47,0,0,0,.43,0l.42-.24A.13.13,0,0,0,166.57,307.94Zm-15.87-7,1.94,1.12a.53.53,0,0,0,.49,0l.36-.21c.14-.07.14-.2,0-.28l-1.94-1.12a.53.53,0,0,0-.49,0l-.36.21C150.56,300.75,150.56,300.88,150.7,301Zm2.66,1.54.37.21a.53.53,0,0,0,.49,0l.36-.21c.14-.07.14-.2,0-.28l-.36-.21a.53.53,0,0,0-.49,0l-.37.21A.15.15,0,0,0,153.36,302.49Zm1.09.63.37.21a.53.53,0,0,0,.49,0l.36-.21c.14-.07.14-.2,0-.28l-.36-.21a.53.53,0,0,0-.49,0l-.37.21A.15.15,0,0,0,154.45,303.12Zm1.09.63.37.21a.53.53,0,0,0,.49,0l.37-.21c.13-.08.13-.2,0-.28l-.36-.21a.53.53,0,0,0-.49,0l-.37.21A.15.15,0,0,0,155.54,303.75Zm1.09.63.37.21a.53.53,0,0,0,.49,0l.37-.21c.13-.08.13-.2,0-.28l-.36-.21a.53.53,0,0,0-.49,0l-.37.21C156.5,304.17,156.5,304.3,156.63,304.38Zm1.09.63.37.21a.53.53,0,0,0,.49,0L159,305c.13-.08.13-.2,0-.28l-.36-.21a.53.53,0,0,0-.49,0l-.37.21C157.59,304.8,157.59,304.93,157.72,305Zm1.09.63.37.21a.53.53,0,0,0,.49,0l.37-.21c.13-.08.13-.2,0-.28l-.36-.21a.56.56,0,0,0-.49,0l-.37.22C158.68,305.43,158.68,305.56,158.81,305.64Zm1.09.63.37.21a.53.53,0,0,0,.49,0l.37-.21c.13-.08.13-.2,0-.28l-.36-.21a.56.56,0,0,0-.49,0l-.37.21A.16.16,0,0,0,159.9,306.27Zm1.09.63.37.21a.53.53,0,0,0,.49,0l.37-.21a.15.15,0,0,0,0-.28l-.36-.22a.6.6,0,0,0-.49,0l-.37.21A.16.16,0,0,0,161,306.9Zm1.09.63.37.21a.53.53,0,0,0,.49,0l.37-.21a.15.15,0,0,0,0-.28l-.36-.22a.6.6,0,0,0-.49,0l-.37.21A.16.16,0,0,0,162.08,307.53Zm1.09.63.37.21a.53.53,0,0,0,.49,0l.37-.21a.15.15,0,0,0,0-.28l-.36-.22a.53.53,0,0,0-.49,0l-.37.21A.16.16,0,0,0,163.17,308.16Zm2.34.36-.37-.21a.53.53,0,0,0-.49,0l-.36.21c-.14.07-.14.2,0,.28l.37.21a.53.53,0,0,0,.49,0l.36-.21C165.65,308.72,165.64,308.6,165.51,308.52Zm-14.12-7-.85-.5a.6.6,0,0,0-.49,0l-.36.21a.15.15,0,0,0,0,.29l.85.49a.53.53,0,0,0,.49,0l.37-.21A.15.15,0,0,0,151.39,301.54Zm1.09.62-.36-.21a.53.53,0,0,0-.49,0l-.37.21a.16.16,0,0,0,0,.29l.37.21a.53.53,0,0,0,.49,0l.37-.21C152.62,302.37,152.62,302.24,152.48,302.16Zm1.09.63-.36-.21a.53.53,0,0,0-.49,0l-.37.21a.16.16,0,0,0,0,.29l.37.21a.53.53,0,0,0,.49,0l.37-.21C153.71,303,153.71,302.87,153.57,302.79Zm7.64,4.41-6.91-4a.53.53,0,0,0-.49,0l-.37.21c-.13.08-.13.21,0,.28l6.91,4a.53.53,0,0,0,.49,0l.37-.21C161.34,307.41,161.34,307.28,161.21,307.2Zm1.09.63-.37-.21a.53.53,0,0,0-.49,0l-.37.21c-.13.08-.13.2,0,.28l.36.21a.53.53,0,0,0,.49,0l.37-.21A.15.15,0,0,0,162.3,307.83Zm1.09.63-.37-.21a.53.53,0,0,0-.49,0l-.37.21c-.13.07-.13.2,0,.28l.36.21a.53.53,0,0,0,.49,0l.37-.21A.15.15,0,0,0,163.39,308.46Zm1.11.64-.37-.21a.53.53,0,0,0-.49,0l-.36.21c-.14.08-.14.2,0,.28l.37.21a.56.56,0,0,0,.49,0l.36-.22C164.64,309.31,164.64,309.18,164.5,309.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M162.55,312.41l-17.47-10a3.56,3.56,0,0,1-1.43-2.38l-1.76-14c-.12-.92.34-1.36,1-1l17.47,10a3.56,3.56,0,0,1,1.43,2.37l1.76,14C163.68,312.36,163.22,312.79,162.55,312.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M160.66,294.85l-17.46-10a.75.75,0,0,0-.68-.09l-.33.22h0a.67.67,0,0,1,.71.07l17.47,10a3.56,3.56,0,0,1,1.43,2.37l1.76,14c.08.57-.07,1-.36,1.07a.16.16,0,0,0,.09,0l.34-.24a1.09,1.09,0,0,0,.23-1l-1.76-14A3.49,3.49,0,0,0,160.66,294.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M171.34,301.61a4.41,4.41,0,0,1-1.49.53c-.88.14-1.34-.2-2.56.11s-2.72,2.34-1.66,3.18c.74.59,2-.13,3.07-.27.45-.07,1.34,0,1.8,0,1.51-.06,2.85-1.91,2.85-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M169.8,301.07a26.91,26.91,0,0,0,9.95-1.36s-.17-7.68-.21-13c0-4.76.37-8.33.19-10.61l-4.07,3c0,4.77.37,11.57.37,14.69C176,295.72,171.79,300.61,169.8,301.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M177.47,274.39c1.52-.7,3.81,1.67,5.34,6.66s5.62,11.05,4.84,13.13-15.1,10.24-15.1,10.24a4.19,4.19,0,0,0-.92-1.69c-.77-.93-1.13-.93-1.13-.93L181,292.33a47.71,47.71,0,0,1-5.8-10.18C173.59,277.85,174.9,275.57,177.47,274.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M269.48,221.56s-1.13-2.57-2.16-3.27-3.43-1.4-3.92-1.13-.1,1.36.48,2.11.78,1.12,1.27,1.68a21.09,21.09,0,0,1,2.16,1.92C267.69,223.34,269.48,221.56,269.48,221.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M265.76,217.1c-.24,0-.55.27-.31.76s.71.91.94,1.29A7.54,7.54,0,0,0,268,220.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M268.17,218.81a7.47,7.47,0,0,0-1.36-1.31c-.38-.3-.43-.69-.65-.7s-.67.27,0,1.14a9.94,9.94,0,0,1,1.3,1.93c.24.59.77,1.7,1.18,1.77s.65-.54.65-.54S268.26,219.06,268.17,218.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M269.21,220.54a3.45,3.45,0,0,0-1.52.77,3.3,3.3,0,0,0-.9,1.31s5.15,6.76,7.86,9.65,9.92,9.31,12.3,6.58c1.13-1.29.41-3.19-2.15-4.84a69.43,69.43,0,0,1-8.16-5.7A81,81,0,0,1,269.21,220.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M277,237.28a3.83,3.83,0,1,1-5.19-1.56A3.83,3.83,0,0,1,277,237.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M261.76,207.61l-8.3,4.47,15.45,28.4h0l0,0c.71,1.33,3.15,1.41,5.44.18s3.57-3.32,2.85-4.65l0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M261.77,207.63c.72,1.33-.56,3.41-2.85,4.65s-4.73,1.15-5.45-.18.56-3.42,2.85-4.65S261.05,206.29,261.77,207.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M256.89,202.7,252,205.35l3,5.37h0v0c.43.8,1.88.84,3.24.11s2.12-2,1.69-2.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M260.53,222a20.39,20.39,0,0,1-.67-2c-.13-.57-.33-1.13-.61-1-.56.17.06,2.56.06,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M259.42,220.9a7.43,7.43,0,0,1-1.18-1.47c-.19-.38-.49-1.7-.73-1.84s-.27.23-.27.23-.09-.45-.37-.35-.15.55-.15.55-.07-.22-.29,0,.1.73.1.73-.09-.1-.17,0a2.75,2.75,0,0,0,.16.86s-.24,0-.15.34a11.33,11.33,0,0,0,.84,2c.19.32,1.69,2.11,1.69,2.11l2.1-.81a13.31,13.31,0,0,0-.58-1.58A2.64,2.64,0,0,0,259.42,220.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.5,301a6.21,6.21,0,0,0-3.1.75l-1.08,1a3.28,3.28,0,0,0-1.78,2.83,3.81,3.81,0,0,0,2.14,3.22l10.67,8a7.73,7.73,0,0,0,3.77.95,6.21,6.21,0,0,0,3.1-.74l4.36-1.95a3.26,3.26,0,0,0,1.78-2.83,3.81,3.81,0,0,0-2.14-3.22l-7-3.55-7-3.54A7.62,7.62,0,0,0,294.5,301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M290.41,302.77a3.18,3.18,0,0,0-1.72,2.72,3.69,3.69,0,0,0,2.05,3.1l2,1.53,1.78,1.35s6.42,4.82,6.45,4.82a7.36,7.36,0,0,0,3.62.9,6.48,6.48,0,0,0,1.56-.18,5,5,0,0,0,1.41-.54l4.2-1.88a3.16,3.16,0,0,0,1.71-2.72,3.66,3.66,0,0,0-2.05-3.09l-2-1-1.92-1-2.76-1.41S298.06,302,298,302a7.06,7.06,0,0,0-2.08-.75,7.78,7.78,0,0,0-1.53-.14,6.08,6.08,0,0,0-3,.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M290.49,302.83a3,3,0,0,0-1.64,2.6,3.51,3.51,0,0,0,1.95,3l1.95,1.47,1.72,1.29s6.14,4.6,6.19,4.6a7.13,7.13,0,0,0,3.47.85,6.65,6.65,0,0,0,1.51-.17,5.21,5.21,0,0,0,1.35-.53l4-1.8a3.05,3.05,0,0,0,1.65-2.61,3.52,3.52,0,0,0-2-3l-1.94-1-1.84-.94-2.65-1.35s-6.41-3.22-6.45-3.21a6.89,6.89,0,0,0-2-.71,8,8,0,0,0-1.47-.13,5.7,5.7,0,0,0-2.85.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M290.58,302.88a2.93,2.93,0,0,0-1.58,2.49,3.36,3.36,0,0,0,1.86,2.85l1.87,1.41,1.64,1.25c.06,0,5.87,4.37,5.94,4.36a6.87,6.87,0,0,0,3.33.81,7.28,7.28,0,0,0,1.44-.17,5.11,5.11,0,0,0,1.29-.51l3.85-1.73a2.89,2.89,0,0,0,1.58-2.49,3.39,3.39,0,0,0-1.86-2.86l-1.86-1-1.75-.91-2.55-1.29c-.07,0-6.13-3.06-6.19-3a6.54,6.54,0,0,0-1.91-.66,7.32,7.32,0,0,0-1.41-.12,5.63,5.63,0,0,0-2.73.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M290.67,302.93a2.8,2.8,0,0,0-1.52,2.38,3.21,3.21,0,0,0,1.77,2.73l1.79,1.35,1.56,1.19c.08,0,5.6,4.15,5.7,4.14a6.55,6.55,0,0,0,4.55.59,5.09,5.09,0,0,0,1.24-.49l3.67-1.65a2.8,2.8,0,0,0,1.52-2.39,3.21,3.21,0,0,0-1.78-2.73s-1.74-.9-1.76-.91l-1.68-.88s-2.4-1.22-2.44-1.23-5.84-2.9-5.93-2.87a6,6,0,0,0-1.82-.62,7.53,7.53,0,0,0-1.35-.1,5.39,5.39,0,0,0-2.6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M290.75,303a2.68,2.68,0,0,0-1.45,2.26,3.09,3.09,0,0,0,1.68,2.61l1.7,1.28,1.5,1.14c.09.06,5.32,3.93,5.44,3.92a6.28,6.28,0,0,0,3,.7,5.53,5.53,0,0,0,1.31-.16,4.93,4.93,0,0,0,1.18-.47l3.5-1.58a2.67,2.67,0,0,0,1.45-2.27,3.08,3.08,0,0,0-1.69-2.61l-1.68-.88-1.6-.84-2.32-1.17c-.12,0-5.57-2.73-5.67-2.71a6.46,6.46,0,0,0-1.74-.57,7.84,7.84,0,0,0-1.29-.08,5.19,5.19,0,0,0-2.47.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M290.84,303a2.52,2.52,0,0,0-1.38,2.15,2.92,2.92,0,0,0,1.58,2.49l1.62,1.22,1.42,1.08c.12.07,5.05,3.71,5.19,3.7a6.1,6.1,0,0,0,4.14.49,4.86,4.86,0,0,0,1.12-.45l3.33-1.5a2.58,2.58,0,0,0,1.39-2.16,2.94,2.94,0,0,0-1.6-2.49s-1.56-.82-1.6-.84l-1.52-.81s-2.15-1.09-2.21-1.11-5.28-2.57-5.41-2.54a5.89,5.89,0,0,0-1.65-.52,7.15,7.15,0,0,0-1.22-.08,5,5,0,0,0-2.36.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M290.93,303.09a2.43,2.43,0,0,0-1.32,2,2.78,2.78,0,0,0,1.49,2.37l1.54,1.16,1.34,1c.14.08,4.78,3.48,4.95,3.47a5.82,5.82,0,0,0,2.75.6,5.42,5.42,0,0,0,1.17-.16,4.43,4.43,0,0,0,1.07-.43l3.15-1.43a2.41,2.41,0,0,0,1.32-2,2.75,2.75,0,0,0-1.5-2.37s-1.47-.78-1.52-.8l-1.43-.78c-.06,0-2-1-2.11-1.05s-5-2.41-5.14-2.37a5.81,5.81,0,0,0-1.58-.48,7.26,7.26,0,0,0-1.15-.06,4.76,4.76,0,0,0-2.23.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M291,303.15a2.3,2.3,0,0,0-1.25,1.92,2.62,2.62,0,0,0,1.4,2.24c0,.05,1.39,1.07,1.45,1.1l1.27,1c.16.09,4.51,3.26,4.7,3.25a5.5,5.5,0,0,0,2.6.55,5.6,5.6,0,0,0,1.12-.16,4.44,4.44,0,0,0,1-.4l3-1.36a2.32,2.32,0,0,0,1.26-1.94,2.61,2.61,0,0,0-1.41-2.24s-1.38-.74-1.44-.77l-1.35-.73c-.07,0-1.92-1-2-1s-4.71-2.25-4.88-2.2A5.49,5.49,0,0,0,295,302a7.83,7.83,0,0,0-1.09,0,4.63,4.63,0,0,0-2.1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M291.1,303.2a2.2,2.2,0,0,0-1.19,1.81,2.48,2.48,0,0,0,1.31,2.12c0,.05,1.3,1,1.37,1l1.2.92c.17.11,4.23,3,4.44,3a5.17,5.17,0,0,0,2.46.49,5,5,0,0,0,1.05-.15,4.49,4.49,0,0,0,.95-.38l2.81-1.29a2.19,2.19,0,0,0,1.19-1.82,2.5,2.5,0,0,0-1.33-2.13s-1.29-.69-1.35-.72l-1.27-.7c-.07-.05-1.8-.91-1.88-.94s-4.43-2.09-4.62-2a5.73,5.73,0,0,0-1.41-.38,7,7,0,0,0-1,0,4.48,4.48,0,0,0-2,.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M291.19,303.25a2,2,0,0,0-1.12,1.7,2.32,2.32,0,0,0,1.21,2c.05.05,1.21.93,1.29,1l1.12.87c.2.11,4,2.81,4.2,2.8a5,5,0,0,0,2.31.44,4.28,4.28,0,0,0,1-.15,4.14,4.14,0,0,0,.89-.36l2.64-1.22a2,2,0,0,0,1.12-1.7,2.31,2.31,0,0,0-1.23-2s-1.2-.65-1.26-.68l-1.2-.67c-.08-.05-1.68-.85-1.77-.88s-4.15-1.93-4.36-1.87a5.69,5.69,0,0,0-1.32-.34,7.81,7.81,0,0,0-1,0,4.34,4.34,0,0,0-1.85.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M291.27,303.31a1.94,1.94,0,0,0-1,1.58,2.18,2.18,0,0,0,1.12,1.88c.05.05,1.12.86,1.21.91l1,.82c.22.12,3.69,2.59,4,2.58a4.75,4.75,0,0,0,2.17.39,4.53,4.53,0,0,0,.92-.15,3.81,3.81,0,0,0,.83-.34l2.46-1.14a2,2,0,0,0,1.06-1.6,2.18,2.18,0,0,0-1.14-1.88c0-.05-1.11-.61-1.18-.65l-1.11-.63c-.09-.05-1.56-.79-1.67-.82s-3.86-1.76-4.1-1.7a4.92,4.92,0,0,0-1.23-.3c-.25,0-.64,0-.9,0a4.07,4.07,0,0,0-1.73.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M291.36,303.36a1.81,1.81,0,0,0-1,1.47,2,2,0,0,0,1,1.76c.05.06,1,.8,1.12.85l1,.76a43.41,43.41,0,0,0,3.7,2.36,4.32,4.32,0,0,0,2.88.19,3.56,3.56,0,0,0,.77-.32l2.3-1.07a1.83,1.83,0,0,0,1-1.48,2,2,0,0,0-1.05-1.76c-.05-.06-1-.57-1.1-.61l-1-.6c-.1-.06-1.44-.73-1.56-.76-.28-.08-3.58-1.6-3.83-1.53a4.8,4.8,0,0,0-1.15-.25,5.89,5.89,0,0,0-.84,0,3.93,3.93,0,0,0-1.61.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M291.45,303.41a1.73,1.73,0,0,0-.93,1.36,1.88,1.88,0,0,0,.94,1.63c.06.07.94.74,1,.79l.9.71a32.81,32.81,0,0,0,3.45,2.14,4.33,4.33,0,0,0,1.88.29,3.85,3.85,0,0,0,.78-.15,3.31,3.31,0,0,0,.72-.3l2.12-1a1.71,1.71,0,0,0,.92-1.37,1.87,1.87,0,0,0-.95-1.64c-.06-.06-.93-.52-1-.58l-.95-.56c-.11-.06-1.32-.66-1.44-.7a37.87,37.87,0,0,0-3.58-1.37,5.2,5.2,0,0,0-1.07-.2,6.69,6.69,0,0,0-.77,0A3.67,3.67,0,0,0,292,303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M291.53,303.47a1.56,1.56,0,0,0-.85,1.24,1.72,1.72,0,0,0,.84,1.51c.06.07.85.67,1,.73l.82.66a27,27,0,0,0,3.2,1.91,4,4,0,0,0,1.73.23,3.37,3.37,0,0,0,.73-.14,2.9,2.9,0,0,0,.65-.28l1.95-.92a1.55,1.55,0,0,0,.86-1.25,1.75,1.75,0,0,0-.86-1.53c-.07-.06-.84-.47-.94-.53l-.87-.53c-.11-.06-1.2-.6-1.33-.64a28.28,28.28,0,0,0-3.31-1.2,5.25,5.25,0,0,0-1-.16c-.17,0-.53,0-.71,0a3.63,3.63,0,0,0-1.35.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M291.62,303.52a1.45,1.45,0,0,0-.79,1.13,1.55,1.55,0,0,0,.75,1.39c.07.08.76.6.87.67l.75.6a21.31,21.31,0,0,0,2.95,1.69,3.69,3.69,0,0,0,1.59.18,3.51,3.51,0,0,0,.66-.14,3.62,3.62,0,0,0,.6-.26l1.77-.84a1.47,1.47,0,0,0,.8-1.15,1.6,1.6,0,0,0-.78-1.4c-.06-.06-.75-.43-.85-.49l-.79-.49c-.12-.08-1.08-.55-1.22-.59a20.29,20.29,0,0,0-3.05-1,5.27,5.27,0,0,0-.9-.12c-.15,0-.49.06-.64.06a3.49,3.49,0,0,0-1.24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M291.71,303.57a1.34,1.34,0,0,0-.73,1,1.42,1.42,0,0,0,.66,1.27,8.59,8.59,0,0,0,.79.6l.68.55a15.1,15.1,0,0,0,2.7,1.47,3.47,3.47,0,0,0,1.44.13,4.68,4.68,0,0,0,.59-.13,3.84,3.84,0,0,0,.54-.25l1.61-.77a1.37,1.37,0,0,0,.73-1,1.46,1.46,0,0,0-.69-1.28c-.07-.07-.66-.39-.77-.46l-.7-.45a10.46,10.46,0,0,0-1.12-.53,15.61,15.61,0,0,0-2.79-.86,5.42,5.42,0,0,0-.81-.07c-.13,0-.45.07-.58.07a3.55,3.55,0,0,0-1.11.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M291.79,303.63a1.2,1.2,0,0,0-.66.9,1.27,1.27,0,0,0,.57,1.15,6.94,6.94,0,0,0,.71.54l.6.5a11.71,11.71,0,0,0,2.45,1.23,3.16,3.16,0,0,0,1.3.09,4,4,0,0,0,.52-.13,3.17,3.17,0,0,0,.49-.23l1.43-.69a1.25,1.25,0,0,0,.66-.92,1.28,1.28,0,0,0-.59-1.16,7.21,7.21,0,0,0-.68-.42l-.63-.42a10.39,10.39,0,0,0-1-.47,11.76,11.76,0,0,0-2.52-.7,5.93,5.93,0,0,0-.73,0c-.1,0-.42.09-.52.09a3.1,3.1,0,0,0-1,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M291.88,303.68a1,1,0,0,0-.12,1.81,4.46,4.46,0,0,0,.62.49l.53.44a8.57,8.57,0,0,0,2.2,1,3,3,0,0,0,1.16,0c.16,0,.31-.09.46-.13l.43-.2,1.25-.63a1.11,1.11,0,0,0,.6-.81,1.14,1.14,0,0,0-.5-1,5.63,5.63,0,0,0-.6-.38l-.55-.39a7.17,7.17,0,0,0-.89-.41,8.86,8.86,0,0,0-2.27-.53,2.74,2.74,0,0,0-.64,0c-.08,0-.38.1-.46.1a3.43,3.43,0,0,0-.86.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M292,303.73a1,1,0,0,0-.53.68,1,1,0,0,0,.38.9,3,3,0,0,0,.54.42l.45.39a6.17,6.17,0,0,0,2,.79,2.59,2.59,0,0,0,1,0,3.79,3.79,0,0,0,.4-.12l.37-.18,1.08-.56a.91.91,0,0,0,.13-1.6,4.28,4.28,0,0,0-.52-.35l-.47-.35a5,5,0,0,0-.78-.35,6.31,6.31,0,0,0-2-.36,2.12,2.12,0,0,0-.57.07c-.05,0-.33.11-.39.11a3.67,3.67,0,0,0-.73.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M292.05,303.78a.9.9,0,0,0-.46.57.83.83,0,0,0,.29.78,2.54,2.54,0,0,0,.46.36l.38.34a4.38,4.38,0,0,0,1.7.56,2.45,2.45,0,0,0,.86-.07,2.53,2.53,0,0,0,.33-.12l.32-.16.91-.48a.88.88,0,0,0,.46-.58.84.84,0,0,0-.32-.8,2.15,2.15,0,0,0-.43-.3l-.38-.32a4.09,4.09,0,0,0-.68-.29,4.22,4.22,0,0,0-1.74-.19,1.87,1.87,0,0,0-.48.11s-.3.13-.32.13-.57.27-.62.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M293.13,303.29l-1,.55c-.62.36-.55,1,.18,1.4l.3.29a2.74,2.74,0,0,0,2.44.1l1-.55c.62-.36.54-1-.18-1.4l-.3-.29A2.74,2.74,0,0,0,293.13,303.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M292.77,305.48c-.65,0-1.88-.45-1.88-.74s1.19-1.17,1.38-1.24a4,4,0,0,1,.65-.12l0-1.41s.89-.62,1.39-1a8.37,8.37,0,0,1,1.05-.72,20.82,20.82,0,0,1,1.55,1.6c.27.39-.26,1.13-1.33,1.7S293.11,305.46,292.77,305.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M297.05,301.92a1.11,1.11,0,0,1-.55,1.7c-.76.38-3.25,2-3.7,2.2a2.91,2.91,0,0,1-1.91-.79c-.05-.22,0-.29,0-.29s1.05.72,1.65.5a10.52,10.52,0,0,0,2.63-2A8.49,8.49,0,0,1,297.05,301.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M308.67,289.15s-11.27-8.22-12.1-9.1S281,260.72,281,260.72l12.53-2,7.69,18,8.94,9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M298,279.25l11.31,8.83-.61,1.07s-11.27-8.22-12.1-9.1S281,260.72,281,260.72l5-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M286.82,257.8s1.17.35,1.17,4.6-.23,20.28-.23,20.28l8.05,18a12.78,12.78,0,0,1-1.55,1.16,4.69,4.69,0,0,1-1.32.52L282.25,285A51.3,51.3,0,0,1,278,271.84c-.75-4.17-1.14-10.9-1.14-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M308.38,289a32.76,32.76,0,0,1,1.13,3.67c.17,1,.62,3.57,1.44,3.28s-1-9.36-1-9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M310.12,286.49c-1.42.22-.87,2.82-.55,4s.54,5.65,1.38,5.46a3.43,3.43,0,0,0,2.14-2.92c0-1.33-1-3.15-1.17-3.91S311.75,286.24,310.12,286.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M281.36,263.24l2.82,20.63L294,301.94a4.62,4.62,0,0,1-1.08.39L282.25,285A51.3,51.3,0,0,1,278,271.84c-.75-4.17-1.14-10.9-1.14-10.9l4.67-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M258.63,223.94s0-.34.84-.82a3.15,3.15,0,0,1,1.73-.37s3.83,8.62,5.22,9.6,7.62,4.84,7.62,4.84a5.17,5.17,0,0,0,3.49,0h0c4.42-1.51,7.39-3.42,9.32-1.38s8,23.68,8,23.68A43.49,43.49,0,0,1,287,264a26.16,26.16,0,0,1-10.05,1.65s-1.41-6.89-2.68-13.29a23.38,23.38,0,0,0-5.89-12.26c-2.32-2.58-4.39-4.5-4.69-4.77C262.63,234.41,258.63,223.94,258.63,223.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M276.78,238.21c.36.87,2.15,1,4,.2s3.05-2.08,2.69-2.95-2.14-1-4-.2S276.42,237.34,276.78,238.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M277.15,237.78c.33.81,1.9.93,3.5.27s2.63-1.84,2.3-2.65-1.9-.93-3.5-.27S276.82,237,277.15,237.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M276.4,234.62l.69,3.08,5.79-2.38s-.89-1.25-.57-2.11,4.33-5-1.09-8.2-6.25,2.67-6.68,4.36a7.25,7.25,0,0,0-.21,3.73C274.57,233.46,276.12,234.31,276.4,234.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M275.09,223.43c-1.57,1.18,2.11,4.94,2.11,4.94a7.6,7.6,0,0,0-.47,2.18c.12.42.73-1,1.51-.25s.78,3.66,1.19,4c.57.45,2.44-.05,2.86-.71s3.76-5.22.53-8.11S276.53,222.36,275.09,223.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M273.75,246c1.14,1,6.39,18.08,6.6,19.53a27.1,27.1,0,0,1-3.41.11s-1.41-6.89-2.68-13.29a30.35,30.35,0,0,0-4.11-10.32C271.44,243.57,273.09,245.46,273.75,246Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-318"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,6-2.7,6.06-2.73a5.84,5.84,0,0,1,5.44.32l39.32,22.7c4.43,2.56,8,9.43,8,15.35V245.8c0,3.14-1,5.38-2.63,6.41-.1.06-6.75,3.13-6.86,3.17C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.9-2.67,6-2.69a5.81,5.81,0,0,1,5.43.31l39.32,22.71c4.44,2.56,8,9.43,8,15.34V245.84c0,3.14-1,5.38-2.63,6.4-.09.06-6.65,3.1-6.76,3.14C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.81-2.63,5.87-2.66a5.82,5.82,0,0,1,5.43.32l39.32,22.7c4.44,2.56,8,9.44,8,15.35V245.87c0,3.14-1,5.38-2.64,6.41-.09.06-6.55,3.06-6.66,3.1C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.71-2.59,5.77-2.62a5.79,5.79,0,0,1,5.43.32l39.33,22.7c4.43,2.56,8,9.43,8,15.35V245.91c0,3.14-1,5.38-2.63,6.41-.1.06-6.46,3-6.57,3.06C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.61-2.56,5.68-2.58a5.79,5.79,0,0,1,5.43.31l39.32,22.71c4.44,2.56,8,9.43,8,15.34V245.94c0,3.15-1,5.39-2.63,6.41-.1.06-6.36,3-6.47,3C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.52-2.52,5.58-2.55a5.79,5.79,0,0,1,5.43.32L262,125.91c4.44,2.56,8,9.43,8,15.35V246c0,3.14-1,5.38-2.64,6.41-.09.06-6.26,3-6.37,3C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.42-2.49,5.48-2.51a5.81,5.81,0,0,1,5.43.31L261.91,126c4.43,2.56,8,9.43,8,15.34V246c0,3.14-1,5.38-2.63,6.4-.1.06-6.17,2.92-6.28,3C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.32-2.45,5.39-2.48a5.82,5.82,0,0,1,5.43.32L261.81,126c4.44,2.56,8,9.44,8,15.35V246.05c0,3.14-1,5.38-2.63,6.41-.1.06-6.07,2.88-6.18,2.92C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.22-2.41,5.29-2.44a5.79,5.79,0,0,1,5.43.32L261.71,126c4.44,2.56,8,9.43,8,15.35V246.09c0,3.14-1,5.38-2.63,6.41-.09.06-6,2.84-6.08,2.88C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5.13-2.38,5.19-2.4a5.79,5.79,0,0,1,5.43.31l39.33,22.71c4.43,2.56,8,9.43,8,15.34V246.12c0,3.15-1,5.39-2.63,6.41-.1.06-5.88,2.81-6,2.85C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,5-2.34,5.1-2.37a5.79,5.79,0,0,1,5.43.32l39.32,22.7c4.43,2.56,8,9.43,8,15.35V246.16c0,3.14-1,5.38-2.63,6.41-.1.06-5.78,2.77-5.89,2.81C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.93-2.31,5-2.33a5.81,5.81,0,0,1,5.43.31l39.32,22.71c4.44,2.56,8,9.43,8,15.34V246.2c0,3.14-1,5.38-2.63,6.4-.09.06-5.68,2.74-5.79,2.78C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.84-2.27,4.9-2.3a5.82,5.82,0,0,1,5.43.32l39.33,22.7c4.43,2.56,8,9.43,8,15.35V246.23c0,3.14-1,5.38-2.64,6.41-.09.06-5.58,2.7-5.69,2.74C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.74-2.24,4.8-2.26a5.81,5.81,0,0,1,5.44.32l39.32,22.7c4.43,2.56,8,9.43,8,15.34V246.27c0,3.14-1,5.38-2.63,6.41-.1.06-5.49,2.66-5.6,2.7C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.64-2.2,4.71-2.22a5.79,5.79,0,0,1,5.43.31l39.32,22.71c4.44,2.56,8,9.43,8,15.34V246.3c0,3.15-1,5.39-2.63,6.41-.09.06-5.39,2.63-5.5,2.67C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.55-2.16,4.61-2.19a5.79,5.79,0,0,1,5.43.32L261,126.27c4.44,2.56,8,9.43,8,15.35V246.34c0,3.14-1,5.38-2.64,6.41-.09.06-5.29,2.59-5.4,2.63C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.45-2.13,4.51-2.15a5.78,5.78,0,0,1,5.43.31l39.33,22.71c4.43,2.56,8,9.43,8,15.34V246.37c0,3.15-1,5.39-2.63,6.41-.1.06-5.2,2.56-5.31,2.6C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.35-2.09,4.42-2.12a5.82,5.82,0,0,1,5.43.32l39.32,22.7c4.44,2.56,8,9.43,8,15.35V246.41c0,3.14-1,5.38-2.63,6.41-.1.06-5.1,2.52-5.21,2.56C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.26-2.06,4.32-2.08a5.79,5.79,0,0,1,5.43.32l39.32,22.7c4.44,2.56,8,9.43,8,15.34V246.45c0,3.14-1,5.38-2.64,6.4-.09.07-5,2.49-5.11,2.53C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.16-2,4.22-2a5.78,5.78,0,0,1,5.43.31l39.33,22.7c4.43,2.57,8,9.44,8,15.35V246.48c0,3.14-1,5.39-2.63,6.41-.1.06-4.91,2.45-5,2.49C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4.06-2,4.13-2a5.79,5.79,0,0,1,5.43.32l39.32,22.7c4.44,2.56,8,9.43,8,15.35V246.52c0,3.14-1,5.38-2.63,6.41-.1.06-4.81,2.41-4.92,2.45C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M260,253l-39.32-22.71c-4.44-2.56-8-9.43-8-15.34V110.2c0-3-2.47-3.68-1-4.76.06,0,4-2,4-2a5.79,5.79,0,0,1,5.43.31l39.32,22.71c4.44,2.56,8,9.43,8,15.34V246.55c0,3.15-1,5.39-2.63,6.41-.09.06-4.71,2.38-4.82,2.42C259.6,255.86,261.94,254.09,260,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M256.24,254.74,216.92,232c-4.43-2.56-8-9.43-8-15.35V112c0-5.91,3.6-8.63,8-6.07l39.32,22.7c4.44,2.56,8,9.43,8,15.35V248.67C264.28,254.58,260.68,257.3,256.24,254.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M259.43,254.91a5.67,5.67,0,0,1-2.79-.86l-39.32-22.7c-4.21-2.43-7.63-9-7.63-14.66V112c0-3.79,1.58-6.24,4-6.24a5.62,5.62,0,0,1,2.79.86l39.33,22.7c4.21,2.43,7.63,9,7.63,14.66V248.67C263.48,252.46,261.89,254.91,259.43,254.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M211.55,218V113.71c0-4.34,2.64-6.34,5.89-4.46l38.28,22.1c3.26,1.88,5.9,6.92,5.9,11.26V246.93c0,4.34-2.64,6.34-5.9,4.46l-38.28-22.1C214.19,227.41,211.55,222.37,211.55,218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M217.89,110.41c-3.07-1.77-5.56-.36-5.56,3.16v105.5a12.24,12.24,0,0,0,5.56,9.58l37.39,21.59c3.07,1.77,5.55.35,5.55-3.17V141.58a12.23,12.23,0,0,0-5.55-9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M267.29,178.37h0c-1.13.65-2,0-2-1.55V168.3a4.87,4.87,0,0,1,2-3.9h0c1.13-.66,2,0,2,1.54v8.52A4.91,4.91,0,0,1,267.29,178.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M252.4,178.77a.85.85,0,0,0-1.16-.32l-2.32,1.33c-.94.54-2.31.37-3.76-.47l-.75-.43c.05-.72.08-1.47.08-2.25l-13.62-7.86c0,.78,0,1.55.07,2.33a12.67,12.67,0,0,1-4.18-4.47l-2.33-4a.85.85,0,1,0-1.47.85l2.33,4a14,14,0,0,0,4.91,5.15l.93.54c.08.72.18,1.42.3,2.12l-4-2.31a.86.86,0,0,0-1.16.31.85.85,0,0,0,.31,1.16l5.29,3.06c.14.57.28,1.13.44,1.68a4.79,4.79,0,0,0-2.48.12,4.18,4.18,0,0,0-2.53,2.52l-.9,2.23a.86.86,0,0,0,.47,1.11.91.91,0,0,0,.32.06.85.85,0,0,0,.79-.53l.9-2.24a2.53,2.53,0,0,1,1.5-1.55,3.7,3.7,0,0,1,2.55.24c1.23,3.45,2.9,6.11,4.75,7.18s3.45.37,4.67-1.56a14.48,14.48,0,0,1,4.1,6.67l.9,3.28a.85.85,0,0,0,1,.59.85.85,0,0,0,.6-1l-.9-3.28a16,16,0,0,0-5-7.79c.12-.31.24-.64.35-1l4.44,2.57a.8.8,0,0,0,.42.11.85.85,0,0,0,.43-1.58l-4.85-2.8q.18-.84.3-1.77l.08,0a6.77,6.77,0,0,0,3.36,1,4.21,4.21,0,0,0,2.09-.52l2.33-1.33A.85.85,0,0,0,252.4,178.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M231.22,159.4a6.85,6.85,0,0,1,3.14,4.44l.15.73c-1.58.27-2.63,1.71-2.63,4l11.6,6.7a12.6,12.6,0,0,0-2.82-7.33l.32-1.23a1.08,1.08,0,0,1,.62-.8,2,2,0,0,1,1.69.41.85.85,0,0,0,.93-1.42,3.56,3.56,0,0,0-3.23-.58,2.76,2.76,0,0,0-1.65,1.95l-.05.2a9,9,0,0,0-1.61-1.2,6.4,6.4,0,0,0-1.4-.61l-.25-1.21a8.48,8.48,0,0,0-4-5.61.85.85,0,0,0-1.14.37A.86.86,0,0,0,231.22,159.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M251.13,179.15a.85.85,0,0,0-1.16-.32l-2.33,1.33c-.94.54-2.31.37-3.75-.47l-.75-.43c.05-.72.08-1.47.08-2.25l-13.62-7.86c0,.78,0,1.55.07,2.33a12.78,12.78,0,0,1-4.19-4.47l-2.32-4a.85.85,0,1,0-1.47.85l2.32,4a14.15,14.15,0,0,0,4.91,5.16l.94.53c.08.72.18,1.42.3,2.12l-4-2.31a.85.85,0,0,0-.85,1.48l5.29,3c.13.57.28,1.14.43,1.68a4.75,4.75,0,0,0-2.47.12,4.18,4.18,0,0,0-2.53,2.52l-.9,2.24a.84.84,0,0,0,.47,1.1.86.86,0,0,0,1.11-.47l.9-2.24a2.49,2.49,0,0,1,1.5-1.54,3.64,3.64,0,0,1,2.55.23c1.22,3.45,2.9,6.11,4.75,7.18s3.44.37,4.66-1.56a14.32,14.32,0,0,1,4.1,6.67l.91,3.28a.84.84,0,0,0,.82.63.57.57,0,0,0,.22,0,.85.85,0,0,0,.6-1l-.91-3.28a15.86,15.86,0,0,0-4.95-7.79c.13-.31.24-.64.35-1l4.44,2.56a.87.87,0,0,0,1.17-.31.85.85,0,0,0-.32-1.16l-4.84-2.8q.18-.84.3-1.77l.08,0a6.84,6.84,0,0,0,3.36,1,4.22,4.22,0,0,0,2.09-.53l2.32-1.33A.85.85,0,0,0,251.13,179.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M230,159.78a6.85,6.85,0,0,1,3.14,4.44l.15.73c-1.58.27-2.63,1.71-2.63,4.05l11.59,6.69a12.56,12.56,0,0,0-2.82-7.33l.33-1.22a1.09,1.09,0,0,1,.61-.81,2.05,2.05,0,0,1,1.7.41.85.85,0,1,0,.92-1.42,3.54,3.54,0,0,0-3.22-.58,2.76,2.76,0,0,0-1.65,2l0,.19a9,9,0,0,0-1.61-1.2,6.41,6.41,0,0,0-1.41-.6l-.24-1.21a8.51,8.51,0,0,0-4-5.62.86.86,0,0,0-1.15.38A.85.85,0,0,0,230,159.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M240.35,202.25c-13-7.52-23.6-25.74-23.6-40.7,0-6,1.71-10.57,4.6-13.4-5.5,1.79-9,7.45-9,16.09,0,15,10.57,33.18,23.6,40.7,7.8,4.51,14.71,4.16,19-.05C250.92,206.19,245.85,205.43,240.35,202.25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-347",
    cx: 237.06,
    cy: 177.05,
    rx: 18.18,
    ry: 31.48,
    transform: "translate(-56.95 143.84) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-348",
    cx: 237.06,
    cy: 177.05,
    rx: 18.18,
    ry: 31.48,
    transform: "translate(-56.95 143.84) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M240.93,147.93c-6.41-3.7-12.22-4.12-16.48-1.82-.12.06-6.22,3.47-6.41,3.76,4.33-3.26,10.73-3.21,17.88.92,13,7.52,23.6,25.74,23.6,40.7,0,7.63-2.75,12.93-7.18,15.3a5.34,5.34,0,0,0,1.16-.51l4.41-2.66c4.09-2.51,6.62-7.68,6.62-15C264.53,173.68,254,155.45,240.93,147.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M235.92,150.79c-13-7.53-23.6-1.5-23.6,13.45s10.57,33.18,23.6,40.7,23.6,1.51,23.6-13.45S249,158.31,235.92,150.79Zm-.16,52.36c-12-7-21.79-23.77-21.79-37.58s9.76-19.37,21.79-12.42,21.78,23.77,21.78,37.58S247.79,210.1,235.76,203.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M237.06,150.22c-6.25-3.61-11.93-4.09-16.15-2,3.94-1.1,9.72-.51,15,2.55,13,7.52,23.6,25.74,23.6,40.7,0,7.79-3.77,13.37-8.36,15.66,5.76-1.61,9.49-7.34,9.49-16.23C260.65,176,250.09,157.75,237.06,150.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M233.94,169.29a73.08,73.08,0,0,1,12.52-10.06,39.5,39.5,0,0,0-9.4-7.8c-12.34-7.12-22.34-1.42-22.34,12.73,0,7.12,2.53,15,6.62,22A71.44,71.44,0,0,1,233.94,169.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-353",
    cx: 259.52,
    cy: 192.55,
    r: 8.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-354",
    cx: 244.7,
    cy: 155.06,
    r: 8.05,
    transform: "translate(-40.61 104.87) rotate(-22.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M29,235.69c6.82-3.94,37.87,19.41,31,23.35L24,272.44,0,258.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M28.43,236.83c6.59-3.8,36.4,18.49,29.81,22.3L24.05,271.94c-.2.11-23.37-13.68-23.18-13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M27.87,238c6.35-3.67,34.91,17.56,28.56,21.23L24.11,271.44c-.38.23-22.76-13.08-22.37-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M27.3,239.12c6.13-3.53,33.44,16.65,27.32,20.18L24.18,271c-.58.33-22.15-12.48-21.57-12.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M26.74,240.27c5.89-3.4,32,15.72,26.07,19.12L24.25,270.45c-.77.45-21.54-11.88-20.77-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M26.17,241.41c5.66-3.26,30.49,14.8,24.83,18.07L24.32,270c-1,.56-20.94-11.27-20-11.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M25.61,242.56c5.42-3.13,29,13.87,23.58,17l-24.81,9.89c-1.16.67-20.32-10.67-19.16-11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M25,243.7c5.19-3,27.53,13,22.34,15.95L24.45,269c-1.35.78-19.71-10.07-18.36-10.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M24.48,244.85c4.95-2.86,26.05,12,21.09,14.89l-21,8.72C23,269.35,5.41,259,7,258.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M23.91,246c4.73-2.72,24.58,11.11,19.85,13.84L24.58,268c-1.73,1-18.49-8.86-16.75-9.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M23.35,247.14c4.49-2.59,23.09,10.18,18.6,12.77l-17.3,7.55c-1.93,1.12-17.89-8.26-15.95-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M22.78,248.28C27,245.82,44.4,257.54,40.14,260l-15.42,7c-2.13,1.22-17.28-7.66-15.15-8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M22.22,249.43c4-2.33,20.14,8.34,16.12,10.66l-13.55,6.38c-2.32,1.34-16.67-7.06-14.35-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M21.65,250.57c3.79-2.19,18.67,7.42,14.88,9.61L24.85,266c-2.51,1.45-16.06-6.45-13.55-7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M21.09,251.72c3.56-2.06,17.19,6.49,13.63,8.54l-9.8,5.21c-2.7,1.56-15.45-5.85-12.75-7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M20.52,252.86c3.33-1.92,15.71,5.57,12.39,7.49L25,265c-2.9,1.68-14.84-5.25-11.95-6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M20,254c3.09-1.79,14.23,4.64,11.14,6.43l-6.05,4C22,266.26,10.82,259.83,13.91,258Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.91,175.84c-1.89-1.09-3.41-.22-3.41,1.94V204a7.52,7.52,0,0,0,3.41,5.89L48,214.62l8,4.69c1.89,1.09,4.17.1,4.17-2.07V191c0-2.16-2.28-4.68-4.17-5.76l-8-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M36.52,178.23v8.06s0,1.86,0,1.87l.06,2.66.3,12.47A7.46,7.46,0,0,0,40,208.74l.26.16L48,213.41l7.75,4.51a2.85,2.85,0,0,0,3.27-.17A2.27,2.27,0,0,0,59.8,216v-6.23s0-2.81,0-2.82l-.08-3.53L59.39,191c0-2-2.29-4.47-4.06-5.49L47.58,181l-7.74-4.51C38.07,175.44,36.52,176.2,36.52,178.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M36.55,178.67v7.76s0,1.77.05,1.78l.13,2.53.58,11.81a7.31,7.31,0,0,0,3,5.16l.25.16,7.47,4.33,7.46,4.33a2.82,2.82,0,0,0,3.14-.11,2.11,2.11,0,0,0,.74-1.65v-6s0-2.67-.07-2.7l-.16-3.33L58.62,191c0-1.9-2.31-4.27-4-5.22l-7.45-4.33-7.45-4.32C38.11,176.14,36.55,176.78,36.55,178.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M36.58,179.11v7.45c0,.05,0,1.69.08,1.71l.18,2.38.88,11.15c0,1.67,1.58,3.94,3,4.89l.23.15L48.14,211l7.16,4.16a2.86,2.86,0,0,0,3-.05,2,2,0,0,0,.72-1.56V207.8c0-.07,0-2.54-.1-2.57l-.24-3.15-.86-11.14c0-1.75-2.32-4.05-3.85-4.94l-7.15-4.14-7.15-4.15C38.16,176.83,36.58,177.36,36.58,179.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M36.61,179.56v7.14c0,.06,0,1.59.1,1.62l.25,2.24,1.17,10.49c0,1.54,1.64,3.74,3,4.62l.23.13,6.88,4,6.87,4a2.85,2.85,0,0,0,2.88,0,1.81,1.81,0,0,0,.72-1.46v-5.5a24.42,24.42,0,0,0-.15-2.45l-.32-3-1.14-10.47c0-1.62-2.32-3.85-3.74-4.66l-6.85-4-6.85-4C38.2,177.52,36.61,177.93,36.61,179.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M36.64,180v6.83a12.65,12.65,0,0,0,.12,1.54l.31,2.1,1.47,9.83c0,1.42,1.71,3.54,2.92,4.34a.92.92,0,0,0,.21.13l6.58,3.8,6.59,3.8a2.87,2.87,0,0,0,2.75.07,1.63,1.63,0,0,0,.7-1.37v-5.25a17.31,17.31,0,0,0-.18-2.32l-.4-2.78-1.42-9.8c0-1.49-2.34-3.64-3.64-4.39l-6.55-3.78L39.54,179C38.25,178.22,36.64,178.51,36.64,180Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M36.67,180.44V187a8.71,8.71,0,0,0,.15,1.47l.36,1.95L39,199.55c0,1.29,1.77,3.34,2.87,4.07l.2.12,6.29,3.62L54.6,211a2.91,2.91,0,0,0,2.62.13,1.47,1.47,0,0,0,.69-1.27v-5a13,13,0,0,0-.21-2.2L57.22,200l-1.71-9.14c0-1.35-2.35-3.43-3.53-4.11l-6.25-3.6-6.26-3.6C38.29,178.91,36.67,179.09,36.67,180.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M36.7,180.89v6.21a6.77,6.77,0,0,0,.17,1.38l.43,1.81,2.06,8.52c0,1.15,1.84,3.13,2.83,3.79l.18.11,6,3.45,6,3.44c.68.39,2,.61,2.49.18a1.18,1.18,0,0,0,.68-1.17v-4.76a10,10,0,0,0-.25-2.09l-.56-2.39-2-8.48c0-1.22-2.36-3.22-3.42-3.83l-6-3.42-6-3.42C38.34,179.6,36.7,179.67,36.7,180.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M36.73,181.33v5.9a5.36,5.36,0,0,0,.19,1.3l.49,1.68,2.36,7.85c0,1,1.9,2.93,2.78,3.52l.17.1L48.43,205l5.71,3.26c.6.35,1.94.63,2.36.24a1,1,0,0,0,.66-1.08v-4.51a8.13,8.13,0,0,0-.28-2l-.64-2.21L54,190.88c0-1.08-2.38-3-3.32-3.56L45,184.08l-5.65-3.24C38.38,180.3,36.73,180.25,36.73,181.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M36.76,181.77v5.59a4,4,0,0,0,.22,1.23l.55,1.53,2.65,7.19c0,.9,2,2.73,2.74,3.24a.86.86,0,0,0,.16.1l5.41,3.09,5.41,3.08c.53.31,1.87.64,2.23.3a.91.91,0,0,0,.65-1v-4.27a6.33,6.33,0,0,0-.31-1.84l-.73-2-2.56-7.15c0-.94-2.39-2.8-3.21-3.28l-5.36-3.06-5.36-3.05C38.43,181,36.76,180.83,36.76,181.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M36.79,182.22v5.28a3.22,3.22,0,0,0,.24,1.14l.61,1.39,3,6.53c0,.77,2,2.53,2.69,3l.15.09,5.12,2.91,5.12,2.9c.45.26,1.79.65,2.1.37a.81.81,0,0,0,.64-.9v-4a4.8,4.8,0,0,0-.36-1.72l-.8-1.83-2.85-6.48c0-.81-2.39-2.6-3.1-3L44.24,185l-5.06-2.88C38.47,181.69,36.79,181.41,36.79,182.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M36.82,182.66v5c0,.17.12,1,.26,1.06l.68,1.25L41,195.81c0,.65,2.1,2.33,2.64,2.7l.14.08,4.83,2.73,4.83,2.73c.38.21,1.7.66,2,.42.36,0,.63-.31.63-.8v-3.78c0-.25-.17-1.47-.39-1.59l-.88-1.65-3.13-5.81c0-.68-2.41-2.39-3-2.73l-4.76-2.7-4.76-2.69C38.52,182.38,36.82,182,36.82,182.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M36.85,183.1v4.66c0,.19.13.9.29,1l.73,1.1,3.54,5.22c0,.51,2.16,2.12,2.6,2.41l.12.08,4.54,2.55,4.54,2.55c.3.17,1.62.67,1.83.48.35,0,.62-.24.62-.7V198.9c0-.27-.2-1.33-.43-1.47l-1-1.46-3.42-5.15c0-.54-2.42-2.18-2.89-2.45l-4.46-2.51L39,183.34C38.56,183.07,36.85,182.56,36.85,183.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M36.88,183.55v4.35c0,.19.14.8.31.9l.8,1,3.83,4.56c0,.38,2.22,1.92,2.55,2.14l.11.07,4.25,2.37L53,201.27c.23.13,1.55.68,1.71.54.34.07.6-.17.6-.61v-3.28c0-.3-.21-1.21-.46-1.36l-1-1.26-3.7-4.49c0-.41-2.43-2-2.78-2.18l-4.17-2.33L39,184C38.61,183.77,36.88,183.14,36.88,183.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M36.91,184v4a1.29,1.29,0,0,0,.33.82l.86.83,4.13,3.89a14.9,14.9,0,0,0,2.51,1.87l.1.05,3.95,2.2,4,2.19a5.91,5.91,0,0,0,1.57.6c.33.11.59-.1.59-.51v-3a1.94,1.94,0,0,0-.49-1.23l-1.13-1.08-4-3.82a14.59,14.59,0,0,0-2.68-1.9l-3.87-2.15-3.86-2.15C38.65,184.46,36.91,183.72,36.91,184Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M36.94,184.43v3.73a1.05,1.05,0,0,0,.36.75l.92.68,4.42,3.23a28.18,28.18,0,0,0,2.46,1.6l.09,0,3.66,2,3.66,2a11.28,11.28,0,0,0,1.44.65c.32.15.58,0,.58-.42v-2.79a1.57,1.57,0,0,0-.53-1.11l-1.21-.89-4.27-3.16A26.82,26.82,0,0,0,46,189.16l-3.57-2-3.56-2A10,10,0,0,0,36.94,184.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M37,184.88v3.42a.84.84,0,0,0,.38.66l8.12,4.43,8.11,4.43c.32.19.57,0,.57-.32V195a1.27,1.27,0,0,0-.57-1l-8.3-4.54Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-387",
    points: "36.01 178.47 4.7 259.62 8.98 258.08 40.29 176.93 36.01 178.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "36.02 178.47 4.71 259.62 1.7 257.92 33.01 176.78 36.02 178.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-388",
    points: "33.01 176.78 36.02 178.47 40.29 176.93 37.27 175.23 33.01 176.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-389",
    points: "51.63 195.21 50.39 198.44 54.67 196.9 55.92 193.66 51.63 195.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "51.64 195.21 50.4 198.44 32.24 188.21 33.48 184.99 51.64 195.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-390",
    points: "33.48 184.99 51.64 195.21 55.92 193.66 37.74 183.43 33.48 184.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-391",
    points: "46.62 208.19 45.38 211.42 49.66 209.88 50.91 206.65 46.62 208.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "46.63 208.19 45.39 211.42 27.23 201.19 28.47 197.97 46.63 208.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-392",
    points: "28.47 197.97 46.63 208.19 50.91 206.65 32.73 196.42 28.47 197.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-393",
    points: "41.59 221.23 40.35 224.46 44.63 222.92 45.88 219.69 41.59 221.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "41.6 221.23 40.36 224.46 22.2 214.23 23.44 211.01 41.6 221.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-394",
    points: "23.44 211.01 41.6 221.23 45.88 219.69 27.7 209.46 23.44 211.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-395",
    points: "36.58 234.22 35.34 237.45 39.62 235.9 40.87 232.67 36.58 234.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "36.59 234.22 35.35 237.45 17.19 227.22 18.43 223.99 36.59 234.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-396",
    points: "18.43 223.99 36.59 234.22 40.87 232.67 22.69 222.44 18.43 223.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-397",
    points: "31.59 247.15 30.35 250.38 34.63 248.84 35.88 245.61 31.59 247.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.6 247.15 30.36 250.38 12.2 240.15 13.44 236.93 31.6 247.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-398",
    points: "13.44 236.93 31.6 247.15 35.88 245.61 17.7 235.38 13.44 236.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-399",
    points: "26.58 260.14 25.34 263.37 29.62 261.82 30.87 258.59 26.58 260.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "26.59 260.14 25.34 263.37 7.19 253.13 8.43 249.91 26.59 260.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-400",
    points: "8.43 249.91 26.59 260.14 30.87 258.59 12.69 248.36 8.43 249.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M49.75,144.8s2.37-2,3.72-2.14,4,.31,4.38.82-.57,1.37-1.49,1.82-1.31.72-2.07,1a24.27,24.27,0,0,0-3,.83C50.64,147.42,49.75,144.8,49.75,144.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M56.64,143.37c.24.13.32.6-.21.87s-1.21.35-1.67.54a8.19,8.19,0,0,1-2.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M52.39,142.76a7.55,7.55,0,0,1,2-.62c.52-.11.76-.47,1-.37s.53.59-.54,1.12a9.88,9.88,0,0,0-2.22,1.26c-.53.46-1.59,1.28-2,1.14s-.38-.83-.38-.83S52.17,143,52.39,142.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "M50.81,143.66a1.56,1.56,0,0,1,1,1.13,8.15,8.15,0,0,1-.1,2.53L40.2,151.53s-4.08,2-5-1.48,1.47-3.58,6.67-4.63C47.36,144.3,50.81,143.66,50.81,143.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M51.88,146.13c-.08.77-.15,1.19-.15,1.19L40.2,151.53s-4.05,2-5-1.47c2.17-.26,3.6.64,8.25-.85C47.71,147.84,51,146.44,51.88,146.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M23.94,211.15a3.39,3.39,0,0,0-.22,1.59,1.73,1.73,0,0,0,2.05.65c.87-.33,1.31-1.15,1.65-1.34s2.13-.23,3.56-1.23,1.38-2.26.05-2.4a11.09,11.09,0,0,0-4.7.71A14,14,0,0,0,23.94,211.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M24.45,212.42c.94.29,2.22-.42,2.83-.84s1.57-.08,2.95-1,1.9-1.55,1.34-1.94-2.69-.5-4.44.25-2.92,1.28-2.92,1.28-.52,1.2-.35,1.49S23.92,212.26,24.45,212.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M29.72,167a6,6,0,0,0-2.49,5c0,1-.24,19.17-.24,19.17S23.44,211,24,211.38a2.08,2.08,0,0,0,1.88.34,6.73,6.73,0,0,0,2.44-1.23c.48-.39,3.43-10.43,5.27-18.51,2.46-10.81,4.3-21.25,4.3-21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M34.89,217.75s-.67,1.39,0,1.76a3.34,3.34,0,0,0,2.49.4,4.7,4.7,0,0,1,2.1-.48,12.79,12.79,0,0,0,5.15-1.81c.73-.69.16-1.62-1.48-1.66s-4-.09-4.42,0S34.89,217.75,34.89,217.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M35.52,218.88c1.51.31,2,0,3.47-.16s5.59-1.23,5.59-2.06-.93-.74-1.71-.75-3.28-.09-3.48-.1S35,217.07,35,217.07s-.41,1.17-.16,1.37S35.11,218.8,35.52,218.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "M34.54,164.92A11.06,11.06,0,0,0,33,172.84c.77,4.84,4.17,23.45,4.17,23.45s-2.05,19-2.27,21.26c-.06.68,1.37,1.14,3,.78,2-.45,2-1,2.19-1.87s3.85-17.33,4.08-21.71c.3-5.78.86-23.32.86-23.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M40.07,216.46c.17-.78,3.85-17.33,4.08-21.71.3-5.78.86-23.32.86-23.32l-4.86-3-.14,7s.09.89.21,2.3c.47,5.17,1.54,17.33,1.4,18.84s-2.39,14.85-3.53,21.64C39.85,217.83,39.89,217.31,40.07,216.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M34.1,140.63c-1.93.24-3.87.68-4.49,5.23-.5,3.73-2.57,26.49-2.57,26.49s3.2,3.27,12.09,3.48c6.07.14,6.28-1.37,6.28-1.37s1-13.28,1.66-21.52c.31-3.84-.14-4.87-1.35-6a57.1,57.1,0,0,0-5.61-4.34C38.52,141.57,35.76,140.43,34.1,140.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M45.41,174.46s1-13.26,1.66-21.5c0-.13,0-.27,0-.4l-4.89-.69c.48,8.19-1.63,22.13-1.63,22.13s-.21,1.49-6.14,1.37h0a30.93,30.93,0,0,0,4.73.46C45.2,176,45.41,174.46,45.41,174.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M42.08,144.67c-.28.94-2,1.24-3.88.68s-3.14-1.78-2.86-2.72,2-1.24,3.89-.68S42.37,143.73,42.08,144.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M33.89,178.61c-.7,3.39-2.81,13.73-3,14.82S28.2,205.85,27,211.29a6.29,6.29,0,0,0,1.31-.8c.47-.39,3.42-10.43,5.26-18.51.58-2.53,1-4.78,1.54-7.22C34.68,182.68,34.27,180.55,33.89,178.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M56.46,149a.57.57,0,0,0-.26-.43.35.35,0,0,0-.14,0,1.35,1.35,0,0,1-.9-.2,3.56,3.56,0,0,1-1.36-1.6,2.54,2.54,0,0,1-.2-1.75l-5.26,10.47,4.14.58,1.57,5.66,5-9.85a1.26,1.26,0,0,1-.9-.19A3.63,3.63,0,0,1,56.46,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M65.43,150.45a2.08,2.08,0,0,1-.25,1.88,1.32,1.32,0,0,1-1.68,0,3.91,3.91,0,0,1-1.12-1,.53.53,0,0,0-.18-.16c-.11-.07-.3-.09-.32.15-.09,1.16-1,1.57-2,1a3.79,3.79,0,0,1-1.11-1.05l4.67,15,2-4.76,5.13,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M65.23,156.18c.1-1.25,1.39-1.22,2.34.06,1.23,1.64,2.78,1.12,2.26-.76-.41-1.47.48-2.24,1.62-1.4,1.45,1.07,2.31-.48,1.25-2.25-.84-1.39-.52-2.81.58-2.58,1.39.29,1.39-2,0-3.3-1.1-1-1.42-2.82-.58-3.25,1.06-.54.2-3.09-1.25-3.7a3,3,0,0,1-1.62-3.27c.52-1.27-1-3.58-2.26-3.36-.95.18-2.24-1.27-2.34-2.64-.13-1.76-2.06-3.38-2.81-2.36-.58.79-2,0-2.6-1.5-.75-1.89-2.68-2.49-2.81-.89-.09,1.26-1.38,1.23-2.34-.06-1.22-1.64-2.77-1.11-2.25.76.41,1.47-.48,2.24-1.62,1.4-1.46-1.07-2.32.48-1.25,2.26.83,1.39.51,2.8-.58,2.57-1.4-.29-1.4,2,0,3.31,1.09,1,1.41,2.81.58,3.24-1.07.55-.21,3.09,1.25,3.7a3,3,0,0,1,1.62,3.27c-.52,1.28,1,3.59,2.25,3.36,1-.18,2.25,1.28,2.34,2.65.13,1.75,2.06,3.37,2.81,2.35.59-.79,2,0,2.6,1.51C63.17,157.18,65.1,157.79,65.23,156.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M64.77,156.44c.1-1.26,1.39-1.23,2.34.06,1.23,1.64,2.77,1.11,2.25-.76-.4-1.47.49-2.24,1.63-1.4,1.45,1.07,2.31-.48,1.25-2.26-.84-1.39-.52-2.8.57-2.57,1.4.29,1.4-2,0-3.31-1.09-1-1.41-2.81-.57-3.24,1.06-.55.2-3.09-1.25-3.7A3.06,3.06,0,0,1,69.36,136c.52-1.28-1-3.59-2.25-3.36-1,.18-2.24-1.28-2.34-2.65-.13-1.75-2.06-3.37-2.81-2.35-.58.79-2,0-2.6-1.51-.75-1.88-2.68-2.49-2.81-.88-.1,1.25-1.38,1.22-2.34-.06-1.22-1.64-2.77-1.12-2.25.76.41,1.47-.49,2.24-1.62,1.4-1.46-1.07-2.32.48-1.25,2.25.83,1.39.51,2.81-.58,2.58-1.4-.29-1.4,2,0,3.3,1.09,1,1.41,2.82.58,3.25-1.07.54-.21,3.09,1.25,3.7A3,3,0,0,1,52,145.69c-.52,1.27,1,3.58,2.25,3.36,1-.18,2.24,1.27,2.34,2.64.13,1.76,2.06,3.38,2.81,2.36.59-.79,2,0,2.6,1.5C62.71,157.44,64.64,158,64.77,156.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M60.66,150.72c-4.75-2.75-8.61-9.4-8.61-14.85s3.86-7.66,8.61-4.91,8.61,9.39,8.61,14.85S65.42,153.46,60.66,150.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-409",
    points: "54.59 137.74 58.69 147.24 67 138.52 63.76 135.78 59.29 143.3 57.19 138.24 54.59 137.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M63.93,155.77A23.4,23.4,0,0,0,66,154.13c.53-.5,1.11-.95,1.34-.66.46.56-1.8,2.6-1.8,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M62.92,158.86a28.78,28.78,0,0,0,3.87.34,3.43,3.43,0,0,0,2.35-.92c.51-.38.85-.72.71-1-.06-.15-.33.13-.33.13s.58-.49.46-.89-.44,0-.44,0,.64-.54.49-.94-.48.07-.48.07.54-.48.47-.82-.27-.29-.69,0a6.26,6.26,0,0,1-2.69.93c-1.11,0-1.86-.54-2.62,0a3.31,3.31,0,0,1-1.92.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M43,147.19a3.69,3.69,0,0,0-1.75,5.32c1.1,2.05,7.35,7.55,9.77,8.34s12.88-1.15,12.88-1.15a11.09,11.09,0,0,0,.31-2.52,1.56,1.56,0,0,0-.65-1.36s-7.17.41-9.29-.35-4.22-3.77-6.09-5.7C46.15,147.66,45.09,146.36,43,147.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M35.94,142.35a.7.7,0,0,0,0,.66,4,4,0,0,0,2.5,1.85,4.91,4.91,0,0,0,2.76.09.81.81,0,0,0,.5-.46l.83-1.91s1.53.5,2.15,0,4.15-7.43,2.44-9.86-6.68-3.21-8.34-.06-.64,5.37-.72,6.19A13.8,13.8,0,0,1,35.94,142.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-411",
    d: "M37.86,139.46a6.71,6.71,0,0,0,2.41,1c1.43,0,2.2-3.11,3.27-3.58.65-.28,1,.33.78.87s-.14.78,0,.87a15,15,0,0,0,1.73-2.33s4-.52,3.81-2.46c-.28-3.37-9.54-6.65-11.39-2S37.11,139,37.86,139.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-412",
    points: "57.18 190.41 25.88 271.54 30.16 270 61.47 188.87 57.18 190.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "57.19 190.41 25.89 271.55 22.88 269.84 54.18 188.72 57.19 190.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-413",
    points: "54.18 188.72 57.19 190.41 61.47 188.87 58.44 187.16 54.18 188.72"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionImage);
export default __webpack_public_path__ + "static/media/introduction-image.f1ce6e2d5d631e9f5ad6bfcc5980de71.svg";
export { ForwardRef as ReactComponent };